var ro = Object.defineProperty;
var ai = (t) => {
  throw TypeError(t);
};
var ao = (t, e, r) => e in t ? ro(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var ii = (t, e, r) => ao(t, typeof e != "symbol" ? e + "" : e, r), ua = (t, e, r) => e.has(t) || ai("Cannot " + r);
var dn = (t, e, r) => (ua(t, e, "read from private field"), r ? r.call(t) : e.get(t)), lr = (t, e, r) => e.has(t) ? ai("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), ca = (t, e, r, a) => (ua(t, e, "write to private field"), a ? a.call(t, r) : e.set(t, r), r), si = (t, e, r) => (ua(t, e, "access private method"), r);
const io = "5";
var Oi;
typeof window < "u" && ((Oi = window.__svelte ?? (window.__svelte = {})).v ?? (Oi.v = /* @__PURE__ */ new Set())).add(io);
let Qn = !1, so = !1;
function oo() {
  Qn = !0;
}
oo();
const Da = 1, Ra = 2, Li = 4, lo = 8, uo = 16, co = 1, vo = 2, fo = 4, go = 8, po = 16, ho = 1, mo = 2, yo = 4, Mi = 1, _o = 2, Pa = "[", Ua = "[!", Ba = "]", An = {}, St = Symbol(), So = "http://www.w3.org/1999/xhtml", oi = !1;
var Sr = Array.isArray, bo = Array.prototype.indexOf, Va = Array.from, Ai = Object.defineProperty, pn = Object.getOwnPropertyDescriptor, Di = Object.getOwnPropertyDescriptors, Io = Object.prototype, wo = Array.prototype, Fa = Object.getPrototypeOf, li = Object.isExtensible;
function Wn(t) {
  return typeof t == "function";
}
const pt = () => {
};
function Co(t) {
  return t();
}
function dr(t) {
  for (var e = 0; e < t.length; e++)
    t[e]();
}
const en = 2, Ri = 4, Yr = 8, Zr = 16, bn = 32, $n = 64, Lr = 128, Pt = 256, Mr = 512, yt = 1024, tn = 2048, In = 4096, hn = 8192, Jr = 16384, Pi = 32768, er = 65536, No = 1 << 17, To = 1 << 19, Ui = 1 << 20, ba = 1 << 21, kn = Symbol("$state"), Bi = Symbol("legacy props"), Eo = Symbol("");
function Vi(t) {
  return t === this.v;
}
function Kr(t, e) {
  return t != t ? e == e : t !== e || t !== null && typeof t == "object" || typeof t == "function";
}
function xo(t, e) {
  return t !== e;
}
function Ha(t) {
  return !Kr(t, this.v);
}
function ko(t) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function Oo() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Lo(t) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Mo() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Ao() {
  throw new Error("https://svelte.dev/e/hydration_failed");
}
function Do(t) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function Ro() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function Po() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function Uo() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
function Xr(t) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
let Ke = null;
function ui(t) {
  Ke = t;
}
function Lt(t) {
  return (
    /** @type {T} */
    Fi().get(t)
  );
}
function Mt(t, e) {
  return Fi().set(t, e), e;
}
function oe(t, e = !1, r) {
  var a = Ke = {
    p: Ke,
    c: null,
    d: !1,
    e: null,
    m: !1,
    s: t,
    x: null,
    l: null
  };
  Qn && !e && (Ke.l = {
    s: null,
    u: null,
    r1: [],
    r2: gr(!1)
  }), Ir(() => {
    a.d = !0;
  });
}
function le(t) {
  const e = Ke;
  if (e !== null) {
    t !== void 0 && (e.x = t);
    const o = e.e;
    if (o !== null) {
      var r = Xe, a = $e;
      e.e = null;
      try {
        for (var i = 0; i < o.length; i++) {
          var s = o[i];
          sn(s.effect), Yt(s.reaction), lt(s.fn);
        }
      } finally {
        sn(r), Yt(a);
      }
    }
    Ke = e.p, e.m = !0;
  }
  return t || /** @type {T} */
  {};
}
function tr() {
  return !Qn || Ke !== null && Ke.l === null;
}
function Fi(t) {
  return Ke === null && Xr(), Ke.c ?? (Ke.c = new Map(Bo(Ke) || void 0));
}
function Bo(t) {
  let e = t.p;
  for (; e !== null; ) {
    const r = e.c;
    if (r !== null)
      return r;
    e = e.p;
  }
  return null;
}
function Tn(t) {
  if (typeof t != "object" || t === null || kn in t)
    return t;
  const e = Fa(t);
  if (e !== Io && e !== wo)
    return t;
  var r = /* @__PURE__ */ new Map(), a = Sr(t), i = /* @__PURE__ */ Ue(0), s = $e, o = (l) => {
    var u = $e;
    Yt(s);
    var d = l();
    return Yt(u), d;
  };
  return a && r.set("length", /* @__PURE__ */ Ue(
    /** @type {any[]} */
    t.length
  )), new Proxy(
    /** @type {any} */
    t,
    {
      defineProperty(l, u, d) {
        (!("value" in d) || d.configurable === !1 || d.enumerable === !1 || d.writable === !1) && Ro();
        var f = r.get(u);
        return f === void 0 ? (f = o(() => /* @__PURE__ */ Ue(d.value)), r.set(u, f)) : O(
          f,
          o(() => Tn(d.value))
        ), !0;
      },
      deleteProperty(l, u) {
        var d = r.get(u);
        if (d === void 0)
          u in l && (r.set(
            u,
            o(() => /* @__PURE__ */ Ue(St))
          ), va(i));
        else {
          if (a && typeof u == "string") {
            var f = (
              /** @type {Source<number>} */
              r.get("length")
            ), c = Number(u);
            Number.isInteger(c) && c < f.v && O(f, c);
          }
          O(d, St), va(i);
        }
        return !0;
      },
      get(l, u, d) {
        var p;
        if (u === kn)
          return t;
        var f = r.get(u), c = u in l;
        if (f === void 0 && (!c || (p = pn(l, u)) != null && p.writable) && (f = o(() => /* @__PURE__ */ Ue(Tn(c ? l[u] : St))), r.set(u, f)), f !== void 0) {
          var v = n(f);
          return v === St ? void 0 : v;
        }
        return Reflect.get(l, u, d);
      },
      getOwnPropertyDescriptor(l, u) {
        var d = Reflect.getOwnPropertyDescriptor(l, u);
        if (d && "value" in d) {
          var f = r.get(u);
          f && (d.value = n(f));
        } else if (d === void 0) {
          var c = r.get(u), v = c == null ? void 0 : c.v;
          if (c !== void 0 && v !== St)
            return {
              enumerable: !0,
              configurable: !0,
              value: v,
              writable: !0
            };
        }
        return d;
      },
      has(l, u) {
        var v;
        if (u === kn)
          return !0;
        var d = r.get(u), f = d !== void 0 && d.v !== St || Reflect.has(l, u);
        if (d !== void 0 || Xe !== null && (!f || (v = pn(l, u)) != null && v.writable)) {
          d === void 0 && (d = o(() => /* @__PURE__ */ Ue(f ? Tn(l[u]) : St)), r.set(u, d));
          var c = n(d);
          if (c === St)
            return !1;
        }
        return f;
      },
      set(l, u, d, f) {
        var C;
        var c = r.get(u), v = u in l;
        if (a && u === "length")
          for (var p = d; p < /** @type {Source<number>} */
          c.v; p += 1) {
            var h = r.get(p + "");
            h !== void 0 ? O(h, St) : p in l && (h = o(() => /* @__PURE__ */ Ue(St)), r.set(p + "", h));
          }
        c === void 0 ? (!v || (C = pn(l, u)) != null && C.writable) && (c = o(() => /* @__PURE__ */ Ue(void 0)), O(
          c,
          o(() => Tn(d))
        ), r.set(u, c)) : (v = c.v !== St, O(
          c,
          o(() => Tn(d))
        ));
        var m = Reflect.getOwnPropertyDescriptor(l, u);
        if (m != null && m.set && m.set.call(f, d), !v) {
          if (a && typeof u == "string") {
            var y = (
              /** @type {Source<number>} */
              r.get("length")
            ), I = Number(u);
            Number.isInteger(I) && I >= y.v && O(y, I + 1);
          }
          va(i);
        }
        return !0;
      },
      ownKeys(l) {
        n(i);
        var u = Reflect.ownKeys(l).filter((c) => {
          var v = r.get(c);
          return v === void 0 || v.v !== St;
        });
        for (var [d, f] of r)
          f.v !== St && !(d in l) && u.push(d);
        return u;
      },
      setPrototypeOf() {
        Po();
      }
    }
  );
}
function va(t, e = 1) {
  O(t, t.v + e);
}
// @__NO_SIDE_EFFECTS__
function Gn(t) {
  var e = en | tn, r = $e !== null && $e.f & en ? (
    /** @type {Derived} */
    $e
  ) : null;
  return Xe === null || r !== null && r.f & Pt ? e |= Pt : Xe.f |= Ui, {
    ctx: Ke,
    deps: null,
    effects: null,
    equals: Vi,
    f: e,
    fn: t,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      null
    ),
    wv: 0,
    parent: r ?? Xe
  };
}
// @__NO_SIDE_EFFECTS__
function Z(t) {
  const e = /* @__PURE__ */ Gn(t);
  return is(e), e;
}
// @__NO_SIDE_EFFECTS__
function de(t) {
  const e = /* @__PURE__ */ Gn(t);
  return e.equals = Ha, e;
}
function Hi(t) {
  var e = t.effects;
  if (e !== null) {
    t.effects = null;
    for (var r = 0; r < e.length; r += 1)
      Sn(
        /** @type {Effect} */
        e[r]
      );
  }
}
function Vo(t) {
  for (var e = t.parent; e !== null; ) {
    if (!(e.f & en))
      return (
        /** @type {Effect} */
        e
      );
    e = e.parent;
  }
  return null;
}
function zi(t) {
  var e, r = Xe;
  sn(Vo(t));
  try {
    Hi(t), e = us(t);
  } finally {
    sn(r);
  }
  return e;
}
function qi(t) {
  var e = zi(t);
  if (t.equals(e) || (t.v = e, t.wv = os()), !ir) {
    var r = (xn || t.f & Pt) && t.deps !== null ? In : yt;
    Zt(t, r);
  }
}
const fr = /* @__PURE__ */ new Map();
function gr(t, e) {
  var r = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: t,
    reactions: null,
    equals: Vi,
    rv: 0,
    wv: 0
  };
  return r;
}
// @__NO_SIDE_EFFECTS__
function Ue(t, e) {
  const r = gr(t);
  return is(r), r;
}
// @__NO_SIDE_EFFECTS__
function Y(t, e = !1) {
  var a;
  const r = gr(t);
  return e || (r.equals = Ha), Qn && Ke !== null && Ke.l !== null && ((a = Ke.l).s ?? (a.s = [])).push(r), r;
}
function za(t, e) {
  return O(
    t,
    Vt(() => n(t))
  ), e;
}
function O(t, e, r = !1) {
  $e !== null && !rn && tr() && $e.f & (en | Zr) && !(It != null && It.includes(t)) && Uo();
  let a = r ? Tn(e) : e;
  return Ia(t, a);
}
function Ia(t, e) {
  if (!t.equals(e)) {
    var r = t.v;
    ir ? fr.set(t, e) : fr.set(t, r), t.v = e, t.f & en && (t.f & tn && zi(
      /** @type {Derived} */
      t
    ), Zt(t, t.f & Pt ? In : yt)), t.wv = os(), Wi(t, tn), tr() && Xe !== null && Xe.f & yt && !(Xe.f & (bn | $n)) && (Wt === null ? Yo([t]) : Wt.push(t));
  }
  return e;
}
function Wi(t, e) {
  var r = t.reactions;
  if (r !== null)
    for (var a = tr(), i = r.length, s = 0; s < i; s++) {
      var o = r[s], l = o.f;
      l & tn || !a && o === Xe || (Zt(o, e), l & (yt | Pt) && (l & en ? Wi(
        /** @type {Derived} */
        o,
        In
      ) : ta(
        /** @type {Effect} */
        o
      )));
    }
}
function br(t) {
  console.warn("https://svelte.dev/e/hydration_mismatch");
}
let Be = !1;
function gn(t) {
  Be = t;
}
let Ge;
function Ut(t) {
  if (t === null)
    throw br(), An;
  return Ge = t;
}
function _n() {
  return Ut(
    /** @type {TemplateNode} */
    /* @__PURE__ */ on(Ge)
  );
}
function _(t) {
  if (Be) {
    if (/* @__PURE__ */ on(Ge) !== null)
      throw br(), An;
    Ge = t;
  }
}
function wn(t = 1) {
  if (Be) {
    for (var e = t, r = Ge; e--; )
      r = /** @type {TemplateNode} */
      /* @__PURE__ */ on(r);
    Ge = r;
  }
}
function wa() {
  for (var t = 0, e = Ge; ; ) {
    if (e.nodeType === 8) {
      var r = (
        /** @type {Comment} */
        e.data
      );
      if (r === Ba) {
        if (t === 0) return e;
        t -= 1;
      } else (r === Pa || r === Ua) && (t += 1);
    }
    var a = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ on(e)
    );
    e.remove(), e = a;
  }
}
function ji(t) {
  if (!t || t.nodeType !== 8)
    throw br(), An;
  return (
    /** @type {Comment} */
    t.data
  );
}
var ci, Gi, Yi, Zi;
function Ca() {
  if (ci === void 0) {
    ci = window, Gi = /Firefox/.test(navigator.userAgent);
    var t = Element.prototype, e = Node.prototype, r = Text.prototype;
    Yi = pn(e, "firstChild").get, Zi = pn(e, "nextSibling").get, li(t) && (t.__click = void 0, t.__className = void 0, t.__attributes = null, t.__style = void 0, t.__e = void 0), li(r) && (r.__t = void 0);
  }
}
function On(t = "") {
  return document.createTextNode(t);
}
// @__NO_SIDE_EFFECTS__
function ht(t) {
  return Yi.call(t);
}
// @__NO_SIDE_EFFECTS__
function on(t) {
  return Zi.call(t);
}
function S(t, e) {
  if (!Be)
    return /* @__PURE__ */ ht(t);
  var r = (
    /** @type {TemplateNode} */
    /* @__PURE__ */ ht(Ge)
  );
  if (r === null)
    r = Ge.appendChild(On());
  else if (e && r.nodeType !== 3) {
    var a = On();
    return r == null || r.before(a), Ut(a), a;
  }
  return Ut(r), r;
}
function ye(t, e) {
  if (!Be) {
    var r = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ ht(
        /** @type {Node} */
        t
      )
    );
    return r instanceof Comment && r.data === "" ? /* @__PURE__ */ on(r) : r;
  }
  return Ge;
}
function H(t, e = 1, r = !1) {
  let a = Be ? Ge : t;
  for (var i; e--; )
    i = a, a = /** @type {TemplateNode} */
    /* @__PURE__ */ on(a);
  if (!Be)
    return a;
  var s = a == null ? void 0 : a.nodeType;
  if (r && s !== 3) {
    var o = On();
    return a === null ? i == null || i.after(o) : a.before(o), Ut(o), o;
  }
  return Ut(a), /** @type {TemplateNode} */
  a;
}
function Ji(t) {
  t.textContent = "";
}
function Ki(t) {
  Xe === null && $e === null && Lo(), $e !== null && $e.f & Pt && Xe === null && Oo(), ir && ko();
}
function Fo(t, e) {
  var r = e.last;
  r === null ? e.last = e.first = t : (r.next = t, t.prev = r, e.last = t);
}
function nr(t, e, r, a = !0) {
  var i = Xe, s = {
    ctx: Ke,
    deps: null,
    nodes_start: null,
    nodes_end: null,
    f: t | tn,
    first: null,
    fn: e,
    last: null,
    next: null,
    parent: i,
    prev: null,
    teardown: null,
    transitions: null,
    wv: 0
  };
  if (r)
    try {
      ea(s), s.f |= Pi;
    } catch (u) {
      throw Sn(s), u;
    }
  else e !== null && ta(s);
  var o = r && s.deps === null && s.first === null && s.nodes_start === null && s.teardown === null && (s.f & (Ui | Lr)) === 0;
  if (!o && a && (i !== null && Fo(s, i), $e !== null && $e.f & en)) {
    var l = (
      /** @type {Derived} */
      $e
    );
    (l.effects ?? (l.effects = [])).push(s);
  }
  return s;
}
function Ir(t) {
  const e = nr(Yr, null, !1);
  return Zt(e, yt), e.teardown = t, e;
}
function ut(t) {
  Ki();
  var e = Xe !== null && (Xe.f & bn) !== 0 && Ke !== null && !Ke.m;
  if (e) {
    var r = (
      /** @type {ComponentContext} */
      Ke
    );
    (r.e ?? (r.e = [])).push({
      fn: t,
      effect: Xe,
      reaction: $e
    });
  } else {
    var a = lt(t);
    return a;
  }
}
function Ho(t) {
  return Ki(), rr(t);
}
function zo(t) {
  const e = nr($n, t, !0);
  return (r = {}) => new Promise((a) => {
    r.outro ? Yn(e, () => {
      Sn(e), a(void 0);
    }) : (Sn(e), a(void 0));
  });
}
function lt(t) {
  return nr(Ri, t, !1);
}
function ae(t, e) {
  var r = (
    /** @type {ComponentContextLegacy} */
    Ke
  ), a = { effect: null, ran: !1 };
  r.l.r1.push(a), a.effect = rr(() => {
    t(), !a.ran && (a.ran = !0, O(r.l.r2, !0), Vt(e));
  });
}
function et() {
  var t = (
    /** @type {ComponentContextLegacy} */
    Ke
  );
  rr(() => {
    if (n(t.l.r2)) {
      for (var e of t.l.r1) {
        var r = e.effect;
        r.f & yt && Zt(r, In), sr(r) && ea(r), e.ran = !1;
      }
      t.l.r2.v = !1;
    }
  });
}
function rr(t) {
  return nr(Yr, t, !0);
}
function L(t, e = [], r = Gn) {
  const a = e.map(r);
  return ar(() => t(...a.map(n)));
}
function ar(t, e = 0) {
  return nr(Yr | Zr | e, t, !0);
}
function Ln(t, e = !0) {
  return nr(Yr | bn, t, !0, e);
}
function Xi(t) {
  var e = t.teardown;
  if (e !== null) {
    const r = ir, a = $e;
    vi(!0), Yt(null);
    try {
      e.call(null);
    } finally {
      vi(r), Yt(a);
    }
  }
}
function Qi(t, e = !1) {
  var r = t.first;
  for (t.first = t.last = null; r !== null; ) {
    var a = r.next;
    r.f & $n ? r.parent = null : Sn(r, e), r = a;
  }
}
function qo(t) {
  for (var e = t.first; e !== null; ) {
    var r = e.next;
    e.f & bn || Sn(e), e = r;
  }
}
function Sn(t, e = !0) {
  var r = !1;
  (e || t.f & To) && t.nodes_start !== null && ($i(
    t.nodes_start,
    /** @type {TemplateNode} */
    t.nodes_end
  ), r = !0), Qi(t, e && !r), Ur(t, 0), Zt(t, Jr);
  var a = t.transitions;
  if (a !== null)
    for (const s of a)
      s.stop();
  Xi(t);
  var i = t.parent;
  i !== null && i.first !== null && es(t), t.next = t.prev = t.teardown = t.ctx = t.deps = t.fn = t.nodes_start = t.nodes_end = null;
}
function $i(t, e) {
  for (; t !== null; ) {
    var r = t === e ? null : (
      /** @type {TemplateNode} */
      /* @__PURE__ */ on(t)
    );
    t.remove(), t = r;
  }
}
function es(t) {
  var e = t.parent, r = t.prev, a = t.next;
  r !== null && (r.next = a), a !== null && (a.prev = r), e !== null && (e.first === t && (e.first = a), e.last === t && (e.last = r));
}
function Yn(t, e) {
  var r = [];
  qa(t, r, !0), ts(r, () => {
    Sn(t), e && e();
  });
}
function ts(t, e) {
  var r = t.length;
  if (r > 0) {
    var a = () => --r || e();
    for (var i of t)
      i.out(a);
  } else
    e();
}
function qa(t, e, r) {
  if (!(t.f & hn)) {
    if (t.f ^= hn, t.transitions !== null)
      for (const o of t.transitions)
        (o.is_global || r) && e.push(o);
    for (var a = t.first; a !== null; ) {
      var i = a.next, s = (a.f & er) !== 0 || (a.f & bn) !== 0;
      qa(a, e, s ? r : !1), a = i;
    }
  }
}
function Ar(t) {
  ns(t, !0);
}
function ns(t, e) {
  if (t.f & hn) {
    t.f ^= hn, t.f & yt || (t.f ^= yt), sr(t) && (Zt(t, tn), ta(t));
    for (var r = t.first; r !== null; ) {
      var a = r.next, i = (r.f & er) !== 0 || (r.f & bn) !== 0;
      ns(r, i ? e : !1), r = a;
    }
    if (t.transitions !== null)
      for (const s of t.transitions)
        (s.is_global || e) && s.in();
  }
}
const Wo = typeof requestIdleCallback > "u" ? (t) => setTimeout(t, 1) : requestIdleCallback;
let pr = [], hr = [];
function rs() {
  var t = pr;
  pr = [], dr(t);
}
function as() {
  var t = hr;
  hr = [], dr(t);
}
function Qr(t) {
  pr.length === 0 && queueMicrotask(rs), pr.push(t);
}
function jo(t) {
  hr.length === 0 && Wo(as), hr.push(t);
}
function Go() {
  pr.length > 0 && rs(), hr.length > 0 && as();
}
let xr = !1, Dr = !1, Rr = null, Dn = !1, ir = !1;
function vi(t) {
  ir = t;
}
let vr = [];
let $e = null, rn = !1;
function Yt(t) {
  $e = t;
}
let Xe = null;
function sn(t) {
  Xe = t;
}
let It = null;
function is(t) {
  $e !== null && $e.f & ba && (It === null ? It = [t] : It.push(t));
}
let bt = null, Rt = 0, Wt = null;
function Yo(t) {
  Wt = t;
}
let ss = 1, Pr = 0, xn = !1;
function os() {
  return ++ss;
}
function sr(t) {
  var c;
  var e = t.f;
  if (e & tn)
    return !0;
  if (e & In) {
    var r = t.deps, a = (e & Pt) !== 0;
    if (r !== null) {
      var i, s, o = (e & Mr) !== 0, l = a && Xe !== null && !xn, u = r.length;
      if (o || l) {
        var d = (
          /** @type {Derived} */
          t
        ), f = d.parent;
        for (i = 0; i < u; i++)
          s = r[i], (o || !((c = s == null ? void 0 : s.reactions) != null && c.includes(d))) && (s.reactions ?? (s.reactions = [])).push(d);
        o && (d.f ^= Mr), l && f !== null && !(f.f & Pt) && (d.f ^= Pt);
      }
      for (i = 0; i < u; i++)
        if (s = r[i], sr(
          /** @type {Derived} */
          s
        ) && qi(
          /** @type {Derived} */
          s
        ), s.wv > t.wv)
          return !0;
    }
    (!a || Xe !== null && !xn) && Zt(t, yt);
  }
  return !1;
}
function Zo(t, e) {
  for (var r = e; r !== null; ) {
    if (r.f & Lr)
      try {
        r.fn(t);
        return;
      } catch {
        r.f ^= Lr;
      }
    r = r.parent;
  }
  throw xr = !1, t;
}
function di(t) {
  return (t.f & Jr) === 0 && (t.parent === null || (t.parent.f & Lr) === 0);
}
function $r(t, e, r, a) {
  if (xr) {
    if (r === null && (xr = !1), di(e))
      throw t;
    return;
  }
  if (r !== null && (xr = !0), Zo(t, e), di(e))
    throw t;
}
function ls(t, e, r = !0) {
  var a = t.reactions;
  if (a !== null)
    for (var i = 0; i < a.length; i++) {
      var s = a[i];
      It != null && It.includes(t) || (s.f & en ? ls(
        /** @type {Derived} */
        s,
        e,
        !1
      ) : e === s && (r ? Zt(s, tn) : s.f & yt && Zt(s, In), ta(
        /** @type {Effect} */
        s
      )));
    }
}
function us(t) {
  var p;
  var e = bt, r = Rt, a = Wt, i = $e, s = xn, o = It, l = Ke, u = rn, d = t.f;
  bt = /** @type {null | Value[]} */
  null, Rt = 0, Wt = null, xn = (d & Pt) !== 0 && (rn || !Dn || $e === null), $e = d & (bn | $n) ? null : t, It = null, ui(t.ctx), rn = !1, Pr++, t.f |= ba;
  try {
    var f = (
      /** @type {Function} */
      (0, t.fn)()
    ), c = t.deps;
    if (bt !== null) {
      var v;
      if (Ur(t, Rt), c !== null && Rt > 0)
        for (c.length = Rt + bt.length, v = 0; v < bt.length; v++)
          c[Rt + v] = bt[v];
      else
        t.deps = c = bt;
      if (!xn)
        for (v = Rt; v < c.length; v++)
          ((p = c[v]).reactions ?? (p.reactions = [])).push(t);
    } else c !== null && Rt < c.length && (Ur(t, Rt), c.length = Rt);
    if (tr() && Wt !== null && !rn && c !== null && !(t.f & (en | In | tn)))
      for (v = 0; v < /** @type {Source[]} */
      Wt.length; v++)
        ls(
          Wt[v],
          /** @type {Effect} */
          t
        );
    return i !== null && i !== t && (Pr++, Wt !== null && (a === null ? a = Wt : a.push(.../** @type {Source[]} */
    Wt))), f;
  } finally {
    bt = e, Rt = r, Wt = a, $e = i, xn = s, It = o, ui(l), rn = u, t.f ^= ba;
  }
}
function Jo(t, e) {
  let r = e.reactions;
  if (r !== null) {
    var a = bo.call(r, t);
    if (a !== -1) {
      var i = r.length - 1;
      i === 0 ? r = e.reactions = null : (r[a] = r[i], r.pop());
    }
  }
  r === null && e.f & en && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (bt === null || !bt.includes(e)) && (Zt(e, In), e.f & (Pt | Mr) || (e.f ^= Mr), Hi(
    /** @type {Derived} **/
    e
  ), Ur(
    /** @type {Derived} **/
    e,
    0
  ));
}
function Ur(t, e) {
  var r = t.deps;
  if (r !== null)
    for (var a = e; a < r.length; a++)
      Jo(t, r[a]);
}
function ea(t) {
  var e = t.f;
  if (!(e & Jr)) {
    Zt(t, yt);
    var r = Xe, a = Ke, i = Dn;
    Xe = t, Dn = !0;
    try {
      e & Zr ? qo(t) : Qi(t), Xi(t);
      var s = us(t);
      t.teardown = typeof s == "function" ? s : null, t.wv = ss;
      var o = t.deps, l;
      oi && so && t.f & tn;
    } catch (u) {
      $r(u, t, r, a || t.ctx);
    } finally {
      Dn = i, Xe = r;
    }
  }
}
function Ko() {
  try {
    Mo();
  } catch (t) {
    if (Rr !== null)
      $r(t, Rr, null);
    else
      throw t;
  }
}
function cs() {
  var t = Dn;
  try {
    var e = 0;
    for (Dn = !0; vr.length > 0; ) {
      e++ > 1e3 && Ko();
      var r = vr, a = r.length;
      vr = [];
      for (var i = 0; i < a; i++) {
        var s = Qo(r[i]);
        Xo(s);
      }
      fr.clear();
    }
  } finally {
    Dr = !1, Dn = t, Rr = null;
  }
}
function Xo(t) {
  var e = t.length;
  if (e !== 0)
    for (var r = 0; r < e; r++) {
      var a = t[r];
      if (!(a.f & (Jr | hn)))
        try {
          sr(a) && (ea(a), a.deps === null && a.first === null && a.nodes_start === null && (a.teardown === null ? es(a) : a.fn = null));
        } catch (i) {
          $r(i, a, null, a.ctx);
        }
    }
}
function ta(t) {
  Dr || (Dr = !0, queueMicrotask(cs));
  for (var e = Rr = t; e.parent !== null; ) {
    e = e.parent;
    var r = e.f;
    if (r & ($n | bn)) {
      if (!(r & yt)) return;
      e.f ^= yt;
    }
  }
  vr.push(e);
}
function Qo(t) {
  for (var e = [], r = t; r !== null; ) {
    var a = r.f, i = (a & (bn | $n)) !== 0, s = i && (a & yt) !== 0;
    if (!s && !(a & hn)) {
      if (a & Ri)
        e.push(r);
      else if (i)
        r.f ^= yt;
      else
        try {
          sr(r) && ea(r);
        } catch (u) {
          $r(u, r, null, r.ctx);
        }
      var o = r.first;
      if (o !== null) {
        r = o;
        continue;
      }
    }
    var l = r.parent;
    for (r = r.next; r === null && l !== null; )
      r = l.next, l = l.parent;
  }
  return e;
}
function $t(t) {
  for (var e; ; ) {
    if (Go(), vr.length === 0)
      return (
        /** @type {T} */
        e
      );
    Dr = !0, cs();
  }
}
function n(t) {
  var e = t.f, r = (e & en) !== 0;
  if ($e !== null && !rn) {
    if (!(It != null && It.includes(t))) {
      var a = $e.deps;
      t.rv < Pr && (t.rv = Pr, bt === null && a !== null && a[Rt] === t ? Rt++ : bt === null ? bt = [t] : (!xn || !bt.includes(t)) && bt.push(t));
    }
  } else if (r && /** @type {Derived} */
  t.deps === null && /** @type {Derived} */
  t.effects === null) {
    var i = (
      /** @type {Derived} */
      t
    ), s = i.parent;
    s !== null && !(s.f & Pt) && (i.f ^= Pt);
  }
  return r && (i = /** @type {Derived} */
  t, sr(i) && qi(i)), ir && fr.has(t) ? fr.get(t) : t.v;
}
function Vt(t) {
  var e = rn;
  try {
    return rn = !0, t();
  } finally {
    rn = e;
  }
}
const $o = ~(tn | In | yt);
function Zt(t, e) {
  t.f = t.f & $o | e;
}
function Le(t) {
  if (!(typeof t != "object" || !t || t instanceof EventTarget)) {
    if (kn in t)
      Na(t);
    else if (!Array.isArray(t))
      for (let e in t) {
        const r = t[e];
        typeof r == "object" && r && kn in r && Na(r);
      }
  }
}
function Na(t, e = /* @__PURE__ */ new Set()) {
  if (typeof t == "object" && t !== null && // We don't want to traverse DOM elements
  !(t instanceof EventTarget) && !e.has(t)) {
    e.add(t), t instanceof Date && t.getTime();
    for (let a in t)
      try {
        Na(t[a], e);
      } catch {
      }
    const r = Fa(t);
    if (r !== Object.prototype && r !== Array.prototype && r !== Map.prototype && r !== Set.prototype && r !== Date.prototype) {
      const a = Di(r);
      for (let i in a) {
        const s = a[i].get;
        if (s)
          try {
            s.call(t);
          } catch {
          }
      }
    }
  }
}
let fi = !1;
function vs() {
  fi || (fi = !0, document.addEventListener(
    "reset",
    (t) => {
      Promise.resolve().then(() => {
        var e;
        if (!t.defaultPrevented)
          for (
            const r of
            /**@type {HTMLFormElement} */
            t.target.elements
          )
            (e = r.__on_r) == null || e.call(r);
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function el(t, e, r, a = !0) {
  a && r();
  for (var i of e)
    t.addEventListener(i, r);
  Ir(() => {
    for (var s of e)
      t.removeEventListener(s, r);
  });
}
function na(t) {
  var e = $e, r = Xe;
  Yt(null), sn(null);
  try {
    return t();
  } finally {
    Yt(e), sn(r);
  }
}
function tl(t, e, r, a = r) {
  t.addEventListener(e, () => na(r));
  const i = t.__on_r;
  i ? t.__on_r = () => {
    i(), a(!0);
  } : t.__on_r = () => a(!0), vs();
}
const ds = /* @__PURE__ */ new Set(), Ta = /* @__PURE__ */ new Set();
function nl(t, e, r, a = {}) {
  function i(s) {
    if (a.capture || cr.call(e, s), !s.cancelBubble)
      return na(() => r == null ? void 0 : r.call(this, s));
  }
  return t.startsWith("pointer") || t.startsWith("touch") || t === "wheel" ? Qr(() => {
    e.addEventListener(t, i, a);
  }) : e.addEventListener(t, i, a), i;
}
function at(t, e, r, a, i) {
  var s = { capture: a, passive: i }, o = nl(t, e, r, s);
  (e === document.body || // @ts-ignore
  e === window || // @ts-ignore
  e === document || // Firefox has quirky behavior, it can happen that we still get "canplay" events when the element is already removed
  e instanceof HTMLMediaElement) && Ir(() => {
    e.removeEventListener(t, o, s);
  });
}
function Wa(t) {
  for (var e = 0; e < t.length; e++)
    ds.add(t[e]);
  for (var r of Ta)
    r(t);
}
function cr(t) {
  var C;
  var e = this, r = (
    /** @type {Node} */
    e.ownerDocument
  ), a = t.type, i = ((C = t.composedPath) == null ? void 0 : C.call(t)) || [], s = (
    /** @type {null | Element} */
    i[0] || t.target
  ), o = 0, l = t.__root;
  if (l) {
    var u = i.indexOf(l);
    if (u !== -1 && (e === document || e === /** @type {any} */
    window)) {
      t.__root = e;
      return;
    }
    var d = i.indexOf(e);
    if (d === -1)
      return;
    u <= d && (o = u);
  }
  if (s = /** @type {Element} */
  i[o] || t.target, s !== e) {
    Ai(t, "currentTarget", {
      configurable: !0,
      get() {
        return s || r;
      }
    });
    var f = $e, c = Xe;
    Yt(null), sn(null);
    try {
      for (var v, p = []; s !== null; ) {
        var h = s.assignedSlot || s.parentNode || /** @type {any} */
        s.host || null;
        try {
          var m = s["__" + a];
          if (m != null && (!/** @type {any} */
          s.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          t.target === s))
            if (Sr(m)) {
              var [y, ...I] = m;
              y.apply(s, [t, ...I]);
            } else
              m.call(s, t);
        } catch (T) {
          v ? p.push(T) : v = T;
        }
        if (t.cancelBubble || h === e || h === null)
          break;
        s = h;
      }
      if (v) {
        for (let T of p)
          queueMicrotask(() => {
            throw T;
          });
        throw v;
      }
    } finally {
      t.__root = e, delete t.currentTarget, Yt(f), sn(c);
    }
  }
}
function ja(t) {
  var e = document.createElement("template");
  return e.innerHTML = t.replaceAll("<!>", "<!---->"), e.content;
}
function Bt(t, e) {
  var r = (
    /** @type {Effect} */
    Xe
  );
  r.nodes_start === null && (r.nodes_start = t, r.nodes_end = e);
}
// @__NO_SIDE_EFFECTS__
function x(t, e) {
  var r = (e & Mi) !== 0, a = (e & _o) !== 0, i, s = !t.startsWith("<!>");
  return () => {
    if (Be)
      return Bt(Ge, null), Ge;
    i === void 0 && (i = ja(s ? t : "<!>" + t), r || (i = /** @type {Node} */
    /* @__PURE__ */ ht(i)));
    var o = (
      /** @type {TemplateNode} */
      a || Gi ? document.importNode(i, !0) : i.cloneNode(!0)
    );
    if (r) {
      var l = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ ht(o)
      ), u = (
        /** @type {TemplateNode} */
        o.lastChild
      );
      Bt(l, u);
    } else
      Bt(o, o);
    return o;
  };
}
// @__NO_SIDE_EFFECTS__
function rl(t, e, r = "svg") {
  var a = !t.startsWith("<!>"), i = (e & Mi) !== 0, s = `<${r}>${a ? t : "<!>" + t}</${r}>`, o;
  return () => {
    if (Be)
      return Bt(Ge, null), Ge;
    if (!o) {
      var l = (
        /** @type {DocumentFragment} */
        ja(s)
      ), u = (
        /** @type {Element} */
        /* @__PURE__ */ ht(l)
      );
      if (i)
        for (o = document.createDocumentFragment(); /* @__PURE__ */ ht(u); )
          o.appendChild(
            /** @type {Node} */
            /* @__PURE__ */ ht(u)
          );
      else
        o = /** @type {Element} */
        /* @__PURE__ */ ht(u);
    }
    var d = (
      /** @type {TemplateNode} */
      o.cloneNode(!0)
    );
    if (i) {
      var f = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ ht(d)
      ), c = (
        /** @type {TemplateNode} */
        d.lastChild
      );
      Bt(f, c);
    } else
      Bt(d, d);
    return d;
  };
}
// @__NO_SIDE_EFFECTS__
function Cn(t, e) {
  return /* @__PURE__ */ rl(t, e, "svg");
}
function Zn(t = "") {
  if (!Be) {
    var e = On(t + "");
    return Bt(e, e), e;
  }
  var r = Ge;
  return r.nodeType !== 3 && (r.before(r = On()), Ut(r)), Bt(r, r), r;
}
function Ze() {
  if (Be)
    return Bt(Ge, null), Ge;
  var t = document.createDocumentFragment(), e = document.createComment(""), r = On();
  return t.append(e, r), Bt(e, r), t;
}
function w(t, e) {
  if (Be) {
    Xe.nodes_end = Ge, _n();
    return;
  }
  t !== null && t.before(
    /** @type {Node} */
    e
  );
}
const al = ["touchstart", "touchmove"];
function il(t) {
  return al.includes(t);
}
let Ea = !0;
function fe(t, e) {
  var r = e == null ? "" : typeof e == "object" ? e + "" : e;
  r !== (t.__t ?? (t.__t = t.nodeValue)) && (t.__t = r, t.nodeValue = r + "");
}
function sl(t, e) {
  return fs(t, e);
}
function cg(t, e) {
  Ca(), e.intro = e.intro ?? !1;
  const r = e.target, a = Be, i = Ge;
  try {
    for (var s = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ ht(r)
    ); s && (s.nodeType !== 8 || /** @type {Comment} */
    s.data !== Pa); )
      s = /** @type {TemplateNode} */
      /* @__PURE__ */ on(s);
    if (!s)
      throw An;
    gn(!0), Ut(
      /** @type {Comment} */
      s
    ), _n();
    const o = fs(t, { ...e, anchor: s });
    if (Ge === null || Ge.nodeType !== 8 || /** @type {Comment} */
    Ge.data !== Ba)
      throw br(), An;
    return gn(!1), /**  @type {Exports} */
    o;
  } catch (o) {
    if (o === An)
      return e.recover === !1 && Ao(), Ca(), Ji(r), gn(!1), sl(t, e);
    throw o;
  } finally {
    gn(a), Ut(i);
  }
}
const zn = /* @__PURE__ */ new Map();
function fs(t, { target: e, anchor: r, props: a = {}, events: i, context: s, intro: o = !0 }) {
  Ca();
  var l = /* @__PURE__ */ new Set(), u = (c) => {
    for (var v = 0; v < c.length; v++) {
      var p = c[v];
      if (!l.has(p)) {
        l.add(p);
        var h = il(p);
        e.addEventListener(p, cr, { passive: h });
        var m = zn.get(p);
        m === void 0 ? (document.addEventListener(p, cr, { passive: h }), zn.set(p, 1)) : zn.set(p, m + 1);
      }
    }
  };
  u(Va(ds)), Ta.add(u);
  var d = void 0, f = zo(() => {
    var c = r ?? e.appendChild(On());
    return Ln(() => {
      if (s) {
        oe({});
        var v = (
          /** @type {ComponentContext} */
          Ke
        );
        v.c = s;
      }
      i && (a.$$events = i), Be && Bt(
        /** @type {TemplateNode} */
        c,
        null
      ), Ea = o, d = t(c, a) || {}, Ea = !0, Be && (Xe.nodes_end = Ge), s && le();
    }), () => {
      var h;
      for (var v of l) {
        e.removeEventListener(v, cr);
        var p = (
          /** @type {number} */
          zn.get(v)
        );
        --p === 0 ? (document.removeEventListener(v, cr), zn.delete(v)) : zn.set(v, p);
      }
      Ta.delete(u), c !== r && ((h = c.parentNode) == null || h.removeChild(c));
    };
  });
  return xa.set(d, f), d;
}
let xa = /* @__PURE__ */ new WeakMap();
function vg(t, e) {
  const r = xa.get(t);
  return r ? (xa.delete(t), r(e)) : Promise.resolve();
}
function gs(t, e, ...r) {
  var a = t, i = pt, s;
  ar(() => {
    i !== (i = e()) && (s && (Sn(s), s = null), s = Ln(() => (
      /** @type {SnippetFn} */
      i(a, ...r)
    )));
  }, er), Be && (a = Ge);
}
function _t(t) {
  Ke === null && Xr(), Qn && Ke.l !== null ? ll(Ke).m.push(t) : ut(() => {
    const e = Vt(t);
    if (typeof e == "function") return (
      /** @type {() => void} */
      e
    );
  });
}
function wr(t) {
  Ke === null && Xr(), _t(() => () => Vt(t));
}
function ol(t, e, { bubbles: r = !1, cancelable: a = !1 } = {}) {
  return new CustomEvent(t, { detail: e, bubbles: r, cancelable: a });
}
function Vn() {
  const t = Ke;
  return t === null && Xr(), (e, r, a) => {
    var s;
    const i = (
      /** @type {Record<string, Function | Function[]>} */
      (s = t.s.$$events) == null ? void 0 : s[
        /** @type {any} */
        e
      ]
    );
    if (i) {
      const o = Sr(i) ? i.slice() : [i], l = ol(
        /** @type {string} */
        e,
        r,
        a
      );
      for (const u of o)
        u.call(t.x, l);
      return !l.defaultPrevented;
    }
    return !0;
  };
}
function ll(t) {
  var e = (
    /** @type {ComponentContextLegacy} */
    t.l
  );
  return e.u ?? (e.u = { a: [], b: [], m: [] });
}
function F(t, e, [r, a] = [0, 0]) {
  Be && r === 0 && _n();
  var i = t, s = null, o = null, l = St, u = r > 0 ? er : 0, d = !1;
  const f = (v, p = !0) => {
    d = !0, c(p, v);
  }, c = (v, p) => {
    if (l === (l = v)) return;
    let h = !1;
    if (Be && a !== -1) {
      if (r === 0) {
        const y = ji(i);
        y === Pa ? a = 0 : y === Ua ? a = 1 / 0 : (a = parseInt(y.substring(1)), a !== a && (a = l ? 1 / 0 : -1));
      }
      const m = a > r;
      !!l === m && (i = wa(), Ut(i), gn(!1), h = !0, a = -1);
    }
    l ? (s ? Ar(s) : p && (s = Ln(() => p(i))), o && Yn(o, () => {
      o = null;
    })) : (o ? Ar(o) : p && (o = Ln(() => p(i, [r + 1, a]))), s && Yn(s, () => {
      s = null;
    })), h && gn(!0);
  };
  ar(() => {
    d = !1, e(f), d || c(null, null);
  }, u), Be && (i = Ge);
}
function ul(t, e, r) {
  Be && _n();
  var a = t, i = St, s, o = tr() ? xo : Kr;
  ar(() => {
    o(i, i = e()) && (s && Yn(s), s = Ln(() => r(a)));
  }), Be && (a = Ge);
}
function Je(t, e) {
  return e;
}
function cl(t, e, r, a) {
  for (var i = [], s = e.length, o = 0; o < s; o++)
    qa(e[o].e, i, !0);
  var l = s > 0 && i.length === 0 && r !== null;
  if (l) {
    var u = (
      /** @type {Element} */
      /** @type {Element} */
      r.parentNode
    );
    Ji(u), u.append(
      /** @type {Element} */
      r
    ), a.clear(), Nn(t, e[0].prev, e[s - 1].next);
  }
  ts(i, () => {
    for (var d = 0; d < s; d++) {
      var f = e[d];
      l || (a.delete(f.k), Nn(t, f.prev, f.next)), Sn(f.e, !l);
    }
  });
}
function qe(t, e, r, a, i, s = null) {
  var o = t, l = { flags: e, items: /* @__PURE__ */ new Map(), first: null }, u = (e & Li) !== 0;
  if (u) {
    var d = (
      /** @type {Element} */
      t
    );
    o = Be ? Ut(
      /** @type {Comment | Text} */
      /* @__PURE__ */ ht(d)
    ) : d.appendChild(On());
  }
  Be && _n();
  var f = null, c = !1, v = /* @__PURE__ */ de(() => {
    var p = r();
    return Sr(p) ? p : p == null ? [] : Va(p);
  });
  ar(() => {
    var p = n(v), h = p.length;
    if (c && h === 0)
      return;
    c = h === 0;
    let m = !1;
    if (Be) {
      var y = ji(o) === Ua;
      y !== (h === 0) && (o = wa(), Ut(o), gn(!1), m = !0);
    }
    if (Be) {
      for (var I = null, C, T = 0; T < h; T++) {
        if (Ge.nodeType === 8 && /** @type {Comment} */
        Ge.data === Ba) {
          o = /** @type {Comment} */
          Ge, m = !0, gn(!1);
          break;
        }
        var N = p[T], b = a(N, T);
        C = ps(
          Ge,
          l,
          I,
          null,
          N,
          b,
          T,
          i,
          e,
          r
        ), l.items.set(b, C), I = C;
      }
      h > 0 && Ut(wa());
    }
    Be || vl(p, l, o, i, e, a, r), s !== null && (h === 0 ? f ? Ar(f) : f = Ln(() => s(o)) : f !== null && Yn(f, () => {
      f = null;
    })), m && gn(!0), n(v);
  }), Be && (o = Ge);
}
function vl(t, e, r, a, i, s, o) {
  var R, W, K, Q;
  var l = (i & lo) !== 0, u = (i & (Da | Ra)) !== 0, d = t.length, f = e.items, c = e.first, v = c, p, h = null, m, y = [], I = [], C, T, N, b;
  if (l)
    for (b = 0; b < d; b += 1)
      C = t[b], T = s(C, b), N = f.get(T), N !== void 0 && ((R = N.a) == null || R.measure(), (m ?? (m = /* @__PURE__ */ new Set())).add(N));
  for (b = 0; b < d; b += 1) {
    if (C = t[b], T = s(C, b), N = f.get(T), N === void 0) {
      var E = v ? (
        /** @type {TemplateNode} */
        v.e.nodes_start
      ) : r;
      h = ps(
        E,
        e,
        h,
        h === null ? e.first : h.next,
        C,
        T,
        b,
        a,
        i,
        o
      ), f.set(T, h), y = [], I = [], v = h.next;
      continue;
    }
    if (u && dl(N, C, b, i), N.e.f & hn && (Ar(N.e), l && ((W = N.a) == null || W.unfix(), (m ?? (m = /* @__PURE__ */ new Set())).delete(N))), N !== v) {
      if (p !== void 0 && p.has(N)) {
        if (y.length < I.length) {
          var k = I[0], A;
          h = k.prev;
          var P = y[0], M = y[y.length - 1];
          for (A = 0; A < y.length; A += 1)
            gi(y[A], k, r);
          for (A = 0; A < I.length; A += 1)
            p.delete(I[A]);
          Nn(e, P.prev, M.next), Nn(e, h, P), Nn(e, M, k), v = k, h = M, b -= 1, y = [], I = [];
        } else
          p.delete(N), gi(N, v, r), Nn(e, N.prev, N.next), Nn(e, N, h === null ? e.first : h.next), Nn(e, h, N), h = N;
        continue;
      }
      for (y = [], I = []; v !== null && v.k !== T; )
        v.e.f & hn || (p ?? (p = /* @__PURE__ */ new Set())).add(v), I.push(v), v = v.next;
      if (v === null)
        continue;
      N = v;
    }
    y.push(N), h = N, v = N.next;
  }
  if (v !== null || p !== void 0) {
    for (var z = p === void 0 ? [] : Va(p); v !== null; )
      v.e.f & hn || z.push(v), v = v.next;
    var B = z.length;
    if (B > 0) {
      var G = i & Li && d === 0 ? r : null;
      if (l) {
        for (b = 0; b < B; b += 1)
          (K = z[b].a) == null || K.measure();
        for (b = 0; b < B; b += 1)
          (Q = z[b].a) == null || Q.fix();
      }
      cl(e, z, G, f);
    }
  }
  l && Qr(() => {
    var V;
    if (m !== void 0)
      for (N of m)
        (V = N.a) == null || V.apply();
  }), Xe.first = e.first && e.first.e, Xe.last = h && h.e;
}
function dl(t, e, r, a) {
  a & Da && Ia(t.v, e), a & Ra ? Ia(
    /** @type {Value<number>} */
    t.i,
    r
  ) : t.i = r;
}
function ps(t, e, r, a, i, s, o, l, u, d) {
  var f = (u & Da) !== 0, c = (u & uo) === 0, v = f ? c ? /* @__PURE__ */ Y(i) : gr(i) : i, p = u & Ra ? gr(o) : o, h = {
    i: p,
    v,
    k: s,
    a: null,
    // @ts-expect-error
    e: null,
    prev: r,
    next: a
  };
  try {
    return h.e = Ln(() => l(t, v, p, d), Be), h.e.prev = r && r.e, h.e.next = a && a.e, r === null ? e.first = h : (r.next = h, r.e.next = h.e), a !== null && (a.prev = h, a.e.prev = h.e), h;
  } finally {
  }
}
function gi(t, e, r) {
  for (var a = t.next ? (
    /** @type {TemplateNode} */
    t.next.e.nodes_start
  ) : r, i = e ? (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ) : r, s = (
    /** @type {TemplateNode} */
    t.e.nodes_start
  ); s !== a; ) {
    var o = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ on(s)
    );
    i.before(s), s = o;
  }
}
function Nn(t, e, r) {
  e === null ? t.first = r : (e.next = r, e.e.next = r && r.e), r !== null && (r.prev = e, r.e.prev = e && e.e);
}
function Ga(t, e, r = !1, a = !1, i = !1) {
  var s = t, o = "";
  L(() => {
    var l = (
      /** @type {Effect} */
      Xe
    );
    if (o === (o = e() ?? "")) {
      Be && _n();
      return;
    }
    if (l.nodes_start !== null && ($i(
      l.nodes_start,
      /** @type {TemplateNode} */
      l.nodes_end
    ), l.nodes_start = l.nodes_end = null), o !== "") {
      if (Be) {
        Ge.data;
        for (var u = _n(), d = u; u !== null && (u.nodeType !== 8 || /** @type {Comment} */
        u.data !== ""); )
          d = u, u = /** @type {TemplateNode} */
          /* @__PURE__ */ on(u);
        if (u === null)
          throw br(), An;
        Bt(Ge, d), s = Ut(u);
        return;
      }
      var f = o + "";
      r ? f = `<svg>${f}</svg>` : a && (f = `<math>${f}</math>`);
      var c = ja(f);
      if ((r || a) && (c = /** @type {Element} */
      /* @__PURE__ */ ht(c)), Bt(
        /** @type {TemplateNode} */
        /* @__PURE__ */ ht(c),
        /** @type {TemplateNode} */
        c.lastChild
      ), r || a)
        for (; /* @__PURE__ */ ht(c); )
          s.before(
            /** @type {Node} */
            /* @__PURE__ */ ht(c)
          );
      else
        s.before(c);
    }
  });
}
function ra(t, e, r, a, i) {
  var l;
  Be && _n();
  var s = (l = e.$$slots) == null ? void 0 : l[r], o = !1;
  s === !0 && (s = e.children, o = !0), s === void 0 || s(t, o ? () => a : a);
}
function fl(t, e, r) {
  Be && _n();
  var a = t, i, s;
  ar(() => {
    i !== (i = e()) && (s && (Yn(s), s = null), i && (s = Ln(() => r(a, i))));
  }, er), Be && (a = Ge);
}
function ne(t, e, r) {
  lt(() => {
    var a = Vt(() => e(t, r == null ? void 0 : r()) || {});
    if (r && (a != null && a.update)) {
      var i = !1, s = (
        /** @type {any} */
        {}
      );
      rr(() => {
        var o = r();
        Le(o), i && Kr(s, o) && (s = o, a.update(o));
      }), i = !0;
    }
    if (a != null && a.destroy)
      return () => (
        /** @type {Function} */
        a.destroy()
      );
  });
}
const pi = [...` 	
\r\f \v\uFEFF`];
function gl(t, e, r) {
  var a = t == null ? "" : "" + t;
  if (e && (a = a ? a + " " + e : e), r) {
    for (var i in r)
      if (r[i])
        a = a ? a + " " + i : i;
      else if (a.length)
        for (var s = i.length, o = 0; (o = a.indexOf(i, o)) >= 0; ) {
          var l = o + s;
          (o === 0 || pi.includes(a[o - 1])) && (l === a.length || pi.includes(a[l])) ? a = (o === 0 ? "" : a.substring(0, o)) + a.substring(l + 1) : o = l;
        }
  }
  return a === "" ? null : a;
}
function hi(t, e = !1) {
  var r = e ? " !important;" : ";", a = "";
  for (var i in t) {
    var s = t[i];
    s != null && s !== "" && (a += " " + i + ": " + s + r);
  }
  return a;
}
function da(t) {
  return t[0] !== "-" || t[1] !== "-" ? t.toLowerCase() : t;
}
function pl(t, e) {
  if (e) {
    var r = "", a, i;
    if (Array.isArray(e) ? (a = e[0], i = e[1]) : a = e, t) {
      t = String(t).replaceAll(/\s*\/\*.*?\*\/\s*/g, "").trim();
      var s = !1, o = 0, l = !1, u = [];
      a && u.push(...Object.keys(a).map(da)), i && u.push(...Object.keys(i).map(da));
      var d = 0, f = -1;
      const m = t.length;
      for (var c = 0; c < m; c++) {
        var v = t[c];
        if (l ? v === "/" && t[c - 1] === "*" && (l = !1) : s ? s === v && (s = !1) : v === "/" && t[c + 1] === "*" ? l = !0 : v === '"' || v === "'" ? s = v : v === "(" ? o++ : v === ")" && o--, !l && s === !1 && o === 0) {
          if (v === ":" && f === -1)
            f = c;
          else if (v === ";" || c === m - 1) {
            if (f !== -1) {
              var p = da(t.substring(d, f).trim());
              if (!u.includes(p)) {
                v !== ";" && c++;
                var h = t.substring(d, c).trim();
                r += " " + h + ";";
              }
            }
            d = c + 1, f = -1;
          }
        }
      }
    }
    return a && (r += hi(a)), i && (r += hi(i, !0)), r = r.trim(), r === "" ? null : r;
  }
  return t == null ? null : String(t);
}
function j(t, e, r, a, i, s) {
  var o = t.__className;
  if (Be || o !== r || o === void 0) {
    var l = gl(r, a, s);
    (!Be || l !== t.getAttribute("class")) && (l == null ? t.removeAttribute("class") : t.className = l), t.__className = r;
  } else if (s && i !== s)
    for (var u in s) {
      var d = !!s[u];
      (i == null || d !== !!i[u]) && t.classList.toggle(u, d);
    }
  return s;
}
function fa(t, e = {}, r, a) {
  for (var i in r) {
    var s = r[i];
    e[i] !== s && (r[i] == null ? t.style.removeProperty(i) : t.style.setProperty(i, s, a));
  }
}
function Te(t, e, r, a) {
  var i = t.__style;
  if (Be || i !== e) {
    var s = pl(e, a);
    (!Be || s !== t.getAttribute("style")) && (s == null ? t.removeAttribute("style") : t.style.cssText = s), t.__style = e;
  } else a && (Array.isArray(a) ? (fa(t, r == null ? void 0 : r[0], a[0]), fa(t, r == null ? void 0 : r[1], a[1], "important")) : fa(t, r, a));
  return a;
}
const hl = Symbol("is custom element"), ml = Symbol("is html");
function yl(t) {
  if (Be) {
    var e = !1, r = () => {
      if (!e) {
        if (e = !0, t.hasAttribute("value")) {
          var a = t.value;
          D(t, "value", null), t.value = a;
        }
        if (t.hasAttribute("checked")) {
          var i = t.checked;
          D(t, "checked", null), t.checked = i;
        }
      }
    };
    t.__on_r = r, jo(r), vs();
  }
}
function D(t, e, r, a) {
  var i = _l(t);
  Be && (i[e] = t.getAttribute(e), e === "src" || e === "srcset" || e === "href" && t.nodeName === "LINK") || i[e] !== (i[e] = r) && (e === "loading" && (t[Eo] = r), r == null ? t.removeAttribute(e) : typeof r != "string" && Sl(t).includes(e) ? t[e] = r : t.setAttribute(e, r));
}
function _l(t) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    // @ts-expect-error
    t.__attributes ?? (t.__attributes = {
      [hl]: t.nodeName.includes("-"),
      [ml]: t.namespaceURI === So
    })
  );
}
var mi = /* @__PURE__ */ new Map();
function Sl(t) {
  var e = mi.get(t.nodeName);
  if (e) return e;
  mi.set(t.nodeName, e = []);
  for (var r, a = t, i = Element.prototype; i !== a; ) {
    r = Di(a);
    for (var s in r)
      r[s].set && e.push(s);
    a = Fa(a);
  }
  return e;
}
const bl = () => performance.now(), fn = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (t) => requestAnimationFrame(t)
  ),
  now: () => bl(),
  tasks: /* @__PURE__ */ new Set()
};
function hs() {
  const t = fn.now();
  fn.tasks.forEach((e) => {
    e.c(t) || (fn.tasks.delete(e), e.f());
  }), fn.tasks.size !== 0 && fn.tick(hs);
}
function Il(t) {
  let e;
  return fn.tasks.size === 0 && fn.tick(hs), {
    promise: new Promise((r) => {
      fn.tasks.add(e = { c: t, f: r });
    }),
    abort() {
      fn.tasks.delete(e);
    }
  };
}
function Tr(t, e) {
  na(() => {
    t.dispatchEvent(new CustomEvent(e));
  });
}
function wl(t) {
  if (t === "float") return "cssFloat";
  if (t === "offset") return "cssOffset";
  if (t.startsWith("--")) return t;
  const e = t.split("-");
  return e.length === 1 ? e[0] : e[0] + e.slice(1).map(
    /** @param {any} word */
    (r) => r[0].toUpperCase() + r.slice(1)
  ).join("");
}
function yi(t) {
  const e = {}, r = t.split(";");
  for (const a of r) {
    const [i, s] = a.split(":");
    if (!i || s === void 0) break;
    const o = wl(i.trim());
    e[o] = s.trim();
  }
  return e;
}
const Cl = (t) => t;
function Br(t, e, r, a) {
  var i = (t & ho) !== 0, s = (t & mo) !== 0, o = i && s, l = (t & yo) !== 0, u = o ? "both" : i ? "in" : "out", d, f = e.inert, c = e.style.overflow, v, p;
  function h() {
    var T = $e, N = Xe;
    Yt(null), sn(null);
    try {
      return d ?? (d = r()(e, (a == null ? void 0 : a()) ?? /** @type {P} */
      {}, {
        direction: u
      }));
    } finally {
      Yt(T), sn(N);
    }
  }
  var m = {
    is_global: l,
    in() {
      var T;
      if (e.inert = f, !i) {
        p == null || p.abort(), (T = p == null ? void 0 : p.reset) == null || T.call(p);
        return;
      }
      s || v == null || v.abort(), Tr(e, "introstart"), v = ka(e, h(), p, 1, () => {
        Tr(e, "introend"), v == null || v.abort(), v = d = void 0, e.style.overflow = c;
      });
    },
    out(T) {
      if (!s) {
        T == null || T(), d = void 0;
        return;
      }
      e.inert = !0, Tr(e, "outrostart"), p = ka(e, h(), v, 0, () => {
        Tr(e, "outroend"), T == null || T();
      });
    },
    stop: () => {
      v == null || v.abort(), p == null || p.abort();
    }
  }, y = (
    /** @type {Effect} */
    Xe
  );
  if ((y.transitions ?? (y.transitions = [])).push(m), i && Ea) {
    var I = l;
    if (!I) {
      for (var C = (
        /** @type {Effect | null} */
        y.parent
      ); C && C.f & er; )
        for (; (C = C.parent) && !(C.f & Zr); )
          ;
      I = !C || (C.f & Pi) !== 0;
    }
    I && lt(() => {
      Vt(() => m.in());
    });
  }
}
function ka(t, e, r, a, i) {
  var s = a === 1;
  if (Wn(e)) {
    var o, l = !1;
    return Qr(() => {
      if (!l) {
        var y = e({ direction: s ? "in" : "out" });
        o = ka(t, y, r, a, i);
      }
    }), {
      abort: () => {
        l = !0, o == null || o.abort();
      },
      deactivate: () => o.deactivate(),
      reset: () => o.reset(),
      t: () => o.t()
    };
  }
  if (r == null || r.deactivate(), !(e != null && e.duration))
    return i(), {
      abort: pt,
      deactivate: pt,
      reset: pt,
      t: () => a
    };
  const { delay: u = 0, css: d, tick: f, easing: c = Cl } = e;
  var v = [];
  if (s && r === void 0 && (f && f(0, 1), d)) {
    var p = yi(d(0, 1));
    v.push(p, p);
  }
  var h = () => 1 - a, m = t.animate(v, { duration: u, fill: "forwards" });
  return m.onfinish = () => {
    m.cancel();
    var y = (r == null ? void 0 : r.t()) ?? 1 - a;
    r == null || r.abort();
    var I = a - y, C = (
      /** @type {number} */
      e.duration * Math.abs(I)
    ), T = [];
    if (C > 0) {
      var N = !1;
      if (d)
        for (var b = Math.ceil(C / 16.666666666666668), E = 0; E <= b; E += 1) {
          var k = y + I * c(E / b), A = yi(d(k, 1 - k));
          T.push(A), N || (N = A.overflow === "hidden");
        }
      N && (t.style.overflow = "hidden"), h = () => {
        var P = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          m.currentTime
        );
        return y + I * c(P / C);
      }, f && Il(() => {
        if (m.playState !== "running") return !1;
        var P = h();
        return f(P, 1 - P), !0;
      });
    }
    m = t.animate(T, { duration: C, fill: "forwards" }), m.onfinish = () => {
      h = () => a, f == null || f(a, 1 - a), i();
    };
  }, {
    abort: () => {
      m && (m.cancel(), m.effect = null, m.onfinish = pt);
    },
    deactivate: () => {
      i = pt;
    },
    reset: () => {
      a === 0 && (f == null || f(1, 0));
    },
    t: () => h()
  };
}
function Nl(t, e, r = e) {
  var a = tr();
  tl(t, "input", (i) => {
    var s = i ? t.defaultValue : t.value;
    if (s = ga(t) ? pa(s) : s, r(s), a && s !== (s = e())) {
      var o = t.selectionStart, l = t.selectionEnd;
      t.value = s ?? "", l !== null && (t.selectionStart = o, t.selectionEnd = Math.min(l, t.value.length));
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  (Be && t.defaultValue !== t.value || // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  Vt(e) == null && t.value) && r(ga(t) ? pa(t.value) : t.value), rr(() => {
    var i = e();
    ga(t) && i === pa(t.value) || t.type === "date" && !i && !t.value || i !== t.value && (t.value = i ?? "");
  });
}
function ga(t) {
  var e = t.type;
  return e === "number" || e === "range";
}
function pa(t) {
  return t === "" ? null : +t;
}
function Jn(t, e, r) {
  var a = pn(t, e);
  a && a.set && (t[e] = r, Ir(() => {
    t[e] = null;
  }));
}
var En, jn, _r, jr, ms;
const Gr = class Gr {
  /** @param {ResizeObserverOptions} options */
  constructor(e) {
    lr(this, jr);
    /** */
    lr(this, En, /* @__PURE__ */ new WeakMap());
    /** @type {ResizeObserver | undefined} */
    lr(this, jn);
    /** @type {ResizeObserverOptions} */
    lr(this, _r);
    ca(this, _r, e);
  }
  /**
   * @param {Element} element
   * @param {(entry: ResizeObserverEntry) => any} listener
   */
  observe(e, r) {
    var a = dn(this, En).get(e) || /* @__PURE__ */ new Set();
    return a.add(r), dn(this, En).set(e, a), si(this, jr, ms).call(this).observe(e, dn(this, _r)), () => {
      var i = dn(this, En).get(e);
      i.delete(r), i.size === 0 && (dn(this, En).delete(e), dn(this, jn).unobserve(e));
    };
  }
};
En = new WeakMap(), jn = new WeakMap(), _r = new WeakMap(), jr = new WeakSet(), ms = function() {
  return dn(this, jn) ?? ca(this, jn, new ResizeObserver(
    /** @param {any} entries */
    (e) => {
      for (var r of e) {
        Gr.entries.set(r.target, r);
        for (var a of dn(this, En).get(r.target) || [])
          a(r);
      }
    }
  ));
}, /** @static */
ii(Gr, "entries", /* @__PURE__ */ new WeakMap());
let Oa = Gr;
var Tl = /* @__PURE__ */ new Oa({
  box: "border-box"
});
function it(t, e, r) {
  var a = Tl.observe(t, () => r(t[e]));
  lt(() => (Vt(() => r(t[e])), a));
}
function _i(t, e) {
  return t === e || (t == null ? void 0 : t[kn]) === e;
}
function nt(t = {}, e, r, a) {
  return lt(() => {
    var i, s;
    return rr(() => {
      i = s, s = [], Vt(() => {
        t !== r(...s) && (e(t, ...s), i && _i(r(...i), t) && e(null, ...i));
      });
    }), () => {
      Qr(() => {
        s && _i(r(...s), t) && e(null, ...s);
      });
    };
  }), t;
}
function Ya(t, e) {
  el(window, ["resize"], () => na(() => e(window[t])));
}
function Me(t = !1) {
  const e = (
    /** @type {ComponentContextLegacy} */
    Ke
  ), r = e.l.u;
  if (!r) return;
  let a = () => Le(e.s);
  if (t) {
    let i = 0, s = (
      /** @type {Record<string, any>} */
      {}
    );
    const o = /* @__PURE__ */ Gn(() => {
      let l = !1;
      const u = e.s;
      for (const d in u)
        u[d] !== s[d] && (s[d] = u[d], l = !0);
      return l && i++, i;
    });
    a = () => n(o);
  }
  r.b.length && Ho(() => {
    Si(e, a), dr(r.b);
  }), ut(() => {
    const i = Vt(() => r.m.map(Co));
    return () => {
      for (const s of i)
        typeof s == "function" && s();
    };
  }), r.a.length && ut(() => {
    Si(e, a), dr(r.a);
  });
}
function Si(t, e) {
  if (t.l.s)
    for (const r of t.l.s) n(r);
  e();
}
function Vr(t, e) {
  var s;
  var r = (
    /** @type {Record<string, Function[] | Function>} */
    (s = t.$$events) == null ? void 0 : s[e.type]
  ), a = Sr(r) ? r.slice() : r == null ? [] : [r];
  for (var i of a)
    i.call(this, e);
}
function Za(t, e, r) {
  if (t == null)
    return e(void 0), r && r(void 0), pt;
  const a = Vt(
    () => t.subscribe(
      e,
      // @ts-expect-error
      r
    )
  );
  return a.unsubscribe ? () => a.unsubscribe() : a;
}
const qn = [];
function El(t, e) {
  return {
    subscribe: We(t, e).subscribe
  };
}
function We(t, e = pt) {
  let r = null;
  const a = /* @__PURE__ */ new Set();
  function i(l) {
    if (Kr(t, l) && (t = l, r)) {
      const u = !qn.length;
      for (const d of a)
        d[1](), qn.push(d, t);
      if (u) {
        for (let d = 0; d < qn.length; d += 2)
          qn[d][0](qn[d + 1]);
        qn.length = 0;
      }
    }
  }
  function s(l) {
    i(l(
      /** @type {T} */
      t
    ));
  }
  function o(l, u = pt) {
    const d = [l, u];
    return a.add(d), a.size === 1 && (r = e(i, s) || pt), l(
      /** @type {T} */
      t
    ), () => {
      a.delete(d), a.size === 0 && r && (r(), r = null);
    };
  }
  return { set: i, update: s, subscribe: o };
}
function xl(t, e, r) {
  const a = !Array.isArray(t), i = a ? [t] : t;
  if (!i.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const s = e.length < 2;
  return El(r, (o, l) => {
    let u = !1;
    const d = [];
    let f = 0, c = pt;
    const v = () => {
      if (f)
        return;
      c();
      const h = e(a ? d[0] : d, o, l);
      s ? o(h) : c = typeof h == "function" ? h : pt;
    }, p = i.map(
      (h, m) => Za(
        h,
        (y) => {
          d[m] = y, f &= ~(1 << m), u && v();
        },
        () => {
          f |= 1 << m;
        }
      )
    );
    return u = !0, v(), function() {
      dr(p), c(), u = !1;
    };
  });
}
function ys(t) {
  let e;
  return Za(t, (r) => e = r)(), e;
}
let Er = !1, La = Symbol();
function re(t, e, r) {
  const a = r[e] ?? (r[e] = {
    store: null,
    source: /* @__PURE__ */ Y(void 0),
    unsubscribe: pt
  });
  if (a.store !== t && !(La in r))
    if (a.unsubscribe(), a.store = t ?? null, t == null)
      a.source.v = void 0, a.unsubscribe = pt;
    else {
      var i = !0;
      a.unsubscribe = Za(t, (s) => {
        i ? a.source.v = s : O(a.source, s);
      }), i = !1;
    }
  return t && La in r ? ys(t) : n(a.source);
}
function tt(t, e) {
  return t.set(e), e;
}
function ke() {
  const t = {};
  function e() {
    Ir(() => {
      for (var r in t)
        t[r].unsubscribe();
      Ai(t, La, {
        enumerable: !1,
        value: !0
      });
    });
  }
  return [t, e];
}
function kl(t) {
  var e = Er;
  try {
    return Er = !1, [t(), Er];
  } finally {
    Er = e;
  }
}
const Ol = {
  get(t, e) {
    let r = t.props.length;
    for (; r--; ) {
      let a = t.props[r];
      if (Wn(a) && (a = a()), typeof a == "object" && a !== null && e in a) return a[e];
    }
  },
  set(t, e, r) {
    let a = t.props.length;
    for (; a--; ) {
      let i = t.props[a];
      Wn(i) && (i = i());
      const s = pn(i, e);
      if (s && s.set)
        return s.set(r), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(t, e) {
    let r = t.props.length;
    for (; r--; ) {
      let a = t.props[r];
      if (Wn(a) && (a = a()), typeof a == "object" && a !== null && e in a) {
        const i = pn(a, e);
        return i && !i.configurable && (i.configurable = !0), i;
      }
    }
  },
  has(t, e) {
    if (e === kn || e === Bi) return !1;
    for (let r of t.props)
      if (Wn(r) && (r = r()), r != null && e in r) return !0;
    return !1;
  },
  ownKeys(t) {
    const e = [];
    for (let r of t.props)
      if (Wn(r) && (r = r()), !!r) {
        for (const a in r)
          e.includes(a) || e.push(a);
        for (const a of Object.getOwnPropertySymbols(r))
          e.includes(a) || e.push(a);
      }
    return e;
  }
};
function mr(...t) {
  return new Proxy({ props: t }, Ol);
}
function bi(t) {
  var e;
  return ((e = t.ctx) == null ? void 0 : e.d) ?? !1;
}
function g(t, e, r, a) {
  var E;
  var i = (r & co) !== 0, s = !Qn || (r & vo) !== 0, o = (r & go) !== 0, l = (r & po) !== 0, u = !1, d;
  o ? [d, u] = kl(() => (
    /** @type {V} */
    t[e]
  )) : d = /** @type {V} */
  t[e];
  var f = kn in t || Bi in t, c = o && (((E = pn(t, e)) == null ? void 0 : E.set) ?? (f && e in t && ((k) => t[e] = k))) || void 0, v = (
    /** @type {V} */
    a
  ), p = !0, h = !1, m = () => (h = !0, p && (p = !1, l ? v = Vt(
    /** @type {() => V} */
    a
  ) : v = /** @type {V} */
  a), v);
  d === void 0 && a !== void 0 && (c && s && Do(), d = m(), c && c(d));
  var y;
  if (s)
    y = () => {
      var k = (
        /** @type {V} */
        t[e]
      );
      return k === void 0 ? m() : (p = !0, h = !1, k);
    };
  else {
    var I = (i ? Gn : de)(
      () => (
        /** @type {V} */
        t[e]
      )
    );
    I.f |= No, y = () => {
      var k = n(I);
      return k !== void 0 && (v = /** @type {V} */
      void 0), k === void 0 ? v : k;
    };
  }
  if (!(r & fo) && s)
    return y;
  if (c) {
    var C = t.$$legacy;
    return function(k, A) {
      return arguments.length > 0 ? ((!s || !A || C || u) && c(A ? y() : k), k) : y();
    };
  }
  var T = !1, N = /* @__PURE__ */ Y(d), b = /* @__PURE__ */ Gn(() => {
    var k = y(), A = n(N);
    return T ? (T = !1, A) : N.v = k;
  });
  return o && n(b), i || (b.equals = Ha), function(k, A) {
    if (arguments.length > 0) {
      const P = A ? n(b) : s && o ? Tn(k) : k;
      if (!b.equals(P)) {
        if (T = !0, O(N, P), h && v !== void 0 && (v = P), bi(b))
          return k;
        Vt(() => n(b));
      }
      return k;
    }
    return bi(b) ? b.v : n(b);
  };
}
function aa() {
  if (typeof window < "u") {
    const { protocol: t, hostname: e, pathname: r } = window.location;
    return `${t}//${e}${r}`;
  }
  return "";
}
function Kn(t, e) {
  if (typeof window < "u") {
    const { protocol: r, hostname: a } = window.location, i = `${r}//${a}`, s = new URL(t, i), o = new URL(e, i), l = `${s.protocol}//${s.hostname}${s.pathname}`, u = `${o.protocol}//${o.hostname}${o.pathname}`;
    return l === u;
  }
  return !1;
}
function _s(t) {
  return typeof t != "string" ? "production" : t.includes("localhost") ? "development" : t.includes("squareupstaging") ? "staging" : "production";
}
function Ll(t = !1) {
  const e = We(t);
  return Mt("LOGGED_IN", e), e;
}
function ln() {
  return Lt("LOGGED_IN") || We(!1);
}
function Ml(t = {}) {
  const e = We(t);
  return Mt("NAV_STATE", e), e;
}
function Jt() {
  return Lt("NAV_STATE") || We({});
}
function Al(t = 0) {
  const e = We(t);
  return Mt("CART_COUNT", e), e;
}
function Kt() {
  return Lt("CART_COUNT") || We(0);
}
function Dl(t = 0) {
  const e = We(t);
  return Mt("DRAWER_TOP", e), e;
}
function Rl() {
  return Lt("DRAWER_TOP") || We(0);
}
function Pl(t) {
  const e = We(t || aa());
  return Mt("CURRENT_URL", e), e;
}
function Ja() {
  return Lt("CURRENT_URL") || We(aa());
}
const Ss = We(0), Un = We(/* @__PURE__ */ new Map()), ia = We(/* @__PURE__ */ new Map());
function Ul(t) {
  if (t)
    try {
      ia.set(new Map(Object.entries(JSON.parse(t))));
    } catch (e) {
      console.error("Error parsing flags", e);
    }
}
function Bl(t) {
  const e = We(t);
  return Mt("FLATTENED_NAV_RENDER_STATE", e), e;
}
function Vl() {
  return Lt("FLATTENED_NAV_RENDER_STATE") || We(!1);
}
function bs(t) {
  const e = We(t);
  return Mt("ACCESSIBILITY_REDESIGN_RENDER_STATE", e), e;
}
function Xt() {
  return Lt("ACCESSIBILITY_REDESIGN_RENDER_STATE") || We(!1);
}
const ot = {
  MAIN_NAVIGATION: "Main Navigation",
  MAIN_NAVIGATION_MENU: "Main Navigation Menu",
  SUBNAVIGATION: "Subnavigation",
  SUBNAVIGATION_MENU: "Subnavigation Menu",
  IMAGE_SUBNAVIGATION: "Image Subnavigation"
}, ha = 1280, Is = 100, ws = 300;
function wt(t, [e, r, a, i]) {
  let s, o;
  const l = () => {
    clearTimeout(o), s = setTimeout(e, a);
  }, u = () => {
    clearTimeout(s), o = setTimeout(r, i);
  };
  return t.addEventListener("mouseenter", l), t.addEventListener("mouseleave", u), {
    destroy() {
      clearTimeout(s), clearTimeout(o), t.removeEventListener("mouseenter", l), t.removeEventListener("mouseleave", u);
    }
  };
}
function Ct(t, e) {
  const r = (a) => {
    t.contains(a.target) || e();
  };
  return window.addEventListener("click", r), {
    destroy() {
      window.removeEventListener("click", r);
    }
  };
}
function Fl() {
  const t = (e) => {
    typeof window < "u" && window.Sq && window.Sq.Tracking && window.Sq.Tracking.config && window.Sq.Tracking.cdp ? e() : setTimeout(() => t(e), 100);
  };
  return new Promise(t);
}
function Hl() {
  const t = (e) => {
    typeof window > "u" ? setTimeout(() => t(e), 100) : e();
  };
  return new Promise(t);
}
const zl = (t) => {
  const e = {};
  for (const [r, a] of Object.entries(t))
    a !== void 0 && (e[r] = a);
  return e;
}, ql = (t) => t === null || !Array.isArray(t) || t.length === 0 ? !1 : t[0] === "*" ? !0 : t.includes(window.location.pathname);
async function st({ eventName: t, properties: e = {} }) {
  await Hl();
  const r = ys(ia), a = r.get("xms2-enable-pwt"), i = r.get("xmsfe-enable-pwt"), s = r.get("xmsfe-pwt-page-allow-list"), o = !!a || !!i && ql(s), l = zl(e);
  o ? window.Sq.Tracking.track(
    {
      action: t,
      properties: l
    },
    { destinations: ["cdp"] }
  ) : (await Fl(), window.Sq.Tracking.cdp.track(t, l));
}
const yr = 240;
var Wl = /* @__PURE__ */ x("<div><!></div>");
function Ka(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$accessibilityRedesignRenderStore", r);
  let s = g(e, "alignment", 8, "left"), o = g(e, "isOpen", 8, !1), l = g(e, "width", 8, yr);
  const u = Xt();
  Me();
  var d = Wl();
  let f;
  var c = S(d);
  ra(c, e, "default", {}), _(d), L(
    (v) => {
      f = j(d, 1, `Flyout align-${s() ?? ""}`, "svelte-1asol2m", f, v), Te(d, `width: ${l() ?? ""}px; visibility: var(--flyout-visibility, hidden);`);
    },
    [
      () => ({
        isOpen: o(),
        "flyout-animation": !i(),
        "flyout-accessibility-redesign": i()
      })
    ],
    de
  ), w(t, d), le(), a();
}
function xe(t) {
  const e = (r) => {
    r.detail !== 0 && t.blur();
  };
  return t.addEventListener("click", e), {
    destroy() {
      t.removeEventListener("click", e);
    }
  };
}
function ct(t, e) {
  let r = !1;
  function a() {
    r = !0;
  }
  function i() {
    r = !1;
  }
  function s(o) {
    r && (o.preventDefault(), e());
  }
  return t.addEventListener("click", e), t.addEventListener("touchstart", a, { passive: !0 }), t.addEventListener("touchmove", i, { passive: !0 }), t.addEventListener("touchcancel", i, { passive: !0 }), t.addEventListener("touchend", s), {
    destroy() {
      t.removeEventListener("click", e), t.removeEventListener("touchstart", a), t.removeEventListener("touchmove", i), t.removeEventListener("touchcancel", i), t.removeEventListener("touchend", s);
    }
  };
}
var jl = /* @__PURE__ */ Cn(`<path d="M1 1c-.6 0-1 .4-1 1s.4 1 1 1h1.7c.1 0 .3 0 .5.5.1.2.2.5.2.8l.1.3c0
      .2.1.4.1.6.1.5.8 2.9 1.5 5.2l.9 3.1.2.7-.2.2c-.5.5-.8 1.3-.8 2.4 0 1.8 1.7
      3.2 3.3 3.2H20c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2h3c.6 0 1-.4
      1-1s-.4-1-1-1H8.5c-.7 0-1.3-.6-1.3-1.2 0-.7.2-1 .3-1.1l.1-.1 15.4-.8c.6 0
      1-.5.9-1.1 0-.5-.5-.9-1-.9h-.3L24
      5.2c.1-.5-.3-1.1-.8-1.2H5.4v-.1c-.1-.4-.2-.8-.4-1.2C4.7 2 4.1 1 2.7
      1H1zm5.6 7.2L5.9 6h15.9l-1.2 6.9-12.5.6-.2-.6c-.4-1.5-.9-3.1-1.3-4.7zM8
      24c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" fill-rule="evenodd" clip-rule="evenodd"></path>`), Gl = /* @__PURE__ */ Cn(
  `<circle cx="8" cy="22" r="2"></circle><path d="M23.6 19.8c-1.6-.3-3.2-.9-4.5-1.8H8.5c-.7 0-1.3-.6-1.3-1.2 0-.7.2-1
      .3-1.1l.1-.1
      8.2-.4c-.5-.6-.9-1.2-1.3-1.9l-6.5.3-.2-.6c-.3-1.6-.8-3.2-1.2-4.8L5.9
      6H13c.1-.7.2-1.4.3-2h-8v-.1c0-.4-.1-.8-.3-1.2C4.7 2 4.1 1 2.7 1H1c-.6 0-1
      .4-1 1s.4 1 1 1h1.7c.1 0 .3 0 .5.5.1.2.2.5.2.8l.1.3c0 .2.1.4.1.6.1.5.8 2.9
      1.5 5.2l.9 3.1.2.7-.2.2c-.5.5-.8 1.3-.8 2.4 0 1.8 1.7 3.2 3.3 3.2H23c.2 0
      .4-.1.6-.2z"></path><circle cx="20" cy="22" r="2"></circle>`,
  1
), Yl = /* @__PURE__ */ Cn('<svg class="Icon svelte-1stu2wu" width="24" height="24" viewBox="0 0 24 24" fill="black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><!></svg>');
function Zl(t, e) {
  let r = g(e, "isEmpty", 8, !0);
  var a = Yl(), i = S(a);
  {
    var s = (l) => {
      var u = jl();
      w(l, u);
    }, o = (l) => {
      var u = Gl();
      wn(2), w(l, u);
    };
    F(i, (l) => {
      r() ? l(s) : l(o, !1);
    });
  }
  _(a), w(t, a);
}
function Cs(t) {
  const e = t - 1;
  return e * e * e + 1;
}
function Ii(t) {
  const e = typeof t == "string" && t.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return e ? [parseFloat(e[1]), e[2] || "px"] : [
    /** @type {number} */
    t,
    "px"
  ];
}
function wi(t, { delay: e = 0, duration: r = 400, easing: a = Cs, x: i = 0, y: s = 0, opacity: o = 0 } = {}) {
  const l = getComputedStyle(t), u = +l.opacity, d = l.transform === "none" ? "" : l.transform, f = u * (1 - o), [c, v] = Ii(i), [p, h] = Ii(s);
  return {
    delay: e,
    duration: r,
    easing: a,
    css: (m, y) => `
			transform: ${d} translate(${(1 - m) * c}${v}, ${(1 - m) * p}${h});
			opacity: ${u - f * y}`
  };
}
function Ns(t, { delay: e = 0, duration: r = 400, easing: a = Cs, start: i = 0, opacity: s = 0 } = {}) {
  const o = getComputedStyle(t), l = +o.opacity, u = o.transform === "none" ? "" : o.transform, d = 1 - i, f = l * (1 - s);
  return {
    delay: e,
    duration: r,
    easing: a,
    css: (c, v) => `
			transform: ${u} scale(${1 - d * v});
			opacity: ${l - f * v}
		`
  };
}
function Ts(t) {
  return --t * t * ((1.70158 + 1) * t + 1.70158) + 1;
}
function Jl(t) {
  return t * t * t * t * t;
}
function Kl(t) {
  return --t * t * t * t * t + 1;
}
var Xl = /* @__PURE__ */ x('<span class="Count svelte-16zabi4" aria-hidden="true"> </span>');
function Ql(t, e) {
  let r = g(e, "count", 8, 0);
  const a = { duration: 250, easing: Ts };
  var i = Xl(), s = S(i, !0);
  _(i), L(() => fe(s, r())), Br(1, i, () => Ns, () => a), w(t, i);
}
var $l = /* @__PURE__ */ x('<button type="button" aria-haspopup="true"><!> <!> <span class="title svelte-1hbomqf"> </span></button>');
function Es(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$accessibilityRedesignRenderStore", r), s = () => re(l, "$countStore", r), o = Vn(), l = Kt(), u = Xt();
  let d = g(e, "isOpen", 8, !1), f = g(e, "title", 8, "Your cart"), c = g(e, "url", 8, "");
  function v() {
    o("toggle");
  }
  function p(E) {
    c() && E.detail !== 0 && (window.location = c());
  }
  Me();
  var h = $l();
  let m;
  var y = S(h);
  const I = /* @__PURE__ */ de(() => s() === 0);
  Zl(y, {
    get isEmpty() {
      return n(I);
    }
  });
  var C = H(y, 2);
  {
    var T = (E) => {
      Ql(E, {
        get count() {
          return s();
        }
      });
    };
    F(C, (E) => {
      s() > 0 && E(T);
    });
  }
  var N = H(C, 2), b = S(N, !0);
  _(N), _(h), lt(() => at("click", h, p)), ne(h, (E, k) => ct == null ? void 0 : ct(E, k), () => v), ne(h, (E) => xe == null ? void 0 : xe(E)), L(
    (E) => {
      m = j(h, 1, "Toggle nav-button svelte-1hbomqf", null, m, E), D(h, "aria-expanded", d()), fe(b, f());
    },
    [
      () => ({
        isOpen: d(),
        "focus-highlight": !i(),
        "toggle-accessibility-redesign": i()
      })
    ],
    de
  ), w(t, h), le(), a();
}
var eu = /* @__PURE__ */ x('<div class="Status svelte-1xpjiki"><div class="title svelte-1xpjiki"> </div> <div class="message svelte-1xpjiki"> </div></div>');
function xs(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$countStore", r), s = /* @__PURE__ */ Y();
  let o = g(e, "title", 8, "Your cart"), l = g(e, "statusZero", 8, "{count} items"), u = g(e, "statusOne", 8, "{count} item"), d = g(e, "statusMany", 8, "{count} items");
  const f = Kt();
  function c(I) {
    switch (I) {
      case 0:
        return l().replace(/{count}/, I);
      case 1:
        return u().replace(/{count}/, I);
      default:
        return d().replace(/{count}/, I);
    }
  }
  ae(() => i(), () => {
    O(s, c(i()));
  }), et(), Me();
  var v = eu(), p = S(v), h = S(p, !0);
  _(p);
  var m = H(p, 2), y = S(m, !0);
  _(m), _(v), L(() => {
    fe(h, o()), fe(y, n(s));
  }), w(t, v), le(), a();
}
function Xa({ item: t, loggedIn: e = !1, cartCount: r = 0 }) {
  return !(!t || t.disabled || t.hideWhenLoggedIn && e || t.hideWhenLoggedOut && !e || t.hideWhenCartEmpty && r === 0 || t.hideWhenCartNotEmpty && r !== 0);
}
function ks({ data: t, currentUrl: e = aa(), loggedIn: r = !1, cartCount: a = 0 }) {
  return !!t.cta && // CTA is not filtered out by logged in or cart state
  Xa({
    item: t.cta,
    loggedIn: r,
    cartCount: a
  }) && // CTA should not be hidden due to current URL
  (t.showCtaOnCtaPage || !Kn(t.cta.url, e));
}
function Os({ data: t, loggedIn: e = !1, cartCount: r = 0 }) {
  return !!t.secondaryCta && // CTA is not filtered out by logged in or cart state
  Xa({
    item: t.secondaryCta,
    loggedIn: e,
    cartCount: r
  });
}
function un({ items: t = [], loggedIn: e = !1, cartCount: r = 0 }) {
  return t ? t.filter(
    (a) => Xa({
      item: a,
      loggedIn: e,
      cartCount: r
    })
  ) : [];
}
function Ft(t) {
  return Cr(t, "data-category");
}
function tu(t) {
  return Cr(t, "data-dynamic-variation");
}
function Ht(t) {
  return Cr(t, "data-subcategory");
}
function nu(t) {
  return Cr(t, "data-component-type");
}
function zt(t) {
  return Cr(t, "data-nav-device-type");
}
function ru(t) {
  return !!t.closest(".isSticky");
}
function Cr(t, e) {
  if (t)
    return t.closest(`[${e}]`) ? t.closest(`[${e}]`).getAttribute(e) : void 0;
}
function be(t, e = {}) {
  const r = () => {
    st({
      eventName: "Click Top Navigation Link",
      properties: {
        linkId: e.id,
        linkText: e.title,
        linkUrl: e.url.includes("http") ? e.url : `${window.location.origin}${e.url}`,
        linkCategory: Ft(t),
        linkSubcategory: Ht(t),
        linkLocation: nu(t),
        navDeviceType: zt(t),
        isNavSticky: ru(t),
        dynamicVariation: tu(t)
      }
    });
  };
  return t.addEventListener("click", r), {
    // Updates the data object used in the action whenever the data parameter is changed
    update(a) {
      e = a;
    },
    destroy() {
      t.removeEventListener("click", r);
    }
  };
}
var au = /* @__PURE__ */ x('<div class="icon svelte-1bvm1sq"></div>'), iu = /* @__PURE__ */ x('<a><!> <span class="title svelte-1bvm1sq"> </span></a>');
function an(t, e) {
  oe(e, !1);
  let r = g(e, "id", 8, void 0), a = g(e, "icon", 8, void 0), i = g(e, "title", 8, void 0), s = g(e, "url", 8, "#"), o = g(e, "linkStyle", 8, "primary"), l = g(e, "width", 8, "auto");
  Me();
  var u = iu(), d = S(u);
  {
    var f = (p) => {
      var h = au();
      L(() => Te(h, `--icon-url: url('${a().s3BaseUrl ?? ""}${a().name ?? ""}.svg')`)), w(p, h);
    };
    F(d, (p) => {
      a() && a().s3BaseUrl && a().name && p(f);
    });
  }
  var c = H(d, 2), v = S(c, !0);
  _(c), _(u), lt(() => at("blur", u, function(p) {
    Vr.call(this, e, p);
  })), lt(() => at("focus", u, function(p) {
    Vr.call(this, e, p);
  })), ne(u, (p) => xe == null ? void 0 : xe(p)), ne(u, (p, h) => be == null ? void 0 : be(p, h), () => ({
    id: r(),
    title: i(),
    url: s()
  })), L(() => {
    D(u, "id", r()), D(u, "href", s()), j(u, 1, `ButtonLink ${o() ?? ""}`, "svelte-1bvm1sq"), Te(u, `width: ${l() ?? ""};`), fe(v, i());
  }), w(t, u), le();
}
var su = /* @__PURE__ */ x('<span class="description svelte-10f4l93"> </span>'), ou = /* @__PURE__ */ x("<a><span> </span> <!></a>");
function lu(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$navStateStore", r), s = () => re(c, "$accessibilityRedesignRenderStore", r);
  let o = g(e, "id", 8), l = g(e, "title", 8), u = g(e, "url", 8), d = g(e, "description", 8);
  const f = Jt(), c = Xt();
  function v() {
    tt(f, { ...i(), subcategory: null });
  }
  Me();
  var p = ou();
  let h;
  var m = S(p);
  let y;
  var I = S(m, !0);
  _(m);
  var C = H(m, 2);
  {
    var T = (N) => {
      var b = su(), E = S(b, !0);
      _(b), L(() => fe(E, d())), w(N, b);
    };
    F(C, (N) => {
      d() && N(T);
    });
  }
  _(p), lt(() => at("mouseover", p, v)), ne(p, (N, b) => be == null ? void 0 : be(N, b), () => ({
    id: o(),
    title: l(),
    url: u()
  })), L(
    (N, b) => {
      D(p, "id", o()), h = j(p, 1, "CategoryLink svelte-10f4l93", null, h, N), D(p, "href", u()), y = j(m, 1, "svelte-10f4l93", null, y, b), fe(I, l());
    },
    [
      () => ({
        "focus-highlight": !s(),
        "focus-accessibility-redesign": s()
      }),
      () => ({
        title: !s(),
        "title-accessibility-redesign": s()
      })
    ],
    de
  ), w(t, p), le(), a();
}
var uu = /* @__PURE__ */ x("<div></div>"), cu = /* @__PURE__ */ x('<li><a class="link svelte-1syx3vl"><span class="title svelte-1syx3vl"> </span></a></li>'), vu = /* @__PURE__ */ x('<!> <div><div><ul class="SubcategoryList svelte-1syx3vl"></ul></div></div>', 1);
function du(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$loggedInStore", r), s = () => re(c, "$cartCountStore", r), o = /* @__PURE__ */ Y();
  let l = g(e, "navItems", 24, () => []), u = g(e, "isOpen", 8, !1), d = g(e, "hasDescriptions", 8, !0);
  const f = ln(), c = Kt();
  let v = /* @__PURE__ */ Y();
  ae(
    () => (Le(l()), i(), s()),
    () => {
      O(o, un({
        items: l(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), ae(
    () => (Le(u()), n(v)),
    () => {
      u() && tt(Ss, n(v) + 15 * 2);
    }
  ), et(), Me();
  var p = vu(), h = ye(p);
  {
    var m = (N) => {
      var b = uu();
      let E;
      L(
        (k) => E = j(b, 1, "leftBorder svelte-1syx3vl", null, E, k),
        [
          () => ({ noDescriptions: !d() })
        ],
        de
      ), w(N, b);
    };
    F(h, (N) => {
      u() && N(m);
    });
  }
  var y = H(h, 2);
  let I;
  var C = S(y), T = S(C);
  qe(T, 5, () => n(o), (N) => N, (N, b) => {
    var E = cu();
    let k;
    var A = S(E), P = S(A), M = S(P, !0);
    _(P), _(A), ne(A, (z, B) => be == null ? void 0 : be(z, B), () => ({
      id: n(b).id,
      title: n(b).title,
      url: n(b).url
    })), _(E), L(
      (z) => {
        k = j(E, 1, "svelte-1syx3vl", null, k, z), D(A, "id", n(b).id), D(A, "href", n(b).url), fe(M, n(b).title);
      },
      [() => ({ hidden: n(b).hidden })],
      de
    ), w(N, E);
  }), _(T), _(C), _(y), L(
    (N) => I = j(y, 1, "SubcategoryListContainer svelte-1syx3vl", null, I, N),
    [
      () => ({
        isOpen: u(),
        noDescriptions: !d()
      })
    ],
    de
  ), it(C, "clientHeight", (N) => O(v, N)), w(t, p), le(), a();
}
var fu = /* @__PURE__ */ x('<span class="description svelte-c7flwi"> </span>'), gu = /* @__PURE__ */ x('<div><button aria-haspopup="true"><span class="title svelte-c7flwi"> </span> <!></button> <!></div>');
function pu(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(v, "$navStateStore", r), s = /* @__PURE__ */ Y();
  let o = g(e, "id", 8), l = g(e, "title", 8), u = g(e, "description", 8), d = g(e, "navItems", 24, () => []);
  const f = 0, c = 300, v = Jt(), p = { menuId: o(), menuText: l() };
  let h = /* @__PURE__ */ Y(), m = /* @__PURE__ */ Y(!1);
  function y() {
    n(m) || (O(m, !0), tt(v, {
      ...i(),
      subcategory: n(h)
      // Set current subcategory
    }), st({
      eventName: "Open Menu",
      properties: {
        ...p,
        menuCategory: Ft(n(h)),
        menuSubcategory: Ht(n(h)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(h))
      }
    }));
  }
  function I() {
    n(m) && (O(m, !1), n(s) && tt(v, {
      ...i(),
      subcategory: null
      // Clear current subcategory
    }), st({
      eventName: "Close Menu",
      properties: {
        ...p,
        menuCategory: Ft(n(h)),
        menuSubcategory: Ht(n(h)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(h))
      }
    }));
  }
  function C() {
    n(m) ? I() : y();
  }
  ae(() => (i(), n(h)), () => {
    O(s, i().subcategory === n(h));
  }), ae(
    () => (n(m), n(s)),
    () => {
      n(m) && !n(s) && I();
    }
  ), et(), Me();
  var T = gu();
  let N;
  var b = S(T);
  let E;
  var k = S(b), A = S(k, !0);
  _(k);
  var P = H(k, 2);
  {
    var M = (G) => {
      var R = fu(), W = S(R, !0);
      _(R), L(() => fe(W, u())), w(G, R);
    };
    F(P, (G) => {
      u() && G(M);
    });
  }
  _(b), ne(b, (G, R) => ct == null ? void 0 : ct(G, R), () => C);
  var z = H(b, 2);
  const B = /* @__PURE__ */ de(() => !!u());
  du(z, {
    get isOpen() {
      return n(m);
    },
    get navItems() {
      return d();
    },
    get hasDescriptions() {
      return n(B);
    }
  }), _(T), nt(T, (G) => O(h, G), () => n(h)), ne(T, (G, R) => wt == null ? void 0 : wt(G, R), () => [
    y,
    I,
    f,
    c
  ]), ne(T, (G, R) => Ct == null ? void 0 : Ct(G, R), () => I), L(
    (G, R) => {
      D(T, "id", o()), N = j(T, 1, "Subcategory svelte-c7flwi", null, N, G), D(T, "data-subcategory", l()), E = j(b, 1, "toggle nav-button svelte-c7flwi", null, E, R), D(b, "aria-expanded", !!n(m)), fe(A, l());
    },
    [
      () => ({ isOpen: n(m) }),
      () => ({
        isOpen: n(m),
        noDescriptions: !u()
      })
    ],
    de
  ), w(t, T), le(), a();
}
var hu = /* @__PURE__ */ x("<li><!></li>"), mu = /* @__PURE__ */ x("<li><!></li>"), yu = /* @__PURE__ */ x("<li><!></li>"), _u = /* @__PURE__ */ x("<ul></ul>");
function Fr(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(y, "$accessibilityRedesignRenderStore", r), s = () => re(p, "$loggedInStore", r), o = () => re(h, "$cartCountStore", r), l = () => re(Ss, "$subcategoryHeight", r), u = () => re(m, "$navStateStore", r), d = /* @__PURE__ */ Y(), f = /* @__PURE__ */ Y(), c = /* @__PURE__ */ Y(), v = /* @__PURE__ */ Y(), p = ln(), h = Kt(), m = Jt(), y = Xt();
  let I = g(e, "navItems", 24, () => []), C = g(e, "cartPrimary", 8, !1), T = g(e, "cartSecondary", 8, !1), N = g(e, "isOpen", 8, !1);
  const b = 0;
  ae(() => Le(C()), () => {
    O(d, !C());
  }), ae(
    () => (Le(T()), i()),
    () => {
      O(f, T() && !i());
    }
  ), ae(
    () => (Le(I()), s(), o()),
    () => {
      O(c, un({
        items: I(),
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), ae(
    () => (l(), u()),
    () => {
      O(v, `min-height: ${l() > 0 && u().subcategory ? l() : b}px;`);
    }
  ), et(), Me();
  var E = _u();
  let k;
  qe(E, 5, () => n(c), (A) => A, (A, P) => {
    var M = Ze(), z = ye(M);
    {
      var B = (R) => {
        var W = hu();
        let K;
        var Q = S(W);
        pu(Q, {
          get id() {
            return n(P).id;
          },
          get title() {
            return n(P).title;
          },
          get navItems() {
            return n(P).navItems;
          },
          get description() {
            return n(P).description;
          }
        }), _(W), L((V) => K = j(W, 1, "category-item svelte-8k7lf4", null, K, V), [() => ({ hidden: n(P).hidden })], de), w(R, W);
      }, G = (R, W) => {
        {
          var K = (Q) => {
            var V = Ze(), U = ye(V);
            {
              var J = (ee) => {
                var Ee = mu();
                let Ie;
                var Ae = S(Ee);
                an(Ae, {
                  get id() {
                    return n(P).id;
                  },
                  get title() {
                    return n(P).title;
                  },
                  get url() {
                    return n(P).url;
                  },
                  get linkStyle() {
                    return n(P).linkStyle;
                  },
                  width: "100%"
                }), _(Ee), L((je) => Ie = j(Ee, 1, "button-item svelte-8k7lf4", null, Ie, je), [() => ({ hidden: n(P).hidden })], de), w(ee, Ee);
              }, X = (ee) => {
                var Ee = yu();
                let Ie;
                var Ae = S(Ee);
                lu(Ae, {
                  get id() {
                    return n(P).id;
                  },
                  get title() {
                    return n(P).title;
                  },
                  get url() {
                    return n(P).url;
                  },
                  get description() {
                    return n(P).description;
                  }
                }), _(Ee), L((je) => Ie = j(Ee, 1, "link-item svelte-8k7lf4", null, Ie, je), [() => ({ hidden: n(P).hidden })], de), w(ee, Ee);
              };
              F(U, (ee) => {
                n(P).linkStyle === "primary" || n(P).linkStyle === "secondary" ? ee(J) : ee(X, !1);
              });
            }
            w(Q, V);
          };
          F(
            R,
            (Q) => {
              n(P).type === "link" && Q(K);
            },
            W
          );
        }
      };
      F(z, (R) => {
        n(P).type === "category" ? R(B) : R(G, !1);
      });
    }
    w(A, M);
  }), _(E), L(
    (A) => {
      k = j(E, 1, "CategoryList svelte-8k7lf4", null, k, A), Te(E, n(v));
    },
    [
      () => ({
        padTop: n(d),
        borderTop: n(f),
        isOpen: N() && i(),
        "category-list-accessibility-redesign": i() && !C() && !T()
      })
    ],
    de
  ), w(t, E), le(), a();
}
var Su = /* @__PURE__ */ x("<!> <!> <!>", 1), bu = /* @__PURE__ */ x("<div><!> <!></div>");
function Iu(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$navStateStore", r), s = /* @__PURE__ */ Y();
  let o = g(e, "data", 24, () => ({}));
  const l = 280, u = 100, d = 300, f = Jt();
  let c = /* @__PURE__ */ Y(), v = /* @__PURE__ */ Y(!1);
  function p() {
    n(v) || (O(v, !0), Un.update((N) => N.set(o().id, n(v))), tt(f, {
      ...i(),
      category: n(c),
      // Set current category
      subcategory: null
      // Clear current subcategory
    }), st({ eventName: "Open Desktop Cart" }));
  }
  function h() {
    n(v) && (O(v, !1), Un.update((N) => N.set(o().id, n(v))), st({ eventName: "Close Desktop Cart" }));
  }
  function m() {
    n(v) ? h() : p();
  }
  ae(() => (i(), n(c)), () => {
    O(s, i().category === n(c));
  }), ae(
    () => (n(v), n(s)),
    () => {
      n(v) && !n(s) && h();
    }
  ), et(), Me();
  var y = bu();
  let I;
  var C = S(y);
  Es(C, {
    get isOpen() {
      return n(v);
    },
    get title() {
      return o().title;
    },
    get url() {
      return o().url;
    },
    $$events: { toggle: m }
  });
  var T = H(C, 2);
  Ka(T, {
    get isOpen() {
      return n(v);
    },
    width: l,
    alignment: "right",
    children: (N, b) => {
      var E = Su(), k = ye(E);
      xs(k, {
        get title() {
          return o().title;
        },
        get statusZero() {
          return o().statusZero;
        },
        get statusOne() {
          return o().statusOne;
        },
        get statusMany() {
          return o().statusMany;
        }
      });
      var A = H(k, 2);
      {
        var P = (B) => {
          Fr(B, {
            get navItems() {
              return o().primaryNavItems;
            },
            cartPrimary: !0
          });
        };
        F(A, (B) => {
          o().primaryNavItems && B(P);
        });
      }
      var M = H(A, 2);
      {
        var z = (B) => {
          Fr(B, {
            get navItems() {
              return o().secondaryNavItems;
            },
            cartSecondary: !0
          });
        };
        F(M, (B) => {
          o().secondaryNavItems && B(z);
        });
      }
      w(N, E);
    },
    $$slots: { default: !0 }
  }), _(y), nt(y, (N) => O(c, N), () => n(c)), ne(y, (N, b) => wt == null ? void 0 : wt(N, b), () => [
    p,
    h,
    u,
    d
  ]), ne(y, (N, b) => Ct == null ? void 0 : Ct(N, b), () => h), L(
    (N) => {
      D(y, "id", o().id), I = j(y, 1, "Cart svelte-s0yl2d", null, I, N), D(y, "data-component-type", ot.MAIN_NAVIGATION_MENU);
    },
    [() => ({ isOpen: n(v) })],
    de
  ), w(t, y), le(), a();
}
var wu = /* @__PURE__ */ x('<svg class="DeveloperLockup svelte-1glg13o" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 322.6 39" height="22"><path fill="black" d="m32.5,0H6.5C2.9,0,0,2.9,0,6.5v26c0,3.6,2.9,6.5,6.5,6.5h26c3.6,0,6.5-2.9,6.5-6.5V6.5c0-3.6-2.8-6.5-6.5-6.5Zm-.5,29.9c0,1.1-.9,2.1-2.1,2.1H9.2c-1.1,0-2.1-.9-2.1-2.1V9.1c0-1.1.9-2.1,2.1-2.1h20.8c1.1,0,2.1.9,2.1,2.1v20.8h0Zm-8.3-5.1c.7,0,1.2-.5,1.2-1.2v-8.3c0-.7-.5-1.2-1.2-1.2h-8.3c-.7,0-1.2.5-1.2,1.2v8.3c0,.7.5,1.2,1.2,1.2h8.3Zm25.7-.6h4.3c.2,2.4,1.9,4.3,5.2,4.3s4.8-1.5,4.8-3.7-1.4-3-4-3.6l-3.3-.7c-3.6-.8-6.3-3.1-6.3-6.9s3.7-7,8.5-7,8.4,2.7,8.6,6.6h-4.1c-.5-1.8-2-2.9-4.5-2.9s-4.4,1.4-4.4,3.2,1.6,2.9,4.3,3.5l3.3.7c3.6.8,6.1,2.9,6.1,6.8s-3.6,7.7-8.8,7.7c-6.1,0-9.3-3.1-9.7-8Zm33.5,14.8v-7.1l.3-3.1h-.3c-1,2.2-3,3.4-5.8,3.4-4.5,0-7.9-3.7-7.9-9.3s3.4-9.3,7.9-9.3,4.7,1.3,5.8,3.3h.3v-3h3.7v24.9c0,.2-4,.2-4,.2Zm.2-16c0-3.6-2.2-5.7-4.9-5.7s-4.9,2.1-4.9,5.7,2.2,5.7,4.9,5.7,4.9-2.1,4.9-5.7Zm6.8,1.9v-10.8h4v10.4c0,2.8,1.4,4.2,3.6,4.2s4.6-2,4.6-5.1v-9.5h4v17.9h-3.7v-3.7h-.3c-.9,2.4-2.8,4.1-5.8,4.1-4.2-.1-6.4-2.8-6.4-7.5Zm18.6,2.1c0-3.3,2.3-5.3,6.5-5.6l4.9-.3v-1.4c0-1.7-1.2-2.7-3.4-2.7s-3.2,1-3.5,2.4h-4c.4-3.6,3.4-5.7,7.5-5.7s7.4,1.9,7.4,5.7v12.5h-3.7v-3.3h-.3c-.8,2.2-2.6,3.7-5.9,3.7-3.2,0-5.5-2.2-5.5-5.3Zm11.4-2.2v-1l-4,.3c-2.2,0-3.1.9-3.1,2.6s1.1,2.3,2.7,2.3c2.8,0,4.4-1.8,4.4-4.2Zm6.9,7.2V14.1h3.7v3.4h.3c.5-2.3,2.3-3.4,4.9-3.4h1.8v3.6h-2.3c-2.6,0-4.5,1.7-4.5,4.8v9.4c.1,0-3.9,0-3.9,0Zm29-8.2h-13.6c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.6,3.6,8.6,8.1c0,.8,0,1.2,0,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.9,4.2h9.6Z" class="svelte-1glg13o"></path><g><path fill="black" d="m166.1,32V7.5h7.8c7.1,0,11.9,4.5,11.9,12.2s-4.8,12.2-11.9,12.2h-7.8Zm4.1-3.7h3.6c4.5,0,7.8-2.9,7.8-8.5s-3.3-8.5-7.8-8.5h-3.6v17Z" class="svelte-1glg13o"></path><path fill="black" d="m205.5,23.8h-13.5c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.7,3.6,8.7,8.1-.1,1.2-.2,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.8,4.2h9.5Z" class="svelte-1glg13o"></path><path fill="black" d="m212.6,32l-6.3-17.9h4.4l3.6,10.7.6,2.5h.3l.7-2.5,3.6-10.7h4.4l-6.3,17.9h-5Z" class="svelte-1glg13o"></path><path fill="black" d="m241.7,23.8h-13.6c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.7,3.6,8.7,8.1c0,.8-.1,1.2-.1,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.8,4.2h9.5Z" class="svelte-1glg13o"></path><path fill="black" d="m244.5,32V7.2h4v24.8h-4Z" class="svelte-1glg13o"></path><path fill="black" d="m251.1,23c0-5.4,3.6-9.3,9-9.3s8.9,3.8,8.9,9.3-3.6,9.3-8.9,9.3-9-3.8-9-9.3Zm13.8,0c0-3.7-2.2-5.7-4.9-5.7s-4.9,2-4.9,5.7,2.2,5.7,4.9,5.7c2.7,0,4.9-2,4.9-5.7Z" class="svelte-1glg13o"></path><path fill="black" d="m271.6,38.5V14.1h3.7v3h.3c1.1-2.1,3-3.4,5.8-3.4,4.5,0,7.8,3.7,7.8,9.3s-3.3,9.3-7.8,9.3-4.8-1.3-5.8-3.3h-.3l.3,3v6.6h-4Zm13.6-15.6c0-3.6-2.2-5.7-4.9-5.7s-4.9,2.1-4.9,5.7,2.2,5.7,4.9,5.7c2.7,0,4.9-2.1,4.9-5.7Z" class="svelte-1glg13o"></path><path fill="black" d="m309,23.8h-13.6c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.7,3.6,8.7,8.1,0,1.2-.1,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.8,4.2h9.5Z" class="svelte-1glg13o"></path><path fill="black" d="m311.8,32V14.1h3.7v3.4h.3c.5-2.3,2.3-3.4,5-3.4h1.8v3.6h-2.3c-2.6,0-4.5,1.7-4.5,4.8v9.4h-4Z" class="svelte-1glg13o"></path></g></svg> <span class="text svelte-1glg13o"> </span>', 1);
function Cu(t, e) {
  let r = g(e, "title", 8, "Square"), a = g(e, "subtitle", 8, "Developer");
  var i = wu(), s = H(ye(i), 2), o = S(s);
  _(s), L(() => fe(o, `${r() ?? ""} ${a() ?? ""}`)), w(t, i);
}
var Nu = /* @__PURE__ */ x(
  `<svg class="LogoJewel svelte-m4lozh" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 994.6 995.7" width="22" height="22"><path fill="black" d="M828.4,0H166.2C74.4,0,0,74.4,0,166.2v662.2c0,91.8,74.4,166.2,166.2,166.2h662.2
    c91.8,0,166.2-74.4,166.2-166.2V166.2C994.6,74.4,920.2,0,828.4,0z M813.8,761.3c0,29-23.5,52.5-52.5,52.5h-528
    c-29,0-52.5-23.5-52.5-52.5v-528c0-29,23.5-52.5,52.5-52.5h528c29,0,52.5,23.5,52.5,52.5V761.3z M391.8,632.3
    c-16.7,0-30.1-13.5-30.1-30.2V391.3c0-16.7,13.4-30.3,30.1-30.3h211.1c16.6,0,30.1,13.5,30.1,30.3V602c0,16.7-13.5,30.2-30.1,30.2
    H391.8z" class="svelte-m4lozh"></path></svg> <span class="text svelte-m4lozh"> </span>`,
  1
);
function Tu(t, e) {
  let r = g(e, "title", 8, "Square");
  var a = Nu(), i = H(ye(a), 2), s = S(i, !0);
  _(i), L(() => fe(s, r())), w(t, a);
}
var Eu = /* @__PURE__ */ x(
  `<svg class="LogoLockup svelte-1qhoav6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3967.7 995.7" width="88" height="22"><path d="M828.4,0H166.2C74.4,0,0,74.4,0,166.2v662.2c0,91.8,74.4,166.2,166.2,166.2h662.2
    c91.8,0,166.2-74.4,166.2-166.2V166.2C994.6,74.4,920.2,0,828.4,0z M813.8,761.3c0,29-23.5,52.5-52.5,52.5h-528
    c-29,0-52.5-23.5-52.5-52.5v-528c0-29,23.5-52.5,52.5-52.5h528c29,0,52.5,23.5,52.5,52.5V761.3z M391.8,632.3
    c-16.7,0-30.1-13.5-30.1-30.2V391.3c0-16.7,13.4-30.3,30.1-30.3h211.1c16.6,0,30.1,13.5,30.1,30.3V602c0,16.7-13.5,30.2-30.1,30.2
    H391.8z M1258.3,617.9h108.6c5.4,61.5,47.1,109.5,131.2,109.5c75.1,0,121.3-37.1,121.3-93.2c0-52.5-36.2-76-101.4-91.4l-84.2-18.1
    c-91.4-19.9-160.2-78.7-160.2-174.7c0-105.9,94.1-178.3,216.3-178.3c129.4,0,212.7,67.9,219.9,168.3h-105
    C1592.3,293,1553.3,265,1490,265c-67,0-113.1,36.2-113.1,82.4s39.8,74.2,108.6,89.6l83.3,18.1c91.4,19.9,153.8,75.1,153.8,171.9
    c0,123.1-92.3,196.4-224.4,196.4C1349.7,823.3,1267.4,742.8,1258.3,617.9z M2111.1,994.6V814.5l7.1-79h-7.1
    c-24.9,56.8-77.2,87.9-148.2,87.9c-114.5,0-199.7-93.2-199.7-236.1c0-142.9,85.2-236.1,199.7-236.1c70.1,0,119.8,32.8,148.2,84.3
    h7.1V360h94.1v634.6H2111.1z M2114.6,587.2c0-91.4-55.9-144.7-124.3-144.7s-124.3,53.3-124.3,144.7c0,91.4,55.9,144.7,124.3,144.7
    S2114.6,678.7,2114.6,587.2z M2287.4,634.3V360h101.2v265.4c0,71.9,34.6,106.5,92.3,106.5c71,0,117.2-50.6,117.2-129.6V360h101.2
    v454.4h-94.1v-94.1h-7.1c-22.2,60.4-71,103-146.4,103C2343.3,823.3,2287.4,754.1,2287.4,634.3z M2760.9,687.5
    c0-85.2,59.5-134.9,165.1-141.1l125.1-8v-35.5c0-42.6-31.1-68.3-86.1-68.3c-50.6,0-80.8,25.7-88.8,62.1h-101.2
    c10.7-92.3,87-145.6,189.9-145.6c116.3,0,187.3,49.7,187.3,145.6v317.7h-94.1v-84.3h-7.1c-21.3,55.9-65.7,93.2-150.9,93.2
    C2818.6,823.3,2760.9,768.3,2760.9,687.5z M3051.2,631.6v-24l-102.1,7.1c-55,3.5-79.9,24-79.9,64.8c0,34.6,28.4,59.5,68.3,59.5
    C3009.5,739,3051.2,692.9,3051.2,631.6z M3227.7,814.5V360h94.1v87h7.1c13.3-59.5,58.6-87,126-87h46.2v91.4h-57.7
    c-65.7,0-114.5,42.6-114.5,123.4v239.6H3227.7z M3964.1,605.9h-345.3c5.3,83.4,63.9,130.5,128.7,130.5c55,0,89.6-22.2,109.2-59.5
    H3957c-27.5,92.3-108.3,146.4-210.4,146.4c-134,0-228.1-100.3-228.1-236.1c0-135.8,96.7-236.1,229-236.1
    c133.1,0,220.1,91.4,220.1,205C3967.7,578.4,3965.9,589.9,3964.1,605.9z M3867.4,535.8c-3.5-63-55.9-105.6-119.8-105.6
    c-60.4,0-110.9,38.2-123.4,105.6H3867.4z" fill="black" class="svelte-1qhoav6"></path></svg> <span class="text svelte-1qhoav6"> </span>`,
  1
);
function xu(t, e) {
  let r = g(e, "title", 8, "Square");
  var a = Eu(), i = H(ye(a), 2), s = S(i, !0);
  _(i), L(() => fe(s, r())), w(t, a);
}
var ku = /* @__PURE__ */ x('<div class="developer-lockup svelte-11hxh1l"><!> <a aria-label="home"><div class="logo-lockup-overlay svelte-11hxh1l"></div></a> <a aria-label="url"><div class="developer-subtitle-overlay svelte-11hxh1l"></div></a></div>'), Ou = /* @__PURE__ */ x('<a class="svelte-11hxh1l"><!></a> <div class="spacer-line svelte-11hxh1l"></div> <a class="subtitle svelte-11hxh1l"> </a>', 1), Lu = /* @__PURE__ */ x('<a class="svelte-11hxh1l"><!></a>'), Mu = /* @__PURE__ */ x('<div class="HomeLink svelte-11hxh1l"><!></div>');
function Hr(t, e) {
  oe(e, !1);
  let r = g(e, "id", 8, void 0), a = g(e, "title", 8, "Square"), i = g(e, "subtitle", 8, void 0), s = g(e, "url", 8, "/"), o = /* @__PURE__ */ Y();
  function l() {
    let v;
    switch (window.Sq && window.Sq.Environment ? v = window.Sq.Environment.env : v = _s(window.location.hostname), v) {
      case "development":
      case "test":
        return "/";
      case "staging":
        return "https://squareupstaging.com";
      default:
        return "https://squareup.com";
    }
  }
  _t(() => {
    O(o, l());
  }), Me();
  var u = Mu(), d = S(u);
  {
    var f = (v) => {
      var p = Ze(), h = ye(p);
      {
        var m = (I) => {
          var C = ku(), T = S(C);
          Cu(T, {
            get title() {
              return a();
            },
            get subtitle() {
              return i();
            }
          });
          var N = H(T, 2);
          ne(N, (E) => xe == null ? void 0 : xe(E)), ne(N, (E, k) => be == null ? void 0 : be(E, k), () => ({
            id: r(),
            title: a(),
            url: n(o)
          }));
          var b = H(N, 2);
          ne(b, (E) => xe == null ? void 0 : xe(E)), ne(b, (E, k) => be == null ? void 0 : be(E, k), () => ({
            id: r(),
            title: a(),
            url: s()
          })), _(C), L(() => {
            D(N, "id", r()), D(N, "href", n(o)), D(b, "id", r()), D(b, "href", s());
          }), w(I, C);
        }, y = (I) => {
          var C = Ou(), T = ye(C), N = S(T);
          Tu(N, {
            get title() {
              return a();
            }
          }), _(T), ne(T, (k) => xe == null ? void 0 : xe(k)), ne(T, (k, A) => be == null ? void 0 : be(k, A), () => ({
            id: r(),
            title: a(),
            url: n(o)
          }));
          var b = H(T, 4), E = S(b, !0);
          _(b), ne(b, (k) => xe == null ? void 0 : xe(k)), ne(b, (k, A) => be == null ? void 0 : be(k, A), () => ({
            id: r(),
            title: a(),
            url: s()
          })), L(() => {
            D(T, "id", r()), D(T, "href", n(o)), D(b, "id", r()), D(b, "href", s()), fe(E, i());
          }), w(I, C);
        };
        F(h, (I) => {
          i() === "Developer" ? I(m) : I(y, !1);
        });
      }
      w(v, p);
    }, c = (v) => {
      var p = Lu(), h = S(p);
      xu(h, {
        get title() {
          return a();
        }
      }), _(p), ne(p, (m) => xe == null ? void 0 : xe(m)), ne(p, (m, y) => be == null ? void 0 : be(m, y), () => ({
        id: r(),
        title: a(),
        url: s()
      })), L(() => {
        D(p, "id", r()), D(p, "href", n(o));
      }), w(v, p);
    };
    F(d, (v) => {
      i() ? v(f) : v(c, !1);
    });
  }
  _(u), w(t, u), le();
}
var Au = /* @__PURE__ */ x('<a id="main-content-jump-link" class="MainContentJumpLink svelte-17bfpsx" href="#main-content">Skip to Content</a>');
function Du(t) {
  function e() {
    window.location.href = "#main-content";
  }
  var r = Au();
  lt(() => at("click", r, e)), ne(r, (a, i) => be == null ? void 0 : be(a, i), () => ({
    id: "main-content-jump-link",
    title: "Skip to Content",
    url: "#main-content"
  })), w(t, r);
}
function jt(t) {
  let e;
  function r() {
    e && window.cancelAnimationFrame(e), e = window.requestAnimationFrame(() => {
      t.dispatchEvent(
        new CustomEvent("offsetLeftOnResize", {
          detail: t ? t.offsetLeft : null
        })
      );
    });
  }
  return window.addEventListener("resize", r), r(), {
    destroy() {
      e && window.cancelAnimationFrame(e), window.removeEventListener("resize", r);
    }
  };
}
var Ru = /* @__PURE__ */ x('<a><span class="svelte-h76lor"> </span></a>');
function Pu(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(d, "$navStateStore", r), s = () => re(f, "$accessibilityRedesignRenderStore", r);
  let o = g(e, "id", 8, void 0), l = g(e, "title", 8, void 0), u = g(e, "url", 8, "#");
  const d = Jt(), f = Xt();
  function c() {
    tt(d, {
      ...i(),
      category: null,
      subcategory: null
    });
  }
  Me();
  var v = Ru();
  let p;
  var h = S(v), m = S(h, !0);
  _(h), _(v), lt(() => at("mouseover", v, c)), ne(v, (y) => xe == null ? void 0 : xe(y)), ne(v, (y, I) => be == null ? void 0 : be(y, I), () => ({
    id: o(),
    title: l(),
    url: u()
  })), L(
    (y) => {
      D(v, "id", o()), D(v, "href", u()), p = j(v, 1, "Link svelte-h76lor", null, p, y), fe(m, l());
    },
    [
      () => ({
        "focus-highlight": !s(),
        "link-accessibility-redesign": s()
      })
    ],
    de
  ), w(t, v), le(), a();
}
var Uu = /* @__PURE__ */ x('<div><button aria-haspopup="true"><span class="title svelte-17zsa4u"> </span></button> <!></div>');
function Bu(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(b, "$navStateStore", r), s = /* @__PURE__ */ Y(), o = /* @__PURE__ */ Y(), l = /* @__PURE__ */ Y(), u = /* @__PURE__ */ Y(), d = /* @__PURE__ */ Y(), f = /* @__PURE__ */ Y();
  let c = g(e, "id", 8), v = g(e, "title", 8), p = g(e, "navItems", 24, () => []), h = g(e, "alignment", 8, "left"), m = g(e, "desktopMode", 8);
  const y = 100, I = 300, C = 280, T = 500, N = 460, b = Jt(), E = { menuId: c(), menuText: v() };
  let k = /* @__PURE__ */ Y(), A = /* @__PURE__ */ Y(!1);
  function P() {
    n(A) || (O(A, !0), tt(b, {
      ...i(),
      category: n(k),
      // Set current category
      subcategory: null
      // Clear current subcategory
    }), st({
      eventName: "Open Menu",
      properties: {
        ...E,
        menuCategory: Ft(n(k)),
        menuSubcategory: Ht(n(k)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(k))
      }
    }));
  }
  function M() {
    n(A) && (O(A, !1), st({
      eventName: "Close Menu",
      properties: {
        ...E,
        menuCategory: Ft(n(k)),
        menuSubcategory: Ht(n(k)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(k))
      }
    }));
  }
  function z() {
    n(A) ? M() : P();
  }
  ae(() => Le(p()), () => {
    O(s, p().some((J) => J.description));
  }), ae(() => (i(), n(k)), () => {
    O(o, i().category === n(k));
  }), ae(
    () => (n(o), i()),
    () => {
      O(l, n(o) && !!i().subcategory);
    }
  ), ae(
    () => (n(s), yr),
    () => {
      O(u, n(s) ? C : yr);
    }
  ), ae(() => n(s), () => {
    O(d, n(s) ? T : N);
  }), ae(
    () => (n(l), n(d), n(u)),
    () => {
      O(f, n(l) ? n(d) : n(u));
    }
  ), ae(
    () => (n(A), n(o)),
    () => {
      n(A) && !n(o) && M();
    }
  ), et(), Me();
  var B = Uu();
  let G;
  var R = S(B);
  let W;
  var K = S(R), Q = S(K, !0);
  _(K), _(R), ne(R, (J, X) => ct == null ? void 0 : ct(J, X), () => z);
  var V = H(R, 2);
  {
    var U = (J) => {
      Ka(J, {
        get alignment() {
          return h();
        },
        get isOpen() {
          return n(A);
        },
        get width() {
          return n(f);
        },
        children: (X, ee) => {
          Fr(X, {
            get navItems() {
              return p();
            }
          });
        },
        $$slots: { default: !0 }
      });
    };
    F(V, (J) => {
      m() && J(U);
    });
  }
  _(B), nt(B, (J) => O(k, J), () => n(k)), ne(B, (J, X) => wt == null ? void 0 : wt(J, X), () => [
    P,
    M,
    y,
    I
  ]), ne(B, (J, X) => Ct == null ? void 0 : Ct(J, X), () => M), L(
    (J, X) => {
      D(B, "id", c()), G = j(B, 1, "Category svelte-17zsa4u", null, G, J), D(B, "data-category", v()), D(B, "data-component-type", ot.MAIN_NAVIGATION_MENU), W = j(R, 1, "toggle nav-button svelte-17zsa4u", null, W, X), D(R, "aria-expanded", !!n(A)), fe(Q, v());
    },
    [
      () => ({ isOpen: n(A) }),
      () => ({ isOpen: n(A) })
    ],
    de
  ), w(t, B), le(), a();
}
function Vu() {
  return _s(window.location.hostname) === "production" ? "https://api.squareup.com" : "https://api.squareupstaging.com";
}
function Ls(t) {
  return t.map((e) => {
    const r = JSON.parse(e.default_format.body), a = JSON.parse(r.body);
    return {
      messageId: e.message_id,
      requestToken: e.request_token,
      placementId: e.placementId,
      description: a.message,
      id: e.message_id,
      image: {
        description: a.message,
        id: `${e.message_id}-image`,
        title: a.title,
        url: r.icon.url
      },
      linkText: a.title,
      title: a.title,
      url: r.buttons.link.url
    };
  });
}
function Ms(t) {
  const e = `${Vu()}/api/v2/messages/bulk`, a = {
    requests: t.map((s) => ({
      placement_id: s,
      limit: 1,
      locale: document.documentElement.lang ? document.documentElement.lang.replace("-", "_").toUpperCase() : "EN_US",
      entity: { type: 2, token: "PUBLIC" }
    }))
  }, i = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json"
    },
    referrerPolicy: "no-referrer",
    body: JSON.stringify(a)
  };
  return fetch(e, i).then((s) => s.json()).then((s) => {
    if (s.responses) {
      const o = [];
      return t.forEach((l) => {
        const u = (s.responses[l] || {}).message_units;
        u && u.length > 0 && o.push({
          ...u[0],
          placementId: l
        });
      }), o;
    }
    return [];
  }).catch((s) => {
    throw new Error("PublicWebNav: Unable to fetch placement data", s);
  });
}
const As = 230, Fu = 100;
var Hu = /* @__PURE__ */ x("<source/>"), zu = /* @__PURE__ */ x('<picture><!> <img class="SpotlightImage svelte-1m3zzfc" loading="lazy"/></picture>');
function qu(t, e) {
  let r = g(e, "id", 8), a = g(e, "description", 8), i = g(e, "url", 8);
  const s = { WIDTH: As, HEIGHT: Fu }, o = ["avif", "webp"];
  var l = zu(), u = S(l);
  qe(u, 1, () => o, Je, (c, v) => {
    var p = Hu();
    L(() => {
      D(p, "srcset", `${i()}?fm=${n(v)}`), D(p, "type", `image/${n(v) ?? ""}`);
    }), w(c, p);
  });
  var d = H(u, 2);
  let f;
  _(l), L(() => {
    D(d, "id", r()), D(d, "alt", a()), D(d, "src", i()), f = Te(d, "", f, {
      height: `${s.HEIGHT}px`,
      width: `${s.WIDTH}px`
    });
  }), w(t, l);
}
var Wu = /* @__PURE__ */ x('<a class="ArrowLink svelte-17arwc6"> <span class="no-wrap svelte-17arwc6"> </span></a>');
function ju(t, e) {
  oe(e, !1);
  let r = g(e, "id", 8), a = g(e, "url", 8), i = g(e, "linkText", 8), s = g(e, "ariaLabel", 8);
  const o = i().split(/(\s+)/), l = o.pop(), u = o.join("");
  Me();
  var d = Wu(), f = S(d), c = H(f), v = S(c, !0);
  _(c), _(d), ne(d, (p, h) => be == null ? void 0 : be(p, h), () => ({
    id: r(),
    title: i(),
    url: a()
  })), L(() => {
    D(d, "id", r()), D(d, "href", a()), D(d, "aria-label", s()), fe(f, `${u ?? ""} `), fe(v, l);
  }), w(t, d), le();
}
var Gu = /* @__PURE__ */ x('<a class="Link svelte-elzmg7"><span class="svelte-elzmg7"> </span></a>');
function Yu(t, e) {
  let r = g(e, "id", 8), a = g(e, "url", 8), i = g(e, "linkText", 8), s = g(e, "ariaLabel", 8);
  var o = Gu(), l = S(o), u = S(l, !0);
  _(l), _(o), ne(o, (d, f) => be == null ? void 0 : be(d, f), () => ({
    id: r(),
    title: i(),
    url: a()
  })), L(() => {
    D(o, "id", r()), D(o, "href", a()), D(o, "aria-label", s()), fe(u, i());
  }), w(t, o);
}
var Zu = /* @__PURE__ */ x('<div class="SpotlightItem svelte-1wkxf6i"><a><!></a> <div class="spotlight-item-text-container svelte-1wkxf6i"><!> <span class="spotlight-item-description svelte-1wkxf6i"> </span></div></div>');
function Ju(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$accessibilityRedesignRenderStore", r);
  let s = g(e, "id", 8, ""), o = g(e, "image", 8, null), l = g(e, "url", 8, ""), u = g(e, "linkText", 8, ""), d = g(e, "description", 8, "");
  const f = Xt();
  Me();
  var c = Zu(), v = S(c);
  let p;
  var h = S(v);
  {
    var m = (E) => {
      qu(E, {
        get id() {
          return o().id;
        },
        get description() {
          return o().description;
        },
        get url() {
          return o().url;
        }
      });
    };
    F(h, (E) => {
      o() && E(m);
    });
  }
  _(v), ne(v, (E, k) => be == null ? void 0 : be(E, k), () => ({
    id: s(),
    title: u(),
    url: l()
  }));
  var y = H(v, 2), I = S(y);
  {
    var C = (E) => {
      Yu(E, {
        get id() {
          return s();
        },
        get linkText() {
          return u();
        },
        get url() {
          return l();
        },
        get ariaLabel() {
          return d();
        }
      });
    }, T = (E) => {
      ju(E, {
        get id() {
          return s();
        },
        get linkText() {
          return u();
        },
        get url() {
          return l();
        },
        get ariaLabel() {
          return d();
        }
      });
    };
    F(I, (E) => {
      i() ? E(C) : E(T, !1);
    });
  }
  var N = H(I, 2), b = S(N, !0);
  _(N), _(y), _(c), L(
    (E) => {
      D(c, "id", s()), Te(c, `--spotlight-item-text-container-width: ${As}px;`), D(v, "id", s()), D(v, "href", l()), p = j(v, 1, "svelte-1wkxf6i", null, p, E), fe(b, d());
    },
    [
      () => ({
        "focus-accessibility-redesign": i()
      })
    ],
    de
  ), w(t, c), le(), a();
}
var Ku = /* @__PURE__ */ x('<div><div class="spotlight-container svelte-10etg3r"><span class="spotlight-title svelte-10etg3r" role="heading" aria-level="2"> </span> <!></div></div>');
function Xu(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$accessibilityRedesignRenderStore", r);
  let s = g(e, "id", 8, ""), o = g(e, "title", 8, ""), l = g(e, "items", 24, () => []);
  const u = Xt();
  Me();
  var d = Ku();
  let f;
  var c = S(d), v = S(c), p = S(v, !0);
  _(v);
  var h = H(v, 2);
  {
    var m = (y) => {
      var I = Ze(), C = ye(I);
      qe(C, 1, l, Je, (T, N) => {
        Ju(T, {
          get id() {
            return n(N).id;
          },
          get image() {
            return n(N).image;
          },
          get url() {
            return n(N).url;
          },
          get linkText() {
            return n(N).linkText;
          },
          get description() {
            return n(N).description;
          }
        });
      }), w(y, I);
    };
    F(h, (y) => {
      l() && y(m);
    });
  }
  _(c), _(d), L(
    (y) => {
      D(d, "id", s()), f = j(d, 1, "Spotlight svelte-10etg3r", null, f, y), D(d, "data-subcategory", o()), fe(p, o());
    },
    [
      () => ({
        "spotlight-accessibility-redesign": i()
      })
    ],
    de
  ), w(t, d), le(), a();
}
var Qu = /* @__PURE__ */ x('<li class="svelte-1fsgcjm"><a><span> </span></a></li>'), $u = /* @__PURE__ */ x('<div class="SubcategoryFlattened svelte-1fsgcjm"><span class="subcategory-title svelte-1fsgcjm" role="heading" aria-level="2"> </span> <ul class="subcategory-links svelte-1fsgcjm"></ul></div>');
function ec(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(d, "$loggedInStore", r), s = () => re(f, "$cartCountStore", r), o = () => re(c, "$accessibilityRedesignRenderStore", r), l = /* @__PURE__ */ Y(), u = /* @__PURE__ */ Y(), d = ln(), f = Kt(), c = Xt();
  let v = g(e, "id", 8, void 0), p = g(e, "title", 8, void 0), h = g(e, "navItems", 24, () => []);
  ae(
    () => (Le(h()), i(), s()),
    () => {
      O(l, un({
        items: h(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), ae(() => n(l), () => {
    O(u, n(l).filter((T) => T.type === "link"));
  }), et(), Me();
  var m = $u(), y = S(m), I = S(y, !0);
  _(y);
  var C = H(y, 2);
  qe(C, 5, () => n(u), Je, (T, N) => {
    var b = Qu(), E = S(b);
    let k;
    var A = S(E);
    let P;
    var M = S(A, !0);
    _(A), _(E), ne(E, (z, B) => be == null ? void 0 : be(z, B), () => ({
      id: n(N).id,
      title: n(N).title,
      url: n(N).url
    })), _(b), L(
      (z, B) => {
        k = j(E, 1, "subcategory-link svelte-1fsgcjm", null, k, z), D(E, "id", n(N).id), D(E, "href", n(N).url), P = j(A, 1, "svelte-1fsgcjm", null, P, B), fe(M, n(N).title);
      },
      [
        () => ({
          "focus-highlight": !o(),
          "focus-accessibility-redesign": o()
        }),
        () => ({
          "subcategory-link-title": !o(),
          "subcategory-link-title-accessibility-redesign": o()
        })
      ],
      de
    ), w(T, b);
  }), _(C), _(m), L(() => {
    D(m, "id", v()), D(m, "data-subcategory", p()), fe(I, p());
  }), w(t, m), le(), a();
}
var tc = /* @__PURE__ */ x("<li><!></li>"), nc = /* @__PURE__ */ x('<li class="svelte-q6f7a3"><!></li>'), rc = /* @__PURE__ */ x('<ul class="CategoryListFlattened svelte-q6f7a3"><!> <!></ul>');
function Ds(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$loggedInStore", r), s = () => re(d, "$cartCountStore", r), o = /* @__PURE__ */ Y(), l = /* @__PURE__ */ Y(), u = ln(), d = Kt();
  let f = g(e, "navItems", 24, () => []), c = g(e, "spotlightConfig", 8, void 0);
  ae(
    () => (Le(f()), i(), s()),
    () => {
      O(o, un({
        items: f(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), ae(() => n(o), () => {
    O(l, n(o).filter((y) => y.type === "category"));
  }), et(), Me();
  var v = rc(), p = S(v);
  qe(p, 1, () => n(l), Je, (y, I) => {
    var C = tc();
    let T;
    var N = S(C);
    ec(N, {
      get id() {
        return n(I).id;
      },
      get title() {
        return n(I).title;
      },
      get navItems() {
        return n(I).navItems;
      }
    }), _(C), L((b) => T = j(C, 1, "category-item svelte-q6f7a3", null, T, b), [() => ({ hidden: n(I).hidden })], de), w(y, C);
  });
  var h = H(p, 2);
  {
    var m = (y) => {
      var I = nc(), C = S(I);
      Xu(C, {
        get id() {
          return c().id;
        },
        get title() {
          return c().title;
        },
        get items() {
          return c().items;
        }
      }), _(I), w(y, I);
    };
    F(h, (y) => {
      c() && y(m);
    });
  }
  _(v), w(t, v), le(), a();
}
var ac = /* @__PURE__ */ x("<div><!></div>");
function Rs(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(l, "$accessibilityRedesignRenderStore", r);
  let s = g(e, "isOpen", 8, !1), o = g(e, "flyoutOffsetLeft", 8, 0);
  const l = Xt();
  Me();
  var u = ac();
  let d;
  var f = S(u);
  ra(f, e, "default", {}), _(u), L(
    (c) => {
      d = j(u, 1, "FlyoutFlattened svelte-1q4spz2", null, d, c), Te(u, `visibility: var(--flyout-visibility, hidden); --flyout-offset-left: ${o() ?? ""}px;`);
    },
    [
      () => ({
        isOpen: s(),
        "flyout-flattened-animation": !i(),
        "flyout-flattened-accessibility-redesign": i()
      })
    ],
    de
  ), w(t, u), le(), a();
}
var ic = /* @__PURE__ */ x('<div class="chevron-container svelte-16ousel"><svg class="chevron-left svelte-16ousel" width="5" height="5" viewBox="0 0 5 5" fill="none"><path d="M4 1L1 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <svg class="chevron-right svelte-16ousel" width="5" height="5" viewBox="0 0 5 5" fill="none"><path d="M4 1L1 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'), sc = /* @__PURE__ */ x("<div><!></div>"), oc = /* @__PURE__ */ x('<div><button aria-haspopup="true"><span class="title svelte-16ousel"> </span> <!></button> <!></div>');
function lc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(N, "$navStateStore", r), s = () => re(ia, "$flagsStore", r), o = () => re(K, "$accessibilityRedesignRenderStore", r), l = /* @__PURE__ */ Y(), u = /* @__PURE__ */ Y(), d = /* @__PURE__ */ Y(), f = /* @__PURE__ */ Y(), c = /* @__PURE__ */ Y(), v = /* @__PURE__ */ Y(), p = /* @__PURE__ */ Y();
  let h = g(e, "id", 8, void 0), m = g(e, "title", 8, void 0), y = g(e, "navItems", 24, () => []), I = g(e, "alignment", 8, "left"), C = g(e, "spotlightConfig", 12, void 0), T = g(e, "desktopMode", 8, void 0);
  const N = Jt(), b = { menuId: h(), menuText: m() }, E = 280, k = 500, A = 460;
  let P = /* @__PURE__ */ Y(), M = /* @__PURE__ */ Y(!1), z = /* @__PURE__ */ Y(), B = /* @__PURE__ */ Y(), G = /* @__PURE__ */ Y(!1), R = !1, W = !1;
  const K = Xt();
  async function Q(q) {
    const me = (q.communicationPlatformPlacementIds || []).slice(0, 2);
    if (me.length > 0)
      try {
        const Ne = await Ms(me), Ce = Ne.length > 0 ? Ls(Ne) : q.items;
        C(C().items = Ce, !0), R = !0;
      } catch {
        st({
          eventName: "Error fetching placement messages",
          properties: { ...b }
        }), C(C().items = n(B).items, !0);
      }
    else
      C(C().items = n(B).items, !0);
    O(G, !0);
  }
  function V(q) {
    q.forEach((me) => {
      me.requestToken && st({
        eventName: "View Commsplat Message",
        properties: {
          ...b,
          requestToken: me.requestToken,
          messageId: me.messageId,
          placementId: me.placementId
        }
      });
    });
  }
  function U() {
    n(M) || (O(M, !0), Un.update((q) => q.set(h(), n(M))), tt(N, {
      ...i(),
      category: n(P),
      // Set current category
      subcategory: null
      // Clear current subcategory
    }), st({
      eventName: "Open Menu",
      properties: {
        ...b,
        menuCategory: Ft(n(P)),
        menuSubcategory: Ht(n(P)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(P))
      }
    }), s().get("publicwebnav/enable-comms-plat-messaging") && !W && R && (C() || {}).items && (W = !0, V(C().items)));
  }
  function J() {
    n(M) && (O(M, !1), Un.update((q) => q.set(h(), n(M))), st({
      eventName: "Close Menu",
      properties: {
        ...b,
        menuCategory: Ft(n(P)),
        menuSubcategory: Ht(n(P)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(P))
      }
    }));
  }
  function X() {
    n(M) ? J() : U();
  }
  ae(() => (i(), n(P)), () => {
    O(l, i().category === n(P));
  }), ae(
    () => (s(), Le(C()), n(G), n(B)),
    () => {
      s().get("publicwebnav/enable-comms-plat-messaging") && typeof window < "u" && C() && !n(G) && (O(B, C()), C({
        items: [],
        title: n(B).title,
        communicationPlatformPlacementIds: n(B).communicationPlatformPlacementIds
      }), Q(n(B)));
    }
  ), ae(
    () => (Le(y()), Le(C())),
    () => {
      O(u, y().every((q) => q.type === "category") && C());
    }
  ), ae(() => Le(y()), () => {
    O(d, y().some((q) => q.description));
  }), ae(
    () => (n(l), i()),
    () => {
      O(f, n(l) && !!i().subcategory);
    }
  ), ae(
    () => (n(d), yr),
    () => {
      O(c, n(d) ? E : yr);
    }
  ), ae(() => n(d), () => {
    O(v, n(d) ? k : A);
  }), ae(
    () => (n(f), n(v), n(c)),
    () => {
      O(p, n(f) ? n(v) : n(c));
    }
  ), ae(
    () => (n(M), n(l)),
    () => {
      n(M) && !n(l) && J();
    }
  ), et(), Me();
  var ee = oc();
  let Ee;
  var Ie = S(ee);
  let Ae;
  var je = S(Ie), pe = S(je, !0);
  _(je);
  var ze = H(je, 2);
  {
    var _e = (q) => {
      var me = ic();
      w(q, me);
    };
    F(ze, (q) => {
      o() && q(_e);
    });
  }
  _(Ie), ne(Ie, (q, me) => ct == null ? void 0 : ct(q, me), () => X);
  var De = H(Ie, 2);
  {
    var Re = (q) => {
      var me = Ze(), Ne = ye(me);
      {
        var Ce = (we) => {
          Rs(we, {
            get isOpen() {
              return n(M);
            },
            get flyoutOffsetLeft() {
              return n(z);
            },
            children: (ie, $) => {
              var te = sc();
              let ue;
              var ce = S(te);
              Ds(ce, {
                get navItems() {
                  return y();
                },
                get spotlightConfig() {
                  return C();
                }
              }), _(te), L(
                (Se) => ue = j(te, 1, "category-flattened-container svelte-16ousel", null, ue, Se),
                [
                  () => ({
                    isOpen: n(M) && o(),
                    "category-flattened-container-accessibility-redesign": o()
                  })
                ],
                de
              ), w(ie, te);
            },
            $$slots: { default: !0 }
          });
        }, Pe = (we) => {
          Ka(we, {
            get alignment() {
              return I();
            },
            get isOpen() {
              return n(M);
            },
            get width() {
              return n(p);
            },
            children: (ie, $) => {
              Fr(ie, {
                get navItems() {
                  return y();
                },
                get isOpen() {
                  return n(M);
                }
              });
            },
            $$slots: { default: !0 }
          });
        };
        F(Ne, (we) => {
          n(u) ? we(Ce) : we(Pe, !1);
        });
      }
      w(q, me);
    };
    F(De, (q) => {
      T() && q(Re);
    });
  }
  _(ee), nt(ee, (q) => O(P, q), () => n(P)), ne(ee, (q, me) => wt == null ? void 0 : wt(q, me), () => [
    U,
    J,
    Is,
    ws
  ]), ne(ee, (q, me) => Ct == null ? void 0 : Ct(q, me), () => J), ne(ee, (q) => jt == null ? void 0 : jt(q)), lt(() => at("offsetLeftOnResize", ee, ({ detail: q }) => {
    O(z, q);
  })), L(
    (q, me) => {
      D(ee, "id", h()), Ee = j(ee, 1, "CategoryFlattened svelte-16ousel", null, Ee, q), D(ee, "data-category", m()), D(ee, "data-component-type", ot.MAIN_NAVIGATION_MENU), Ae = j(Ie, 1, "toggle nav-button svelte-16ousel", null, Ae, me), D(Ie, "aria-expanded", !!n(M)), fe(pe, m());
    },
    [
      () => ({ isOpen: n(M) }),
      () => ({
        "focus-highlight": !o(),
        "toggle-accessibility-redesign": o(),
        isOpen: n(M)
      })
    ],
    de
  ), w(t, ee), Jn(e, "getSpotlightMessages", Q), Jn(e, "open", U);
  var ge = le({ getSpotlightMessages: Q, open: U });
  return a(), ge;
}
var uc = /* @__PURE__ */ x("<li><!></li>"), cc = /* @__PURE__ */ x("<li><!></li>"), vc = /* @__PURE__ */ x("<li><!></li>"), dc = /* @__PURE__ */ x("<ul></ul>");
function Ci(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$loggedInStore", r), s = () => re(d, "$cartCountStore", r), o = () => re(f, "$flattenedNavRenderStore", r), l = /* @__PURE__ */ Y(), u = ln(), d = Kt(), f = Vl();
  let c = g(e, "navItems", 24, () => []), v = g(e, "alignment", 8, "center"), p = g(e, "desktopMode", 8), h = /* @__PURE__ */ Y(), m = /* @__PURE__ */ Y();
  ae(
    () => (Le(c()), i(), s()),
    () => {
      O(l, un({
        items: c(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), et(), Me();
  var y = dc();
  qe(y, 5, () => n(l), (I) => I, (I, C) => {
    var T = Ze(), N = ye(T);
    {
      var b = (k) => {
        var A = uc();
        let P;
        var M = S(A);
        {
          var z = (G) => {
            lc(G, {
              get alignment() {
                return v();
              },
              get id() {
                return n(C).id;
              },
              get title() {
                return n(C).title;
              },
              get navItems() {
                return n(C).navItems;
              },
              get spotlightConfig() {
                return n(C).spotlight;
              },
              get desktopMode() {
                return p();
              }
            });
          }, B = (G) => {
            Bu(G, {
              get alignment() {
                return v();
              },
              get id() {
                return n(C).id;
              },
              get title() {
                return n(C).title;
              },
              get navItems() {
                return n(C).navItems;
              },
              get desktopMode() {
                return p();
              }
            });
          };
          F(M, (G) => {
            o() ? G(z) : G(B, !1);
          });
        }
        _(A), L((G) => P = j(A, 1, "category-item svelte-et1sru", null, P, G), [() => ({ hidden: n(C).hidden })], de), w(k, A);
      }, E = (k, A) => {
        {
          var P = (M) => {
            var z = Ze(), B = ye(z);
            {
              var G = (W) => {
                var K = cc();
                let Q;
                var V = S(K);
                an(V, {
                  get id() {
                    return n(C).id;
                  },
                  get title() {
                    return n(C).title;
                  },
                  get url() {
                    return n(C).url;
                  },
                  get linkStyle() {
                    return n(C).linkStyle;
                  }
                }), _(K), L((U) => Q = j(K, 1, "button-item svelte-et1sru", null, Q, U), [() => ({ hidden: n(C).hidden })], de), w(W, K);
              }, R = (W) => {
                var K = vc();
                let Q;
                var V = S(K);
                Pu(V, {
                  get id() {
                    return n(C).id;
                  },
                  get title() {
                    return n(C).title;
                  },
                  get url() {
                    return n(C).url;
                  }
                }), _(K), L((U) => Q = j(K, 1, "link-item svelte-et1sru", null, Q, U), [() => ({ hidden: n(C).hidden })], de), w(W, K);
              };
              F(B, (W) => {
                n(C).linkStyle === "primary" || n(C).linkStyle === "secondary" ? W(G) : W(R, !1);
              });
            }
            w(M, z);
          };
          F(
            k,
            (M) => {
              n(C).type === "link" && M(P);
            },
            A
          );
        }
      };
      F(N, (k) => {
        n(C).type === "category" ? k(b) : k(E, !1);
      });
    }
    w(I, T);
  }), _(y), nt(y, (I) => O(h, I), () => n(h)), ne(y, (I) => jt == null ? void 0 : jt(I)), lt(() => at("offsetLeftOnResize", y, ({ detail: I }) => {
    O(m, I);
  })), L(() => {
    j(y, 1, `NavList align-${v() ?? ""}`, "svelte-et1sru"), Te(y, `--nav-list-offset-left: ${n(m) ?? ""}px;`);
  }), w(t, y), le(), a();
}
var fc = /* @__PURE__ */ x('<div style="visibility: var(--scrim-visibility, hidden)" aria-hidden="true"></div>');
function gc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(Un, "$categoryOpenStates", r);
  function s(u) {
    return u instanceof Map ? Array.from(u.values()).includes(!0) : !1;
  }
  Me();
  var o = fc();
  let l;
  L(
    (u) => l = j(o, 1, "Scrim svelte-4ds68c", null, l, u),
    [
      () => ({
        isVisible: s(i())
      })
    ],
    de
  ), w(t, o), le(), a();
}
var pc = /* @__PURE__ */ x('<div class="left-slot svelte-stplgd"><!></div> <div class="slot-spacer svelte-stplgd"></div> <div class="middle-slot svelte-stplgd"><!></div> <div class="slot-spacer svelte-stplgd"></div> <div class="right-slot svelte-stplgd"><!> <!></div>', 1), hc = /* @__PURE__ */ x("<!> <nav><!></nav> <!>", 1);
function mc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$accessibilityRedesignRender", r), s = /* @__PURE__ */ Y();
  let o = g(e, "data", 24, () => ({})), l = g(e, "desktopMode", 8);
  const u = Xt();
  ae(() => Le(o()), () => {
    O(s, o().alignment || "center");
  }), et(), Me();
  var d = hc(), f = ye(d);
  {
    var c = (T) => {
      Du(T);
    };
    F(f, (T) => {
      i() && T(c);
    });
  }
  var v = H(f, 2);
  let p;
  var h = S(v);
  {
    var m = (T) => {
      var N = pc(), b = ye(N), E = S(b);
      Hr(E, mr(() => o().home)), _(b);
      var k = H(b, 4), A = S(k);
      {
        var P = (W) => {
          Ci(W, {
            get navItems() {
              return o().primaryNavItems;
            },
            get alignment() {
              return n(s);
            },
            get desktopMode() {
              return l();
            }
          });
        };
        F(A, (W) => {
          o().primaryNavItems && W(P);
        });
      }
      _(k);
      var M = H(k, 4), z = S(M);
      {
        var B = (W) => {
          Ci(W, {
            get navItems() {
              return o().secondaryNavItems;
            },
            alignment: "right",
            get desktopMode() {
              return l();
            }
          });
        };
        F(z, (W) => {
          o().secondaryNavItems && W(B);
        });
      }
      var G = H(z, 2);
      {
        var R = (W) => {
          Iu(W, {
            get data() {
              return o().cart;
            }
          });
        };
        F(G, (W) => {
          o().cart && W(R);
        });
      }
      _(M), w(T, N);
    }, y = (T) => {
      Hr(T, mr(() => o().home));
    };
    F(h, (T) => {
      o().primaryNavItems || o().secondaryNavItems || o().cart ? T(m) : T(y, !1);
    });
  }
  _(v);
  var I = H(v, 2);
  {
    var C = (T) => {
      gc(T, {});
    };
    F(I, (T) => {
      i() && T(C);
    });
  }
  L(
    (T) => {
      p = j(v, 1, `DesktopNav align-${n(s) ?? ""}`, "svelte-stplgd", p, T), D(v, "data-component-type", ot.MAIN_NAVIGATION);
    },
    [
      () => ({
        "desktop-nav-accessibility-redesign": i()
      })
    ],
    de
  ), w(t, d), le(), a();
}
var yc = /* @__PURE__ */ x('<button type="button" aria-haspopup="true"><span class="text svelte-1qll5eu"><!></span> <span class="icon svelte-1qll5eu" aria-hidden="true"><span class="iconBarTop svelte-1qll5eu"></span> <span class="iconBarBottom svelte-1qll5eu"></span> <span class="iconBarClockwise svelte-1qll5eu"></span> <span class="iconBarCounterwise svelte-1qll5eu"></span></span></button>');
function _c(t, e) {
  oe(e, !1);
  const r = Vn();
  let a = g(e, "isOpen", 8, !1), i = g(e, "openText", 8, "Open menu"), s = g(e, "closeText", 8, "Close menu");
  function o() {
    r("toggle");
  }
  Me();
  var l = yc();
  let u;
  var d = S(l), f = S(d);
  {
    var c = (p) => {
      var h = Zn();
      L(() => fe(h, s())), w(p, h);
    }, v = (p) => {
      var h = Zn();
      L(() => fe(h, i())), w(p, h);
    };
    F(f, (p) => {
      a() ? p(c) : p(v, !1);
    });
  }
  _(d), wn(2), _(l), lt(() => at("click", l, o)), ne(l, (p) => xe == null ? void 0 : xe(p)), L(
    (p) => {
      u = j(l, 1, "MenuToggle nav-button svelte-1qll5eu", null, u, p), D(l, "aria-expanded", a());
    },
    [() => ({ isOpen: a() })],
    de
  ), w(t, l), le();
}
function ma(t) {
  let e, r, a = !1;
  function i(d) {
    return d.propertyName === "height" && d.target.classList.contains("isOpen") && (d.target.classList.contains("CategoryList") || d.target.classList.contains("SubcategoryList"));
  }
  function s(d) {
    i(d) && (a = !0, e = d.target, r = e.closest(".Subcategory, .Category"), requestAnimationFrame(o));
  }
  function o() {
    a && (l(), requestAnimationFrame(o));
  }
  function l() {
    const d = r.getBoundingClientRect().top, f = t.getBoundingClientRect().top;
    if (d < f) {
      const c = f - d, v = Math.round(t.scrollTop - c);
      t.scrollTo({ top: v, left: 0 });
    }
  }
  function u(d) {
    d.target === e && d.propertyName === "height" && (a = !1, l(), e = r = null);
  }
  return t.addEventListener("transitionstart", s), t.addEventListener("transitionend", u), {
    destroy() {
      t.removeEventListener("transitionstart", s), t.removeEventListener("transitionend", u);
    }
  };
}
var Sc = /* @__PURE__ */ x("<!> <div><!></div>", 1);
function Ps(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$navStateStore", r), s = () => re(d, "$drawerTopStore", r);
  let o = g(e, "toggle", 8), l = g(e, "drawerType", 8, "Menu");
  const u = Jt(), d = Rl();
  let f = /* @__PURE__ */ Y(), c = /* @__PURE__ */ Y(!1);
  function v() {
    za(f, n(f).scrollTop = 0), n(f).offsetHeight, O(c, !0), tt(u, {
      ...i(),
      // set current drawer to this drawer
      drawer: n(f),
      // when a drawer opens, close any open category or subcategory
      category: null,
      subcategory: null
    }), st({
      eventName: "Open Drawer",
      properties: { drawerType: l() }
    });
  }
  function p() {
    O(c, !1), tt(u, {
      ...i(),
      // if no other drawers are open, set current drawer to null
      drawer: i().drawer === n(f) ? null : i().drawer,
      // when a drawer closes, close any open category or subcategory
      category: null,
      subcategory: null
    }), st({
      eventName: "Close Drawer",
      properties: { drawerType: l() }
    });
  }
  function h() {
    n(c) ? p() : v();
  }
  ae(
    () => (n(c), i(), n(f)),
    () => {
      n(c) && i().drawer !== n(f) && p();
    }
  ), et(), Me();
  var m = Sc(), y = ye(m);
  fl(y, o, (N, b) => {
    b(N, {
      get isOpen() {
        return n(c);
      },
      $$events: { toggle: h }
    });
  });
  var I = H(y, 2);
  let C;
  var T = S(I);
  ra(T, e, "default", {}), _(I), nt(I, (N) => O(f, N), () => n(f)), ne(I, (N) => ma == null ? void 0 : ma(N)), L(
    (N) => {
      C = j(I, 1, "Drawer svelte-1jgdy7s", null, C, N), Te(I, `top: ${s() ?? ""}px; visibility: var(--drawer-visibility, hidden)`);
    },
    [() => ({ isOpen: n(c) })],
    de
  ), w(t, m), le(), a();
}
var bc = /* @__PURE__ */ x('<a class="Link svelte-z8gsfy"><span class="title svelte-z8gsfy"> </span></a>');
function Ic(t, e) {
  let r = g(e, "id", 8), a = g(e, "title", 8), i = g(e, "url", 8);
  var s = bc(), o = S(s), l = S(o, !0);
  _(o), _(s), ne(s, (u) => xe == null ? void 0 : xe(u)), ne(s, (u, d) => be == null ? void 0 : be(u, d), () => ({
    id: r(),
    title: a(),
    url: i()
  })), L(() => {
    D(s, "id", r()), D(s, "href", i()), fe(l, a());
  }), w(t, s);
}
function mn(t, { isOpen: e, duration: r, easing: a }) {
  t.style.height = e ? "auto" : "0px", t.style.visibility = e ? "visible" : "hidden";
  function i() {
    t.style.height = getComputedStyle(t).height, t.offsetHeight, t.style.transition = `
      height ${r} ${a},
      visibility 0s`, t.style.visibility = "visible", t.style.height = `${t.scrollHeight}px`;
  }
  function s() {
    t.style.height = getComputedStyle(t).height, t.offsetHeight, t.style.transition = `
      height ${r} ${a},
      visibility 0s ${r}`, t.style.visibility = "hidden", t.style.height = "0px";
  }
  function o(l) {
    l.propertyName === "height" && t.style.height !== "0px" && (t.style.height = "auto");
  }
  return t.addEventListener("transitionend", o), {
    update({ isOpen: l }) {
      l ? i() : s();
    },
    destroy() {
      t.removeEventListener("transitionend", o);
    }
  };
}
var wc = /* @__PURE__ */ x('<span class="description svelte-tg49ie"> </span>'), Cc = /* @__PURE__ */ x('<a class="CategoryLink svelte-tg49ie"><span class="title svelte-tg49ie"> </span> <!></a>');
function Nc(t, e) {
  let r = g(e, "id", 8), a = g(e, "title", 8), i = g(e, "url", 8), s = g(e, "description", 8, void 0);
  var o = Cc(), l = S(o), u = S(l, !0);
  _(l);
  var d = H(l, 2);
  {
    var f = (c) => {
      var v = wc(), p = S(v, !0);
      _(v), L(() => fe(p, s())), w(c, v);
    };
    F(d, (c) => {
      s() && c(f);
    });
  }
  _(o), ne(o, (c) => xe == null ? void 0 : xe(c)), ne(o, (c, v) => be == null ? void 0 : be(c, v), () => ({
    id: r(),
    title: a(),
    url: i()
  })), L(() => {
    D(o, "id", r()), D(o, "href", i()), fe(u, a());
  }), w(t, o);
}
var Tc = /* @__PURE__ */ x("<source/>"), Ec = /* @__PURE__ */ x('<picture><!> <img class="SpotlightImage svelte-dcidqf" loading="lazy"/></picture>');
function xc(t, e) {
  let r = g(e, "id", 8), a = g(e, "description", 8), i = g(e, "url", 8);
  const s = ["avif", "webp"];
  var o = Ec(), l = S(o);
  qe(l, 1, () => s, Je, (d, f) => {
    var c = Tc();
    L(() => {
      D(c, "srcset", `${i()}?fm=${n(f)}`), D(c, "type", `image/${n(f) ?? ""}`);
    }), w(d, c);
  });
  var u = H(l, 2);
  Te(u, "", {}, { height: "130px" }), _(o), L(() => {
    D(u, "id", r()), D(u, "alt", a()), D(u, "src", i());
  }), w(t, o);
}
var kc = /* @__PURE__ */ x('<a class="ArrowLink svelte-ja645l"> <span class="no-wrap svelte-ja645l"> </span></a>');
function Oc(t, e) {
  oe(e, !1);
  let r = g(e, "id", 8), a = g(e, "url", 8), i = g(e, "linkText", 8);
  const s = i().split(/(\s+)/), o = s.pop(), l = s.join("");
  Me();
  var u = kc(), d = S(u), f = H(d), c = S(f, !0);
  _(f), _(u), ne(u, (v, p) => be == null ? void 0 : be(v, p), () => ({
    id: r(),
    title: i(),
    url: a()
  })), L(() => {
    D(u, "id", r()), D(u, "href", a()), fe(d, `${l ?? ""} `), fe(c, o);
  }), w(t, u), le();
}
var Lc = /* @__PURE__ */ x('<div class="SpotlightItem svelte-1ybcrj3"><a><!></a> <!></div>');
function Mc(t, e) {
  oe(e, !1);
  let r = g(e, "id", 8, ""), a = g(e, "image", 8, null), i = g(e, "url", 8, ""), s = g(e, "linkText", 8, "");
  Me();
  var o = Lc(), l = S(o), u = S(l);
  {
    var d = (c) => {
      xc(c, {
        get id() {
          return a().id;
        },
        get description() {
          return a().description;
        },
        get url() {
          return a().url;
        }
      });
    };
    F(u, (c) => {
      a() && c(d);
    });
  }
  _(l), ne(l, (c, v) => be == null ? void 0 : be(c, v), () => ({
    id: r(),
    title: s(),
    url: i()
  }));
  var f = H(l, 2);
  Oc(f, {
    get id() {
      return r();
    },
    get linkText() {
      return s();
    },
    get url() {
      return i();
    }
  }), _(o), L(() => {
    D(o, "id", r()), D(l, "id", r()), D(l, "href", i());
  }), w(t, o), le();
}
var Ac = /* @__PURE__ */ x('<div class="Spotlight svelte-1yiqsl1"><span class="title svelte-1yiqsl1" role="heading" aria-level="2"> </span> <div class="item-container svelte-1yiqsl1"></div></div>');
function Dc(t, e) {
  let r = g(e, "id", 8, ""), a = g(e, "title", 8, ""), i = g(e, "items", 24, () => []);
  var s = Ac(), o = S(s), l = S(o, !0);
  _(o);
  var u = H(o, 2);
  qe(u, 5, i, Je, (d, f) => {
    Mc(d, {
      get id() {
        return n(f).id;
      },
      get image() {
        return n(f).imageMobile;
      },
      get url() {
        return n(f).url;
      },
      get linkText() {
        return n(f).linkText;
      }
    });
  }), _(u), _(s), L(() => {
    D(s, "id", r()), D(s, "data-subcategory", a()), fe(l, a());
  }), w(t, s);
}
var Rc = /* @__PURE__ */ x('<li><a class="link svelte-1yjh70f"><span class="title svelte-1yjh70f"> </span></a></li>'), Pc = /* @__PURE__ */ x("<ul></ul>");
function Uc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(d, "$loggedInStore", r), s = () => re(f, "$cartCountStore", r), o = /* @__PURE__ */ Y(), l = "300ms", u = "cubic-bezier(0.4, 0, 0.2, 1)", d = ln(), f = Kt();
  let c = g(e, "isOpen", 8, !1), v = g(e, "navItems", 24, () => []);
  ae(
    () => (Le(v()), i(), s()),
    () => {
      O(o, un({
        items: v(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), et(), Me();
  var p = Pc();
  let h;
  qe(p, 5, () => n(o), (m) => m, (m, y) => {
    var I = Rc();
    let C;
    var T = S(I), N = S(T), b = S(N, !0);
    _(N), _(T), ne(T, (E) => xe == null ? void 0 : xe(E)), ne(T, (E, k) => be == null ? void 0 : be(E, k), () => ({
      id: n(y).id,
      title: n(y).title,
      url: n(y).url
    })), _(I), L(
      (E) => {
        C = j(I, 1, "svelte-1yjh70f", null, C, E), D(T, "id", n(y).id), D(T, "href", n(y).url), fe(b, n(y).title);
      },
      [() => ({ hidden: n(y).hidden })],
      de
    ), w(m, I);
  }), _(p), ne(p, (m, y) => mn == null ? void 0 : mn(m, y), () => ({
    isOpen: c(),
    duration: l,
    easing: u
  })), L((m) => h = j(p, 1, "SubcategoryList svelte-1yjh70f", null, h, m), [() => ({ isOpen: c() })], de), w(t, p), le(), a();
}
var Bc = /* @__PURE__ */ x('<span class="description svelte-1ei9v35"> </span>'), Vc = /* @__PURE__ */ x('<div><button aria-haspopup="true"><span class="title svelte-1ei9v35"> </span> <!></button> <!></div>');
function Fc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(d, "$navStateStore", r);
  let s = g(e, "id", 8, void 0), o = g(e, "title", 8, void 0), l = g(e, "description", 8, void 0), u = g(e, "navItems", 24, () => []);
  const d = Jt(), f = { menuId: s(), menuText: o() };
  let c = /* @__PURE__ */ Y(), v = /* @__PURE__ */ Y(!1);
  function p() {
    O(v, !0), tt(d, {
      ...i(),
      subcategory: n(c)
    }), st({
      eventName: "Open Menu",
      properties: {
        ...f,
        menuCategory: Ft(n(c)),
        menuSubcategory: Ht(n(c)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(c))
      }
    });
  }
  function h() {
    O(v, !1), st({
      eventName: "Close Menu",
      properties: {
        ...f,
        menuCategory: Ft(n(c)),
        menuSubcategory: Ht(n(c)),
        navDeviceType: zt(n(c))
      }
    });
  }
  function m() {
    n(v) ? h() : p();
  }
  ae(
    () => (n(v), i(), n(c)),
    () => {
      n(v) && i().subcategory !== n(c) && h();
    }
  ), et(), Me();
  var y = Vc();
  let I;
  var C = S(y);
  let T;
  var N = S(C), b = S(N, !0);
  _(N);
  var E = H(N, 2);
  {
    var k = (P) => {
      var M = Bc(), z = S(M, !0);
      _(M), L(() => fe(z, l())), w(P, M);
    };
    F(E, (P) => {
      l() && P(k);
    });
  }
  _(C), ne(C, (P) => xe == null ? void 0 : xe(P)), lt(() => at("click", C, m));
  var A = H(C, 2);
  Uc(A, {
    get isOpen() {
      return n(v);
    },
    get navItems() {
      return u();
    }
  }), _(y), nt(y, (P) => O(c, P), () => n(c)), L(
    (P, M) => {
      D(y, "id", s()), I = j(y, 1, "Subcategory svelte-1ei9v35", null, I, P), D(y, "data-subcategory", o()), T = j(C, 1, "toggle nav-button svelte-1ei9v35", null, T, M), D(C, "aria-expanded", !!n(v)), fe(b, o());
    },
    [
      () => ({ isOpen: n(v) }),
      () => ({ isOpen: n(v) })
    ],
    de
  ), w(t, y), le(), a();
}
var Hc = /* @__PURE__ */ x("<li><!></li>"), zc = /* @__PURE__ */ x("<li><!></li>"), qc = /* @__PURE__ */ x("<ul><!> <!></ul>");
function Wc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$loggedInStore", r), s = () => re(c, "$cartCountStore", r), o = /* @__PURE__ */ Y(), l = /* @__PURE__ */ Y(), u = "300ms", d = "cubic-bezier(0.4, 0, 0.2, 1)", f = ln(), c = Kt();
  let v = g(e, "isOpen", 8, !1), p = g(e, "navItems", 24, () => []), h = g(e, "spotlightConfig", 24, () => ({}));
  ae(
    () => (Le(p()), i(), s()),
    () => {
      O(o, un({
        items: p(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), ae(() => Le(h()), () => {
    O(l, h() && h().items && h().items.length <= 2);
  }), et(), Me();
  var m = qc();
  let y;
  var I = S(m);
  qe(I, 1, () => n(o), (N) => N, (N, b) => {
    var E = Ze(), k = ye(E);
    {
      var A = (M) => {
        var z = Hc();
        let B;
        var G = S(z);
        Fc(G, {
          get id() {
            return n(b).id;
          },
          get title() {
            return n(b).title;
          },
          get navItems() {
            return n(b).navItems;
          },
          get description() {
            return n(b).description;
          }
        }), _(z), L((R) => B = j(z, 1, "category-item svelte-gp75ed", null, B, R), [() => ({ hidden: n(b).hidden })], de), w(M, z);
      }, P = (M, z) => {
        {
          var B = (G) => {
            var R = zc();
            let W;
            var K = S(R);
            Nc(K, {
              get id() {
                return n(b).id;
              },
              get title() {
                return n(b).title;
              },
              get url() {
                return n(b).url;
              },
              get description() {
                return n(b).description;
              }
            }), _(R), L((Q) => W = j(R, 1, "link-item svelte-gp75ed", null, W, Q), [() => ({ hidden: n(b).hidden })], de), w(G, R);
          };
          F(
            M,
            (G) => {
              n(b).type === "link" && G(B);
            },
            z
          );
        }
      };
      F(k, (M) => {
        n(b).type === "category" ? M(A) : M(P, !1);
      });
    }
    w(N, E);
  });
  var C = H(I, 2);
  {
    var T = (N) => {
      Dc(N, {
        get id() {
          return h().id;
        },
        get title() {
          return h().title;
        },
        get items() {
          return h().items;
        }
      });
    };
    F(C, (N) => {
      n(l) && N(T);
    });
  }
  _(m), ne(m, (N, b) => mn == null ? void 0 : mn(N, b), () => ({
    isOpen: v(),
    duration: u,
    easing: d
  })), L((N) => y = j(m, 1, "CategoryList svelte-gp75ed", null, y, N), [() => ({ isOpen: v() })], de), w(t, m), le(), a();
}
var jc = /* @__PURE__ */ x('<div><button aria-haspopup="true"><span class="title svelte-3r94ed"> </span></button> <!></div>');
function Gc(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(d, "$navState", r);
  let s = g(e, "id", 8), o = g(e, "title", 8), l = g(e, "navItems", 8), u = g(e, "spotlightConfig", 8, void 0);
  const d = Jt(), f = { menuId: s(), menuText: o() };
  let c = /* @__PURE__ */ Y(), v = /* @__PURE__ */ Y(!1);
  function p() {
    O(v, !0), tt(d, {
      ...i(),
      category: n(c),
      subcategory: null
    }), st({
      eventName: "Open Menu",
      properties: {
        ...f,
        menuCategory: Ft(n(c)),
        menuSubcategory: Ht(n(c)),
        menuLocation: ot.MAIN_NAVIGATION,
        navDeviceType: zt(n(c))
      }
    });
  }
  function h() {
    O(v, !1), tt(d, { ...i(), subcategory: null }), st({
      eventName: "Close Menu",
      properties: {
        ...f,
        menuCategory: Ft(n(c)),
        menuSubcategory: Ht(n(c)),
        navDeviceType: zt(n(c))
      }
    });
  }
  function m() {
    n(v) ? h() : p();
  }
  ae(
    () => (n(v), i(), n(c)),
    () => {
      n(v) && i().category !== n(c) && h();
    }
  ), et(), Me();
  var y = jc();
  let I;
  var C = S(y);
  let T;
  var N = S(C), b = S(N, !0);
  _(N), _(C), ne(C, (k) => xe == null ? void 0 : xe(k)), lt(() => at("click", C, m));
  var E = H(C, 2);
  Wc(E, {
    get isOpen() {
      return n(v);
    },
    get navItems() {
      return l();
    },
    get spotlightConfig() {
      return u();
    }
  }), _(y), nt(y, (k) => O(c, k), () => n(c)), L(
    (k, A) => {
      D(y, "id", s()), I = j(y, 1, "Category svelte-3r94ed", null, I, k), D(y, "data-category", o()), D(y, "data-component-type", ot.MAIN_NAVIGATION_MENU), T = j(C, 1, "toggle nav-button svelte-3r94ed", null, T, A), D(C, "aria-expanded", !!n(v)), fe(b, o());
    },
    [
      () => ({ isOpen: n(v) }),
      () => ({ isOpen: n(v) })
    ],
    de
  ), w(t, y), le(), a();
}
var Yc = /* @__PURE__ */ x("<li><!></li>"), Zc = /* @__PURE__ */ x("<li><!></li>"), Jc = /* @__PURE__ */ x("<li><!></li>"), Kc = /* @__PURE__ */ x("<ul></ul>");
function zr(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(l, "$loggedInStore", r), s = () => re(u, "$cartCountStore", r), o = /* @__PURE__ */ Y(), l = ln(), u = Kt();
  let d = g(e, "navItems", 24, () => []), f = g(e, "cartPrimary", 8, !1);
  ae(
    () => (Le(d()), i(), s()),
    () => {
      O(o, un({
        items: d(),
        loggedIn: i(),
        cartCount: s()
      }));
    }
  ), et(), Me();
  var c = Kc();
  let v;
  qe(c, 5, () => n(o), (p) => p, (p, h) => {
    var m = Ze(), y = ye(m);
    {
      var I = (T) => {
        var N = Yc();
        let b;
        var E = S(N);
        Gc(E, {
          get id() {
            return n(h).id;
          },
          get title() {
            return n(h).title;
          },
          get navItems() {
            return n(h).navItems;
          },
          get spotlightConfig() {
            return n(h).spotlight;
          }
        }), _(N), L((k) => b = j(N, 1, "category-item svelte-7s268a", null, b, k), [() => ({ hidden: n(h).hidden })], de), w(T, N);
      }, C = (T, N) => {
        {
          var b = (E) => {
            var k = Ze(), A = ye(k);
            {
              var P = (z) => {
                var B = Zc();
                let G;
                var R = S(B);
                an(R, {
                  get id() {
                    return n(h).id;
                  },
                  get title() {
                    return n(h).title;
                  },
                  get url() {
                    return n(h).url;
                  },
                  get linkStyle() {
                    return n(h).linkStyle;
                  },
                  width: "100%"
                }), _(B), L((W) => G = j(B, 1, "button-item svelte-7s268a", null, G, W), [() => ({ hidden: n(h).hidden })], de), w(z, B);
              }, M = (z) => {
                var B = Jc();
                let G;
                var R = S(B);
                Ic(R, {
                  get id() {
                    return n(h).id;
                  },
                  get title() {
                    return n(h).title;
                  },
                  get url() {
                    return n(h).url;
                  }
                }), _(B), L((W) => G = j(B, 1, "link-item svelte-7s268a", null, G, W), [() => ({ hidden: n(h).hidden })], de), w(z, B);
              };
              F(A, (z) => {
                n(h).linkStyle === "primary" || n(h).linkStyle === "secondary" ? z(P) : z(M, !1);
              });
            }
            w(E, k);
          };
          F(
            T,
            (E) => {
              n(h).type === "link" && E(b);
            },
            N
          );
        }
      };
      F(y, (T) => {
        n(h).type === "category" ? T(I) : T(C, !1);
      });
    }
    w(p, m);
  }), _(c), L((p) => v = j(c, 1, "NavList svelte-7s268a", null, v, p), [() => ({ cartPrimary: f() })], de), w(t, c), le(), a();
}
var Xc = /* @__PURE__ */ x("<!> <!>", 1);
function Qc(t, e) {
  oe(e, !1);
  let r = g(e, "data", 24, () => ({})), a = g(e, "mobileMode", 8);
  Me(), Ps(t, {
    get toggle() {
      return _c;
    },
    children: (i, s) => {
      var o = Ze(), l = ye(o);
      {
        var u = (d) => {
          var f = Xc(), c = ye(f);
          {
            var v = (m) => {
              zr(m, {
                get navItems() {
                  return r().primaryNavItems;
                }
              });
            };
            F(c, (m) => {
              r().primaryNavItems && m(v);
            });
          }
          var p = H(c, 2);
          {
            var h = (m) => {
              zr(m, {
                get navItems() {
                  return r().secondaryNavItems;
                }
              });
            };
            F(p, (m) => {
              r().secondaryNavItems && m(h);
            });
          }
          w(d, f);
        };
        F(l, (d) => {
          a() && d(u);
        });
      }
      w(i, o);
    },
    $$slots: { default: !0 }
  }), le();
}
var $c = /* @__PURE__ */ x('<div class="Cart svelte-1wc7457"><!> <!> <!></div>');
function ev(t, e) {
  oe(e, !1);
  let r = g(e, "data", 24, () => ({}));
  bs(!1), Me(), Ps(t, {
    get toggle() {
      return Es;
    },
    drawerType: "Cart",
    children: (a, i) => {
      var s = $c(), o = S(s);
      xs(o, {
        get title() {
          return r().title;
        },
        get statusZero() {
          return r().statusZero;
        },
        get statusOne() {
          return r().statusOne;
        },
        get statusMany() {
          return r().statusMany;
        }
      });
      var l = H(o, 2);
      {
        var u = (c) => {
          zr(c, {
            get navItems() {
              return r().primaryNavItems;
            },
            cartPrimary: !0
          });
        };
        F(l, (c) => {
          r().primaryNavItems && c(u);
        });
      }
      var d = H(l, 2);
      {
        var f = (c) => {
          zr(c, {
            get navItems() {
              return r().secondaryNavItems;
            }
          });
        };
        F(d, (c) => {
          r().secondaryNavItems && c(f);
        });
      }
      _(s), L(() => D(s, "data-component-type", ot.MAIN_NAVIGATION)), w(a, s);
    },
    $$slots: { default: !0 }
  }), le();
}
var tv = /* @__PURE__ */ x('<div style="visibility: var(--scrim-visibility, hidden)" aria-hidden="true"></div>');
function nv(t, e) {
  let r = g(e, "isVisible", 8, !1);
  var a = tv();
  let i;
  L((s) => i = j(a, 1, "Scrim svelte-1vopcyo", null, i, s), [() => ({ isVisible: r() })], de), at("click", a, function(s) {
    Vr.call(this, e, s);
  }), w(t, a);
}
function rv(t, e) {
  oe(e, !1);
  let r = g(e, "isLocked", 8, !1), a, i, s, o;
  typeof window < "u" && (a = document.body, i = a.style.overflowY, s = a.style.position, o = a.style.width), typeof window < "u" && wr(u);
  function l() {
    typeof window < "u" && (i = a.style.overflowY, s = a.style.position, o = a.style.width, a.style.overflowY = "scroll", a.style.position = "fixed", a.style.width = "100%");
  }
  function u() {
    typeof window < "u" && (a.style.overflowY = i, a.style.position = s, a.style.width = o);
  }
  ae(() => Le(r()), () => {
    r() ? l() : u();
  }), et(), Me(), le();
}
var av = /* @__PURE__ */ x('<div class="left-slot svelte-12pihcg"><!></div> <div class="right-slot svelte-12pihcg"><!> <!></div>', 1), iv = /* @__PURE__ */ x("<nav><!></nav> <!> <!>", 1);
function sv(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(d, "$navStateStore", r), s = () => re(c, "$accessibilityRedesignRender", r), o = /* @__PURE__ */ Y();
  let l = g(e, "data", 24, () => ({})), u = g(e, "mobileMode", 8);
  const d = Jt(), f = Dl(), c = Xt();
  let v = /* @__PURE__ */ Y(), p = /* @__PURE__ */ Y();
  function h() {
    tt(d, {
      ...i(),
      drawer: null,
      category: null,
      subcategory: null
    });
  }
  ae(() => Le(l()), () => {
    O(o, l().alignment || "center");
  }), ae(() => (n(v), n(p)), () => {
    n(v) && n(p) && tt(f, n(p) + n(v).getBoundingClientRect().top + window.scrollY);
  }), et(), Me();
  var m = iv(), y = ye(m);
  let I;
  var C = S(y);
  {
    var T = (P) => {
      var M = av(), z = ye(M), B = S(z);
      Hr(B, mr(() => l().home)), _(z);
      var G = H(z, 2), R = S(G);
      {
        var W = (V) => {
          ev(V, {
            get data() {
              return l().cart;
            }
          });
        };
        F(R, (V) => {
          l().cart && V(W);
        });
      }
      var K = H(R, 2);
      {
        var Q = (V) => {
          Qc(V, {
            get data() {
              return l();
            },
            get mobileMode() {
              return u();
            }
          });
        };
        F(K, (V) => {
          (l().primaryNavItems || l().secondaryNavItems) && V(Q);
        });
      }
      _(G), w(P, M);
    }, N = (P) => {
      Hr(P, mr(() => l().home));
    };
    F(C, (P) => {
      l().primaryNavItems || l().secondaryNavItems || l().cart ? P(T) : P(N, !1);
    });
  }
  _(y), nt(y, (P) => O(v, P), () => n(v));
  var b = H(y, 2);
  const E = /* @__PURE__ */ de(() => !!i().drawer);
  nv(b, {
    get isVisible() {
      return n(E);
    },
    $$events: { click: h }
  });
  var k = H(b, 2);
  const A = /* @__PURE__ */ de(() => !!i().drawer);
  rv(k, {
    get isLocked() {
      return n(A);
    }
  }), L(
    (P) => {
      I = j(y, 1, `MobileNav align-${n(o) ?? ""}`, "svelte-12pihcg", I, P), D(y, "data-component-type", ot.MAIN_NAVIGATION);
    },
    [
      () => ({
        "mobile-nav-accessibility-redesign": s()
      })
    ],
    de
  ), it(y, "offsetHeight", (P) => O(p, P)), w(t, m), le(), a();
}
function ya(t, e) {
  let r = !1;
  function a() {
    r = !0;
  }
  function i() {
    r = !1;
  }
  function s(o) {
    r || e(o);
  }
  return t.addEventListener("mousedown", a), t.addEventListener("mouseup", i), t.addEventListener("focus", s), {
    destroy() {
      t.removeEventListener("mousedown", a), t.removeEventListener("mouseup", i), t.removeEventListener("focus", s);
    }
  };
}
const ur = 124;
var ov = /* @__PURE__ */ x('<img aria-hidden="true" alt="" class="image svelte-1a0inbg" width="80" height="70"/>'), lv = /* @__PURE__ */ x('<span class="title svelte-1a0inbg"> </span>'), uv = /* @__PURE__ */ x('<span class="subtitle svelte-1a0inbg"> </span>'), cv = /* @__PURE__ */ x('<a class="ImageLink svelte-1a0inbg"><!> <!> <!></a>');
function vv(t, e) {
  oe(e, !1);
  const r = Vn();
  let a = g(e, "id", 8, ""), i = g(e, "title", 8, ""), s = g(e, "subtitle", 8, ""), o = g(e, "url", 8, ""), l = g(e, "image", 8, null);
  Me();
  var u = cv();
  Te(u, "min-width: 124px;");
  var d = S(u);
  {
    var f = (m) => {
      var y = ov();
      L(() => D(y, "src", l())), w(m, y);
    };
    F(d, (m) => {
      l() && m(f);
    });
  }
  var c = H(d, 2);
  {
    var v = (m) => {
      var y = lv(), I = S(y, !0);
      _(y), L(() => fe(I, i())), w(m, y);
    };
    F(c, (m) => {
      i() && m(v);
    });
  }
  var p = H(c, 2);
  {
    var h = (m) => {
      var y = uv(), I = S(y, !0);
      _(y), L(() => fe(I, s())), w(m, y);
    };
    F(p, (m) => {
      s() && m(h);
    });
  }
  _(u), ne(u, (m) => xe == null ? void 0 : xe(m)), ne(u, (m, y) => ya == null ? void 0 : ya(m, y), () => (m) => r("tabFocus", m)), ne(u, (m, y) => be == null ? void 0 : be(m, y), () => ({
    id: a(),
    title: i(),
    url: o()
  })), L(() => {
    D(u, "id", a()), D(u, "href", o());
  }), w(t, u), le();
}
const Ma = 40;
var dv = /* @__PURE__ */ x('<button tabindex="-1"></button>');
function Ni(t, e) {
  oe(e, !1);
  const r = /* @__PURE__ */ Y();
  let a = g(e, "direction", 8, "right");
  ae(() => Le(a()), () => {
    O(r, Ma * (a() === "right" ? 1 : -1));
  }), et();
  var i = dv();
  Te(i, "width: 40px;"), lt(() => at("click", i, function(s) {
    Vr.call(this, e, s);
  })), ne(i, (s) => xe == null ? void 0 : xe(s)), L(() => {
    j(i, 1, `ArrowButton ${a() ?? ""}`, "svelte-mjrfak"), D(i, "aria-label", `arrow button ${a() ?? ""}`);
  }), Br(1, i, () => wi, () => ({
    duration: 100,
    x: n(r),
    opacity: 0,
    easing: Kl
  })), Br(2, i, () => wi, () => ({
    duration: 100,
    x: n(r),
    opacity: 0,
    easing: Jl
  })), w(t, i), le();
}
var fv = /* @__PURE__ */ x('<li class="svelte-c27ows"><!></li>'), gv = /* @__PURE__ */ x('<nav class="ImageSubnav svelte-c27ows"><div class="scroller svelte-c27ows"><ul class="svelte-c27ows"></ul></div> <!> <!></nav>');
function Us(t, e) {
  oe(e, !1);
  const r = /* @__PURE__ */ Y(), a = /* @__PURE__ */ Y();
  let i = g(e, "navItems", 24, () => []);
  const s = 10;
  let o = /* @__PURE__ */ Y(), l = /* @__PURE__ */ Y(), u = /* @__PURE__ */ Y(!1), d = /* @__PURE__ */ Y(!1);
  function f() {
    if (n(l) < n(r)) {
      const b = n(o).scrollLeft / (n(r) - n(l));
      O(u, b > 0), O(d, b < 1);
    } else
      O(u, O(d, !1));
  }
  function c() {
    let b = n(a);
    n(d) || (b = b - Ma), n(o).scrollBy({ left: -b, behavior: "smooth" });
  }
  function v() {
    let b = n(a);
    n(u) || (b = b - Ma), n(o).scrollBy({ left: b, behavior: "smooth" });
  }
  function p(b) {
    const E = b.detail.target;
    n(o).scrollTo({
      left: E.offsetLeft + (E.offsetWidth - n(l)) / 2,
      behavior: "smooth"
    });
  }
  ae(
    () => (Le(i()), ur),
    () => {
      O(r, i().length * ur + s * 2);
    }
  ), ae(() => (n(l), ur), () => {
    O(a, Math.floor(n(l) / ur) * ur + s);
  }), ae(
    () => (n(l), n(r), n(o)),
    () => {
      n(l) && n(r) && n(o) && f();
    }
  ), et(), Me();
  var h = gv(), m = S(h), y = S(m);
  Te(y, "padding: 10px;"), qe(y, 5, i, Je, (b, E) => {
    var k = fv(), A = S(k);
    vv(A, mr(() => n(E), { $$events: { tabFocus: p } })), _(k), w(b, k);
  }), _(y), _(m), nt(m, (b) => O(o, b), () => n(o));
  var I = H(m, 2);
  {
    var C = (b) => {
      Ni(b, {
        direction: "left",
        $$events: { click: c }
      });
    };
    F(I, (b) => {
      n(u) && b(C);
    });
  }
  var T = H(I, 2);
  {
    var N = (b) => {
      Ni(b, {
        direction: "right",
        $$events: { click: v }
      });
    };
    F(T, (b) => {
      n(d) && b(N);
    });
  }
  _(h), L(() => D(h, "data-component-type", ot.IMAGE_SUBNAVIGATION)), at("scroll", m, f), it(h, "offsetWidth", (b) => O(l, b)), w(t, h), le();
}
var pv = /* @__PURE__ */ x('<a><span class="svelte-1ax2d77"> </span></a>');
function Ti(t, e) {
  let r = g(e, "id", 8), a = g(e, "title", 8), i = g(e, "url", 8), s = g(e, "isSelected", 8, !1), o = g(e, "isDynamicVariation", 8, !1);
  var l = pv();
  let u;
  var d = S(l), f = S(d, !0);
  _(d), _(l), ne(l, (c) => xe == null ? void 0 : xe(c)), ne(l, (c, v) => be == null ? void 0 : be(c, v), () => ({
    id: r(),
    title: a(),
    url: i()
  })), L(
    (c) => {
      D(l, "id", r()), D(l, "href", i()), u = j(l, 1, "CtaSubnavDesktopNavLink svelte-1ax2d77", null, u, c), fe(f, a());
    },
    [
      () => ({
        isSelected: s(),
        isDynamicVariation: o()
      })
    ],
    de
  ), w(t, l);
}
function _a(t, e, r = {}) {
  const a = new IntersectionObserver(([i]) => {
    i.isIntersecting && e();
  }, r);
  return a.observe(t), {
    destroy() {
      a.unobserve(t);
    }
  };
}
var hv = /* @__PURE__ */ x("<div><!></div>"), mv = /* @__PURE__ */ x('<div><button aria-haspopup="true"><span class="title"> </span> <div class="chevron-container svelte-1o5tzof"><svg class="chevron-left svelte-1o5tzof" width="5" height="5" viewBox="0 0 5 5" fill="none"><path d="M4 1L1 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <svg class="chevron-right svelte-1o5tzof" width="5" height="5" viewBox="0 0 5 5" fill="none"><path d="M4 1L1 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div></button> <!></div>');
function yv(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(v, "$navStateStore", r), s = () => re(ia, "$flagsStore", r), o = /* @__PURE__ */ Y();
  let l = g(e, "id", 8, void 0), u = g(e, "title", 8, void 0), d = g(e, "navItems", 24, () => []), f = g(e, "spotlightConfig", 12, void 0), c = g(e, "isVisible", 8, !1);
  const v = Jt(), p = { menuId: l(), menuText: u() };
  let h = /* @__PURE__ */ Y(), m = /* @__PURE__ */ Y(!1), y = /* @__PURE__ */ Y(), I = /* @__PURE__ */ Y(), C = /* @__PURE__ */ Y(!1), T = !1, N = !1;
  async function b(V) {
    const U = (V.communicationPlatformPlacementIds || []).slice(0, 2);
    if (U.length > 0)
      try {
        const J = await Ms(U), X = J.length > 0 ? Ls(J) : V.items;
        f(f().items = X, !0), T = !0;
      } catch {
        st({
          eventName: "Error fetching placement messages",
          properties: { ...p }
        }), f(f().items = n(I).items, !0);
      }
    else
      f(f().items = n(I).items, !0);
    O(C, !0);
  }
  function E(V) {
    V.forEach((U) => {
      U.requestToken && st({
        eventName: "View Commsplat Message",
        properties: {
          ...p,
          requestToken: U.requestToken,
          messageId: U.messageId,
          placementId: U.placementId
        }
      });
    });
  }
  function k() {
    n(m) || (O(m, !0), Un.update((V) => V.set(l(), n(m))), tt(v, {
      ...i(),
      category: n(h),
      // Set current category
      subcategory: null
      // Clear current subcategory
    }), st({
      eventName: "Open Menu",
      properties: {
        ...p,
        menuCategory: Ft(n(h)),
        menuSubcategory: Ht(n(h)),
        menuLocation: ot.SUBNAVIGATION,
        navDeviceType: zt(n(h))
      }
    }), s().get("publicwebnav/enable-comms-plat-messaging") && !N && T && (f() || {}).items && (N = !0, E(f().items)));
  }
  function A() {
    n(m) && (O(m, !1), Un.update((V) => V.set(l(), n(m))), st({
      eventName: "Close Menu",
      properties: {
        ...p,
        menuCategory: Ft(n(h)),
        menuSubcategory: Ht(n(h)),
        menuLocation: ot.SUBNAVIGATION,
        navDeviceType: zt(n(h))
      }
    }));
  }
  function P() {
    n(m) ? A() : k();
  }
  _t(() => () => A()), ae(() => (i(), n(h)), () => {
    O(o, i().category === n(h));
  }), ae(
    () => (s(), Le(f()), n(C), n(I)),
    () => {
      s().get("publicwebnav/enable-comms-plat-messaging") && typeof window < "u" && f() && !n(C) && (O(I, f()), f({
        items: [],
        title: n(I).title,
        communicationPlatformPlacementIds: n(I).communicationPlatformPlacementIds
      }), b(n(I)));
    }
  ), ae(
    () => (n(m), n(o)),
    () => {
      n(m) && !n(o) && A();
    }
  ), et(), Me();
  var M = mv();
  let z;
  var B = S(M);
  let G;
  var R = S(B), W = S(R, !0);
  _(R), wn(2), _(B), ne(B, (V, U) => ct == null ? void 0 : ct(V, U), () => P);
  var K = H(B, 2);
  Rs(K, {
    get isOpen() {
      return n(m);
    },
    get flyoutOffsetLeft() {
      return n(y);
    },
    children: (V, U) => {
      var J = hv();
      let X;
      var ee = S(J);
      Ds(ee, {
        get navItems() {
          return d();
        },
        get spotlightConfig() {
          return f();
        }
      }), _(J), L((Ee) => X = j(J, 1, "category-flattened-container svelte-1o5tzof", null, X, Ee), [() => ({ isOpen: n(m) })], de), w(V, J);
    },
    $$slots: { default: !0 }
  }), _(M), nt(M, (V) => O(h, V), () => n(h)), ne(M, (V, U) => wt == null ? void 0 : wt(V, U), () => [
    k,
    A,
    Is,
    ws
  ]), ne(M, (V, U) => Ct == null ? void 0 : Ct(V, U), () => A), ne(M, (V) => jt == null ? void 0 : jt(V)), ne(M, (V, U) => _a == null ? void 0 : _a(V, U), () => () => {
    O(y, n(h).offsetLeft);
  }), lt(() => at("offsetLeftOnResize", M, ({ detail: V }) => {
    O(y, V);
  })), L(
    (V, U) => {
      D(M, "id", l()), z = j(M, 1, "CategoryFlattened svelte-1o5tzof", null, z, V), D(M, "data-category", u()), D(M, "data-component-type", ot.SUBNAVIGATION_MENU), G = j(B, 1, "toggle nav-button svelte-1o5tzof", null, G, U), D(B, "aria-expanded", !!n(m)), fe(W, u());
    },
    [
      () => ({
        isOpen: n(m),
        isVisible: c()
      }),
      () => ({ isOpen: n(m) })
    ],
    de
  ), w(t, M), Jn(e, "getSpotlightMessages", b), Jn(e, "open", k);
  var Q = le({ getSpotlightMessages: b, open: k });
  return a(), Q;
}
const Bs = We(!1);
function Vs({
  renderCta: t,
  renderSecondaryCta: e,
  ctaIsVisible: r,
  isSticky: a,
  hiddenUntilScrolled: i
}) {
  Bs.set(
    // CTA or Secondary CTA will be rendered
    (t && r || e) && // And the CtaSubnav shouldn't be hidden
    (a && i || !i)
  );
}
var _v = /* @__PURE__ */ x('<div class="shim svelte-3zl2a6" aria-hidden="true"></div>'), Sv = /* @__PURE__ */ x("<span> </span>"), bv = /* @__PURE__ */ x('<div class="vertical-divider svelte-3zl2a6"></div> <span> </span>', 1), Iv = /* @__PURE__ */ x("<li><!></li>"), wv = /* @__PURE__ */ x("<li><!></li>"), Cv = /* @__PURE__ */ x("<li><!></li>"), Nv = /* @__PURE__ */ x("<ul><!> <!> <!></ul>"), Tv = /* @__PURE__ */ x('<div><!> <!> <!></div> <div class="right-slot"><!></div>', 1), Ev = /* @__PURE__ */ x('<span class="title svelte-3zl2a6"> </span>'), xv = /* @__PURE__ */ x("<li><!></li>"), kv = /* @__PURE__ */ x("<li><!></li>"), Ov = /* @__PURE__ */ x("<li><!></li>"), Lv = /* @__PURE__ */ x("<ul><!> <!> <!></ul>"), Mv = /* @__PURE__ */ x('<div class="left-slot"><!></div> <div class="right-slot"><!></div>', 1), Av = /* @__PURE__ */ x('<!> <nav class="CtaSubnavDesktopNav"><div><!></div></nav>', 1);
function Dv(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(N, "$currentUrlStore", r), s = () => re(C, "$loggedInStore", r), o = () => re(T, "$cartCountStore", r), l = /* @__PURE__ */ Y(), u = /* @__PURE__ */ Y(), d = /* @__PURE__ */ Y(), f = /* @__PURE__ */ Y(), c = /* @__PURE__ */ Y(), v = /* @__PURE__ */ Y(), p = /* @__PURE__ */ Y(), h = /* @__PURE__ */ Y(), m = /* @__PURE__ */ Y(), y = /* @__PURE__ */ Y(), I = /* @__PURE__ */ Y(), C = ln(), T = Kt(), N = Ja();
  let b = g(e, "data", 24, () => ({})), E = g(e, "isSticky", 8, !1), k = g(e, "hiddenUntilScrolled", 8, !1), A = /* @__PURE__ */ Y(), P = /* @__PURE__ */ Y(), M = /* @__PURE__ */ Y(), z = /* @__PURE__ */ Y(), B = /* @__PURE__ */ Y(!1), G = /* @__PURE__ */ Y(!1), R = /* @__PURE__ */ Y();
  function W() {
    Object.values(document.links).forEach((pe, ze) => {
      const _e = new URL(pe.href);
      if (n(y).includes(_e.pathname)) {
        if (_e.searchParams.get("v") || pe.href.includes("#"))
          return;
        _e.searchParams.size === 0 ? document.links[ze].href += `?v=${b().dynamicVariationSlug}` : document.links[ze].href += `&v=${b().dynamicVariationSlug}`;
      }
    });
  }
  _t(() => {
    n(R) && za(R, n(R).style.position = ""), b().enableDynamicVariations && b().dynamicVariationSlug && W(), setTimeout(
      () => {
        O(G, !0);
      },
      100
    );
  });
  function K() {
    O(B, !0);
  }
  function Q() {
    O(B, !1);
  }
  ae(
    () => (Le(E()), n(B), Le(b())),
    () => {
      O(l, E() || n(B) || !b().onlyShowCtaWhenSticky);
    }
  ), ae(() => (n(l), n(z)), () => {
    O(u, n(l) ? "0" : `${n(z)}px`);
  }), ae(() => Le(b()), () => {
    O(d, b().enableDynamicVariations);
  }), ae(
    () => (Le(b()), i(), s(), o()),
    () => {
      O(f, ks({
        data: b(),
        currentUrl: i(),
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), ae(
    () => (n(f), Le(b())),
    () => {
      O(c, n(f) ? b().cta : void 0);
    }
  ), ae(
    () => (n(c), Le(E())),
    () => {
      O(v, n(c) ? E() ? "primary" : n(c).linkStyle : void 0);
    }
  ), ae(
    () => (Le(b()), s(), o()),
    () => {
      O(p, Os({
        data: b(),
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), ae(
    () => (n(p), Le(b())),
    () => {
      O(h, n(p) ? b().secondaryCta : void 0);
    }
  ), ae(
    () => (Le(b()), s(), o()),
    () => {
      O(m, un({
        items: b().navItems,
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), ae(() => n(m), () => {
    O(y, n(m).map((pe) => pe.url && pe.url.split("?")[0]));
  }), ae(
    () => (n(c), n(h), Le(b())),
    () => {
      O(I, n(c) && n(h) && b().reverseDesktopCtaButtons);
    }
  ), ae(
    () => (n(f), n(p), n(l), Le(E()), Le(k())),
    () => {
      Vs({
        renderCta: n(f),
        renderSecondaryCta: n(p),
        ctaIsVisible: n(l),
        isSticky: E(),
        hiddenUntilScrolled: k()
      });
    }
  ), et(), Me();
  var V = Av(), U = ye(V);
  {
    var J = (pe) => {
      var ze = _v();
      L(() => Te(ze, `height: ${n(A) ?? ""}px;`)), w(pe, ze);
    };
    F(U, (pe) => {
      E() && pe(J);
    });
  }
  var X = H(U, 2), ee = S(X);
  let Ee;
  var Ie = S(ee);
  {
    var Ae = (pe) => {
      var ze = Tv(), _e = ye(ze);
      let De;
      var Re = S(_e);
      {
        var ge = ($) => {
          var te = Sv();
          let ue;
          var ce = S(te, !0);
          _(te), L(
            (Se) => {
              ue = j(te, 1, "title svelte-3zl2a6", null, ue, Se), fe(ce, b().title);
            },
            [
              () => ({
                isDynamicVariation: n(d)
              })
            ],
            de
          ), w($, te);
        };
        F(Re, ($) => {
          b().title && !E() && $(ge);
        });
      }
      var q = H(Re, 2);
      {
        var me = ($) => {
          yv($, {
            get id() {
              return b().titleCategory.id;
            },
            get title() {
              return b().titleCategory.title;
            },
            get navItems() {
              return b().titleCategory.navItems;
            },
            get spotlightConfig() {
              return b().titleCategory.spotlight;
            },
            get isVisible() {
              return E();
            }
          });
        };
        F(q, ($) => {
          b().titleCategory && $(me);
        });
      }
      var Ne = H(q, 2);
      {
        var Ce = ($) => {
          var te = bv(), ue = H(ye(te), 2);
          let ce;
          var Se = S(ue, !0);
          _(ue), ne(ue, (he) => jt == null ? void 0 : jt(he)), lt(() => at("offsetLeftOnResize", ue, ({ detail: he }) => {
            O(M, he);
          })), L(
            (he) => {
              ce = j(ue, 1, "subtitle svelte-3zl2a6", null, ce, he), fe(Se, b().subtitle);
            },
            [
              () => ({
                isDynamicVariation: n(d)
              })
            ],
            de
          ), w($, te);
        };
        F(Ne, ($) => {
          b().subtitle && $(Ce);
        });
      }
      _(_e);
      var Pe = H(_e, 2), we = S(Pe);
      {
        var ie = ($) => {
          var te = Nv();
          let ue;
          var ce = S(te);
          qe(ce, 1, () => n(m), Je, (Oe, Ye) => {
            var Qe = Iv();
            let Ve;
            var Fe = S(Qe);
            const Tt = /* @__PURE__ */ de(() => Kn(n(Ye).url, i()));
            Ti(Fe, {
              get id() {
                return n(Ye).id;
              },
              get title() {
                return n(Ye).title;
              },
              get url() {
                return n(Ye).url;
              },
              get isSelected() {
                return n(Tt);
              },
              isDynamicVariation: !0
            }), _(Qe), L((gt) => Ve = j(Qe, 1, "link-item svelte-3zl2a6", null, Ve, gt), [() => ({ hidden: n(Ye).hidden })], de), w(Oe, Qe);
          });
          var Se = H(ce, 2);
          {
            var he = (Oe) => {
              var Ye = wv();
              let Qe;
              var Ve = S(Ye);
              an(Ve, {
                get id() {
                  return n(c).id;
                },
                get title() {
                  return n(c).title;
                },
                get url() {
                  return n(c).url;
                },
                get linkStyle() {
                  return n(v);
                },
                $$events: { focus: K, blur: Q }
              }), _(Ye), L(
                (Fe) => Qe = j(Ye, 1, "cta-item svelte-3zl2a6", null, Qe, Fe),
                [
                  () => ({
                    hidden: n(c).hidden || !E(),
                    isVisible: n(l),
                    isDynamicVariation: n(d)
                  })
                ],
                de
              ), it(Ye, "offsetWidth", (Fe) => O(z, Fe)), w(Oe, Ye);
            };
            F(Se, (Oe) => {
              n(c) && Oe(he);
            });
          }
          var ve = H(Se, 2);
          {
            var se = (Oe) => {
              var Ye = Cv();
              let Qe;
              var Ve = S(Ye);
              an(Ve, {
                get id() {
                  return n(h).id;
                },
                get title() {
                  return n(h).title;
                },
                get url() {
                  return n(h).url;
                },
                get linkStyle() {
                  return n(h).linkStyle;
                }
              }), _(Ye), L(
                (Fe) => Qe = j(Ye, 1, "cta-item isVisible svelte-3zl2a6", null, Qe, Fe),
                [
                  () => ({
                    hidden: n(h).hidden || !E(),
                    isDynamicVariation: n(d)
                  })
                ],
                de
              ), w(Oe, Ye);
            };
            F(ve, (Oe) => {
              n(h) && Oe(se);
            });
          }
          _(te), L(
            (Oe) => {
              ue = j(te, 1, "nav-list svelte-3zl2a6", null, ue, Oe), Te(te, `transform: translate(${n(u) ?? ""});`);
            },
            [
              () => ({
                ctaIsVisible: n(l),
                primaryCtaFirst: n(I)
              })
            ],
            de
          ), w($, te);
        };
        F(we, ($) => {
          (n(c) || n(h) || n(m).length > 0) && $(ie);
        });
      }
      _(Pe), L(
        ($) => De = j(_e, 1, "left-slot svelte-3zl2a6", null, De, $),
        [
          () => ({
            isDynamicVariation: n(d)
          })
        ],
        de
      ), w(pe, ze);
    }, je = (pe) => {
      var ze = Mv(), _e = ye(ze), De = S(_e);
      {
        var Re = (Ne) => {
          var Ce = Ev(), Pe = S(Ce, !0);
          _(Ce), L(() => fe(Pe, b().title)), w(Ne, Ce);
        };
        F(De, (Ne) => {
          b().title && Ne(Re);
        });
      }
      _(_e);
      var ge = H(_e, 2), q = S(ge);
      {
        var me = (Ne) => {
          var Ce = Lv();
          let Pe;
          var we = S(Ce);
          qe(we, 1, () => n(m), Je, (ce, Se) => {
            var he = xv();
            let ve;
            var se = S(he);
            const Oe = /* @__PURE__ */ de(() => Kn(n(Se).url, i()));
            Ti(se, {
              get id() {
                return n(Se).id;
              },
              get title() {
                return n(Se).title;
              },
              get url() {
                return n(Se).url;
              },
              get isSelected() {
                return n(Oe);
              }
            }), _(he), L((Ye) => ve = j(he, 1, "link-item svelte-3zl2a6", null, ve, Ye), [() => ({ hidden: n(Se).hidden })], de), w(ce, he);
          });
          var ie = H(we, 2);
          {
            var $ = (ce) => {
              var Se = kv();
              let he;
              var ve = S(Se);
              an(ve, {
                get id() {
                  return n(c).id;
                },
                get title() {
                  return n(c).title;
                },
                get url() {
                  return n(c).url;
                },
                get linkStyle() {
                  return n(v);
                },
                $$events: { focus: K, blur: Q }
              }), _(Se), L(
                (se) => he = j(Se, 1, "cta-item svelte-3zl2a6", null, he, se),
                [
                  () => ({
                    hidden: n(c).hidden,
                    isVisible: n(l)
                  })
                ],
                de
              ), it(Se, "offsetWidth", (se) => O(z, se)), w(ce, Se);
            };
            F(ie, (ce) => {
              n(c) && ce($);
            });
          }
          var te = H(ie, 2);
          {
            var ue = (ce) => {
              var Se = Ov();
              let he;
              var ve = S(Se);
              an(ve, {
                get id() {
                  return n(h).id;
                },
                get title() {
                  return n(h).title;
                },
                get url() {
                  return n(h).url;
                },
                get linkStyle() {
                  return n(h).linkStyle;
                }
              }), _(Se), L(
                (se) => he = j(Se, 1, "cta-item isVisible svelte-3zl2a6", null, he, se),
                [
                  () => ({ hidden: n(h).hidden })
                ],
                de
              ), w(ce, Se);
            };
            F(te, (ce) => {
              n(h) && ce(ue);
            });
          }
          _(Ce), L(
            (ce) => {
              Pe = j(Ce, 1, "nav-list svelte-3zl2a6", null, Pe, ce), Te(Ce, `transform: translate(${n(u) ?? ""});`);
            },
            [
              () => ({
                ctaIsVisible: n(l),
                primaryCtaFirst: n(I)
              })
            ],
            de
          ), w(Ne, Ce);
        };
        F(q, (Ne) => {
          (n(c) || n(h) || n(m).length > 0) && Ne(me);
        });
      }
      _(ge), w(pe, ze);
    };
    F(Ie, (pe) => {
      b().enableDynamicVariations ? pe(Ae) : pe(je, !1);
    });
  }
  _(ee), nt(ee, (pe) => O(R, pe), () => n(R)), _(X), L(
    (pe) => {
      Ee = j(ee, 1, "header svelte-3zl2a6", null, Ee, pe), Te(ee, `width: ${n(P) ?? ""}px; --subtitle-offset-left: ${n(M) ?? ""}px;`), D(ee, "data-dynamic-variation", b().dynamicVariationSlug);
    },
    [
      () => ({
        isSticky: E(),
        useTransitions: n(G),
        hiddenUntilScrolled: k(),
        isDynamicVariation: n(d)
      })
    ],
    de
  ), it(ee, "offsetHeight", (pe) => O(A, pe)), it(X, "offsetWidth", (pe) => O(P, pe)), w(t, V), le(), a();
}
var Rv = /* @__PURE__ */ x('<a><span class="svelte-bl60r1"> </span></a>');
function Pv(t, e) {
  let r = g(e, "id", 8), a = g(e, "title", 8), i = g(e, "url", 8), s = g(e, "isSelected", 8, !1);
  var o = Rv();
  let l;
  var u = S(o), d = S(u, !0);
  _(u), _(o), ne(o, (f) => xe == null ? void 0 : xe(f)), ne(o, (f, c) => be == null ? void 0 : be(f, c), () => ({
    id: r(),
    title: a(),
    url: i()
  })), L(
    (f) => {
      D(o, "id", r()), D(o, "href", i()), l = j(o, 1, "CtaSubnavMobileNavLink svelte-bl60r1", null, l, f), fe(d, a());
    },
    [() => ({ isSelected: s() })],
    de
  ), w(t, o);
}
var Uv = /* @__PURE__ */ x('<span class="current-page svelte-1jxem9i"> </span>'), Bv = /* @__PURE__ */ x("<li><!></li>"), Vv = /* @__PURE__ */ x('<button aria-haspopup="true"><span class="truncate-wrapper svelte-1jxem9i"><span class="title svelte-1jxem9i"> </span> <!></span></button> <ul></ul>', 1), Fv = /* @__PURE__ */ x('<div class="truncate-wrapper svelte-1jxem9i"><span class="title svelte-1jxem9i"> </span></div>'), Hv = /* @__PURE__ */ x('<div class="HeaderMenu svelte-1jxem9i"><!></div>');
function zv(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(l, "$currentUrlStore", r), s = "300ms", o = "cubic-bezier(0.4, 0, 0.2, 1)", l = Ja();
  let u = g(e, "title", 8), d = g(e, "navItems", 24, () => []), f = /* @__PURE__ */ Y(!1), c = /* @__PURE__ */ Y(!1);
  const v = d().find((T) => Kn(T.url, i())), p = v && v.title;
  function h() {
    O(f, !n(f));
  }
  _t(() => {
    O(c, !0);
  }), Me();
  var m = Hv(), y = S(m);
  {
    var I = (T) => {
      var N = Vv(), b = ye(N);
      let E;
      var k = S(b), A = S(k), P = S(A, !0);
      _(A);
      var M = H(A, 2);
      {
        var z = (R) => {
          var W = Uv(), K = S(W, !0);
          _(W), L(() => fe(K, p)), w(R, W);
        };
        F(M, (R) => {
          p && !n(f) && R(z);
        });
      }
      _(k), _(b), ne(b, (R) => xe == null ? void 0 : xe(R)), ne(b, (R, W) => ct == null ? void 0 : ct(R, W), () => h);
      var B = H(b, 2);
      let G;
      qe(B, 5, d, Je, (R, W) => {
        var K = Bv();
        let Q;
        var V = S(K);
        const U = /* @__PURE__ */ de(() => Kn(n(W).url, i()));
        Pv(V, {
          get id() {
            return n(W).id;
          },
          get title() {
            return n(W).title;
          },
          get url() {
            return n(W).url;
          },
          get isSelected() {
            return n(U);
          }
        }), _(K), L((J) => Q = j(K, 1, "nav-item svelte-1jxem9i", null, Q, J), [() => ({ hidden: n(W).hidden })], de), w(R, K);
      }), _(B), ne(B, (R, W) => mn == null ? void 0 : mn(R, W), () => ({
        isOpen: n(f),
        duration: s,
        easing: o
      })), L(
        (R, W) => {
          E = j(b, 1, "toggle nav-button svelte-1jxem9i", null, E, R), D(b, "aria-expanded", !!n(f)), fe(P, u()), G = j(B, 1, "nav-item-list svelte-1jxem9i", null, G, W), D(B, "data-component-type", ot.SUBNAVIGATION_MENU);
        },
        [
          () => ({ isOpen: n(f) }),
          () => ({
            isOpen: n(f),
            hidden: !n(c)
          })
        ],
        de
      ), w(T, N);
    }, C = (T) => {
      var N = Fv(), b = S(N), E = S(b, !0);
      _(b), _(N), L(() => fe(E, u())), w(T, N);
    };
    F(y, (T) => {
      d().length ? T(I) : T(C, !1);
    });
  }
  _(m), w(t, m), le(), a();
}
var qv = /* @__PURE__ */ x('<div class="shim svelte-ta0rx1" aria-hidden="true"></div>'), Wv = /* @__PURE__ */ x("<!> <div><!></div>", 1), jv = /* @__PURE__ */ x("<div><!> <!></div>"), Gv = /* @__PURE__ */ x('<nav class="CtaSubnavMobileNav svelte-ta0rx1"><!> <!></nav>');
function Yv(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(h, "$currentUrlStore", r), s = () => re(v, "$loggedInStore", r), o = () => re(p, "$cartCountStore", r), l = /* @__PURE__ */ Y(), u = /* @__PURE__ */ Y(), d = /* @__PURE__ */ Y(), f = /* @__PURE__ */ Y(), c = /* @__PURE__ */ Y(), v = ln(), p = Kt(), h = Ja();
  let m = g(e, "data", 24, () => ({})), y = g(e, "isSticky", 8, !1), I = g(e, "hiddenUntilScrolled", 8, !1), C = /* @__PURE__ */ Y(), T = /* @__PURE__ */ Y(), N = /* @__PURE__ */ Y(!1);
  const b = !!m().disableIconCtaOnMobile;
  let E = /* @__PURE__ */ Y();
  _t(() => {
    n(E) && za(E, n(E).style.position = "");
  });
  function k() {
    O(N, !0);
  }
  function A() {
    O(N, !1);
  }
  ae(
    () => (Le(m()), i(), s(), o()),
    () => {
      O(l, ks({
        data: m(),
        currentUrl: i(),
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), ae(
    () => (n(l), Le(m())),
    () => {
      O(u, n(l) ? m().cta : void 0);
    }
  ), ae(
    () => (Le(m()), s(), o()),
    () => {
      O(d, Os({
        data: m(),
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), ae(
    () => (n(d), Le(m())),
    () => {
      O(f, n(d) ? m().secondaryCta : void 0);
    }
  ), ae(
    () => (Le(m()), s(), o()),
    () => {
      O(c, un({
        items: m().navItems,
        loggedIn: s(),
        cartCount: o()
      }));
    }
  ), et(), Me();
  var P = Gv(), M = S(P);
  {
    var z = (R) => {
      var W = Wv(), K = ye(W);
      {
        var Q = (X) => {
          var ee = qv();
          L(() => Te(ee, `height: ${n(C) ?? ""}px;`)), w(X, ee);
        };
        F(K, (X) => {
          y() && X(Q);
        });
      }
      var V = H(K, 2);
      let U;
      var J = S(V);
      zv(J, {
        get title() {
          return m().title;
        },
        get navItems() {
          return n(c);
        }
      }), _(V), nt(V, (X) => O(E, X), () => n(E)), L(
        (X) => {
          U = j(V, 1, "header svelte-ta0rx1", null, U, X), Te(V, `width: ${n(T) ?? ""}px;`);
        },
        [
          () => ({
            isSticky: y(),
            hiddenUntilScrolled: I()
          })
        ],
        de
      ), it(V, "offsetHeight", (X) => O(C, X)), w(R, W);
    };
    F(M, (R) => {
      m().title && R(z);
    });
  }
  var B = H(M, 2);
  {
    var G = (R) => {
      var W = jv();
      let K;
      var Q = S(W);
      {
        var V = (X) => {
          an(X, {
            get id() {
              return n(f).id;
            },
            get icon() {
              return n(f).iconData;
            },
            get title() {
              return n(f).title;
            },
            get url() {
              return n(f).url;
            },
            get linkStyle() {
              return n(f).linkStyle;
            }
          });
        };
        F(Q, (X) => {
          n(f) && X(V);
        });
      }
      var U = H(Q, 2);
      {
        var J = (X) => {
          an(X, {
            get id() {
              return n(u).id;
            },
            get title() {
              return n(u).title;
            },
            get url() {
              return n(u).url;
            },
            linkStyle: "primary",
            $$events: { focus: k, blur: A }
          });
        };
        F(U, (X) => {
          n(u) && X(J);
        });
      }
      _(W), L(
        (X) => {
          K = j(W, 1, "footer svelte-ta0rx1", null, K, X), Te(W, `width: ${n(T) ?? ""}px;`);
        },
        [
          () => ({
            isSticky: y(),
            isVisible: y() || n(N),
            disableLeftCtaIcon: b
          })
        ],
        de
      ), w(R, W);
    };
    F(B, (R) => {
      (n(f) || n(u)) && R(G);
    });
  }
  _(P), it(P, "offsetWidth", (R) => O(T, R)), w(t, P), le(), a();
}
var Zv = /* @__PURE__ */ x("<div></div>");
function Jv(t, e) {
  oe(e, !1);
  let r = g(e, "isPast", 12), a = g(e, "debug", 8, !1), i = g(e, "hiddenUntilScrolled", 8, !1), s = /* @__PURE__ */ Y(), o;
  _t(() => {
    o = new IntersectionObserver(l), o.observe(n(s));
  }), wr(() => {
    o && o.unobserve(n(s));
  });
  function l(f) {
    r(f[0].boundingClientRect.top < 0);
  }
  Me();
  var u = Zv();
  let d;
  nt(u, (f) => O(s, f), () => n(s)), L(
    (f) => d = j(u, 1, "Waypoint svelte-noukdu", null, d, f),
    [
      () => ({
        hiddenUntilScrolled: i(),
        debug: a()
      })
    ],
    de
  ), w(t, u), le();
}
var Kv = /* @__PURE__ */ x('<div class="CtaSubnav"><!> <!> <!></div>');
function Fs(t, e) {
  oe(e, !1);
  const r = /* @__PURE__ */ Y(), a = "pwn-has-sticky-cta-subnav";
  let i = g(e, "data", 28, () => ({})), s = /* @__PURE__ */ Y(), o, l = /* @__PURE__ */ Y(!1), u = /* @__PURE__ */ Y(!!i().hiddenUntilScrolled);
  function d() {
    const h = new URLSearchParams(window.location.search).get("v");
    o = i().dynamicVariations.find((m) => m.dynamicVariationSlug === h), o && i(o);
  }
  _t(() => {
    O(s, document.documentElement), i().enableDynamicVariations && Array.isArray(i().dynamicVariations) && d();
  }), ae(
    () => (n(l), Le(i())),
    () => {
      O(r, n(l) && !i().disableStickyBehavior);
    }
  ), ae(
    () => (n(s), Le(i())),
    () => {
      n(s) && n(s).classList.toggle(a, !i().disableStickyBehavior);
    }
  ), et(), Me();
  var f = Kv(), c = S(f);
  Jv(c, {
    get isPast() {
      return n(l);
    },
    set isPast(h) {
      O(l, h);
    },
    get hiddenUntilScrolled() {
      return n(u);
    },
    set hiddenUntilScrolled(h) {
      O(u, h);
    },
    $$legacy: !0
  });
  var v = H(c, 2);
  Dv(v, {
    get data() {
      return i();
    },
    get isSticky() {
      return n(r);
    },
    get hiddenUntilScrolled() {
      return n(u);
    }
  });
  var p = H(v, 2);
  Yv(p, {
    get data() {
      return i();
    },
    get isSticky() {
      return n(r);
    },
    get hiddenUntilScrolled() {
      return n(u);
    }
  }), _(f), L(() => D(f, "data-component-type", ot.SUBNAVIGATION)), w(t, f), le();
}
var Xv = /* @__PURE__ */ x('<header class="Header svelte-1rgjlpy"><!> <!> <!> <!></header>');
function Qv(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(f, "$renderFlattenedNav", r);
  let s = g(e, "data", 24, () => ({})), o = g(e, "imageSubnavData", 8, null), l = g(e, "ctaSubnavData", 8, null), u = g(e, "desktopMode", 8), d = g(e, "mobileMode", 8);
  const f = Bl(s() ? s().enableFlattenedNav : !1);
  bs(s() ? s().enableAccessibilityRedesign && i() : !1), Me();
  var c = Xv(), v = S(c);
  mc(v, {
    get data() {
      return s();
    },
    get desktopMode() {
      return u();
    }
  });
  var p = H(v, 2);
  sv(p, {
    get data() {
      return s();
    },
    get mobileMode() {
      return d();
    }
  });
  var h = H(p, 2);
  {
    var m = (C) => {
      Us(C, {
        get navItems() {
          return o().navItems;
        }
      });
    };
    F(h, (C) => {
      o() && C(m);
    });
  }
  var y = H(h, 2);
  {
    var I = (C) => {
      Fs(C, {
        get data() {
          return l();
        }
      });
    };
    F(y, (C) => {
      l() && C(I);
    });
  }
  _(c), w(t, c), le(), a();
}
var $v = /* @__PURE__ */ x('<!> <div data-nav-monorepo="" data-nav-svelte-5=""><!></div>', 1);
function dg(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = /* @__PURE__ */ Y(void 0, !0), s = /* @__PURE__ */ Y(void 0, !0), o = /* @__PURE__ */ Y(void 0, !0), l = /* @__PURE__ */ Y(void 0, !0), u = /* @__PURE__ */ Y(void 0, !0);
  let d = g(e, "dataJSON", 13, void 0), f = g(e, "imageSubnavJSON", 13, void 0), c = g(e, "ctaSubnavJSON", 13, void 0), v = g(e, "flagsJSON", 13, void 0), p = g(e, "loggedIn", 13, void 0), h = g(e, "darkMode", 13, !1), m = g(e, "themeColor", 13, "#006aff"), y = g(e, "themeFocusColor", 13, "#0055cc"), I = g(e, "zIndex", 13, 1e3), C = g(e, "cartCount", 13, 0), T = g(e, "currentUrl", 29, aa);
  const N = Ml(), b = Ll(p()), E = Al(C()), k = Pl(T()), A = Vn();
  let P = /* @__PURE__ */ Y(void 0, !0), M = /* @__PURE__ */ Y(void 0, !0);
  function z() {
    return fetch(n(o).cart.dataUrl).then((U) => U.json()).then((U) => {
      C(U.item_count);
    }).catch((U) => {
      console.error("PublicWebNav: Unable to fetch cart data", U);
    });
  }
  function B() {
    return fetch("/mp/status").then((U) => (U.status === 200 && p(!0), U.json())).catch((U) => {
      console.error("PublicWebNav: Unable to fetch logged in state", U);
    });
  }
  _t(() => {
    Ul(v()), A("mount", { meta: n(o) && n(o).meta });
  }), ae(() => (n(P), ha), () => {
    O(i, n(P) === void 0 ? null : n(P) >= ha);
  }), ae(() => n(i), () => {
    O(s, n(i) === !1);
  }), ae(() => Le(p()), () => {
    tt(b, p());
  }), ae(() => Le(C()), () => {
    tt(E, C());
  }), ae(() => Le(T()), () => {
    tt(k, T());
  }), ae(() => n(i), () => {
    tt(N, n(i) ? {} : {});
  }), ae(() => Le(d()), () => {
    O(o, d() ? JSON.parse(d()) : {});
  }), ae(() => Le(f()), () => {
    O(l, f() ? JSON.parse(f()) : void 0);
  }), ae(() => Le(c()), () => {
    O(u, c() ? JSON.parse(c()) : void 0);
  }), ae(() => n(o), () => {
    n(o).cart && n(o).cart.dataUrl && typeof window < "u" && z();
  }), ae(() => Le(p()), () => {
    p() === void 0 && typeof window < "u" && B();
  }), et(), Me(!0);
  var G = $v(), R = ye(G), W = H(R, 2);
  let K;
  var Q = S(W);
  Qv(Q, {
    get data() {
      return n(o);
    },
    get imageSubnavData() {
      return n(l);
    },
    get ctaSubnavData() {
      return n(u);
    },
    get desktopMode() {
      return n(i);
    },
    get mobileMode() {
      return n(s);
    }
  }), _(W), L(
    (U) => {
      K = j(W, 1, "PublicWebNav svelte-1yechz2", null, K, U), D(W, "data-nav-device-type", n(i) ? "Desktop" : "Mobile"), Te(W, `--color-theme: ${m() ?? ""}; --color-theme-focus: ${y() ?? ""}; z-index: ${I() ?? ""}; --desktop-breakpoint:${ha}px; --nav-width:${n(M) ?? ""}px;`);
    },
    [() => ({ darkMode: h() })],
    de
  ), Ya("innerWidth", (U) => O(P, U)), it(W, "clientWidth", (U) => O(M, U)), w(t, G), Jn(e, "fetchCartData", z), Jn(e, "fetchLoggedInState", B);
  var V = le({
    fetchCartData: z,
    fetchLoggedInState: B,
    get dataJSON() {
      return d();
    },
    set dataJSON(U) {
      d(U), $t();
    },
    get imageSubnavJSON() {
      return f();
    },
    set imageSubnavJSON(U) {
      f(U), $t();
    },
    get ctaSubnavJSON() {
      return c();
    },
    set ctaSubnavJSON(U) {
      c(U), $t();
    },
    get flagsJSON() {
      return v();
    },
    set flagsJSON(U) {
      v(U), $t();
    },
    get loggedIn() {
      return p();
    },
    set loggedIn(U) {
      p(U), $t();
    },
    get darkMode() {
      return h();
    },
    set darkMode(U) {
      h(U), $t();
    },
    get themeColor() {
      return m();
    },
    set themeColor(U) {
      m(U), $t();
    },
    get themeFocusColor() {
      return y();
    },
    set themeFocusColor(U) {
      y(U), $t();
    },
    get zIndex() {
      return I();
    },
    set zIndex(U) {
      I(U), $t();
    },
    get cartCount() {
      return C();
    },
    set cartCount(U) {
      C(U), $t();
    },
    get currentUrl() {
      return T();
    },
    set currentUrl(U) {
      T(U), $t();
    }
  });
  return a(), V;
}
function ed(t = !1) {
  const e = We(t);
  return Mt("DARK_MODE", e), e;
}
function td() {
  return Lt("DARK_MODE") || We(!1);
}
const Hs = We(/* @__PURE__ */ new Map());
function nd(t) {
  if (t)
    try {
      const e = JSON.parse(t);
      Hs.set(new Map(Object.entries(e)));
    } catch (e) {
      console.error("Error parsing flags", e);
    }
}
function sa() {
  if (typeof window < "u") {
    const { protocol: t, hostname: e, pathname: r } = window.location;
    return `${t}//${e}${r}`;
  }
  return "";
}
function vt() {
  var t;
  return ((t = window.location) == null ? void 0 : t.pathname) || "";
}
function rd(t, e) {
  if (typeof window < "u") {
    const { protocol: r, hostname: a } = window.location, i = `${r}//${a}`;
    try {
      const s = new URL(t, i), o = new URL(e, i), l = `${s.protocol}//${s.hostname}${s.pathname}`, u = `${o.protocol}//${o.hostname}${o.pathname}`;
      return l === u;
    } catch (s) {
      return console.error("Error comparing URLs:", s), !1;
    }
  }
  return !1;
}
function ad(t) {
  return typeof t != "string" ? "production" : t.includes("localhost") ? "development" : t.includes("squareupstaging") ? "staging" : "production";
}
function id(t) {
  const e = We(t || sa());
  return Mt("CURRENT_URL", e), e;
}
function zs() {
  return Lt("CURRENT_URL") || We(sa());
}
function sd(t = !1) {
  const e = We(t);
  return Mt("LOGGED_IN", e), e;
}
function Nr() {
  return Lt("LOGGED_IN") || We(!1);
}
function od(t = 0) {
  const e = We(t);
  return Mt("CART_COUNT", e), e;
}
function Fn() {
  return Lt("CART_COUNT") || We(0);
}
var ld = /* @__PURE__ */ x('<div id="public-web-nav-v2-cash-sans" class="svelte-dlm5nd"></div>');
function ud(t) {
  var e = ld();
  w(t, e);
}
var cd = /* @__PURE__ */ x('<div><svg class="chevron-left svelte-8uiegc" width="10" height="10" viewBox="0 0 6 6" fill="none"><path d="M4 1L1 4" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg> <svg class="chevron-right svelte-8uiegc" width="10" height="10" viewBox="0 0 6 6" fill="none"><path d="M4 1L1 4" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>');
function qs(t, e) {
  const r = g(e, "isOpen", 3, !1);
  var a = cd();
  let i;
  L((s) => i = j(a, 1, "chevron-container svelte-8uiegc", null, i, s), [() => ({ isOpen: r() })]), w(t, a);
}
var vd = /* @__PURE__ */ x('<div><div class="flyout-container svelte-1vvubed"><!></div></div>');
function dd(t, e) {
  const r = g(e, "id", 3, ""), a = g(e, "alignment", 3, "left"), i = g(e, "isOpen", 3, !1);
  var s = vd();
  let o;
  Te(s, "", {}, { visibility: "var(--flyout-visibility, hidden)" });
  var l = S(s), u = S(l);
  gs(u, () => e.children ?? pt), _(l), _(s), L(
    (d) => {
      D(s, "id", `nav-flyout-${r() ?? ""}`), o = j(s, 1, `Flyout align-${a() ?? ""}`, "svelte-1vvubed", o, d);
    },
    [() => ({ isOpen: i() })]
  ), w(t, s);
}
var fd = /* @__PURE__ */ Cn(`<path d="M1 1c-.6 0-1 .4-1 1s.4 1 1 1h1.7c.1 0 .3 0 .5.5.1.2.2.5.2.8l.1.3c0
      .2.1.4.1.6.1.5.8 2.9 1.5 5.2l.9 3.1.2.7-.2.2c-.5.5-.8 1.3-.8 2.4 0 1.8 1.7
      3.2 3.3 3.2H20c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2h3c.6 0 1-.4
      1-1s-.4-1-1-1H8.5c-.7 0-1.3-.6-1.3-1.2 0-.7.2-1 .3-1.1l.1-.1 15.4-.8c.6 0
      1-.5.9-1.1 0-.5-.5-.9-1-.9h-.3L24
      5.2c.1-.5-.3-1.1-.8-1.2H5.4v-.1c-.1-.4-.2-.8-.4-1.2C4.7 2 4.1 1 2.7
      1H1zm5.6 7.2L5.9 6h15.9l-1.2 6.9-12.5.6-.2-.6c-.4-1.5-.9-3.1-1.3-4.7zM8
      24c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" fill-rule="evenodd" clip-rule="evenodd"></path>`), gd = /* @__PURE__ */ Cn(
  `<circle cx="8" cy="22" r="2"></circle><path d="M23.6 19.8c-1.6-.3-3.2-.9-4.5-1.8H8.5c-.7 0-1.3-.6-1.3-1.2 0-.7.2-1
      .3-1.1l.1-.1
      8.2-.4c-.5-.6-.9-1.2-1.3-1.9l-6.5.3-.2-.6c-.3-1.6-.8-3.2-1.2-4.8L5.9
      6H13c.1-.7.2-1.4.3-2h-8v-.1c0-.4-.1-.8-.3-1.2C4.7 2 4.1 1 2.7 1H1c-.6 0-1
      .4-1 1s.4 1 1 1h1.7c.1 0 .3 0 .5.5.1.2.2.5.2.8l.1.3c0 .2.1.4.1.6.1.5.8 2.9
      1.5 5.2l.9 3.1.2.7-.2.2c-.5.5-.8 1.3-.8 2.4 0 1.8 1.7 3.2 3.3 3.2H23c.2 0
      .4-.1.6-.2z"></path><circle cx="20" cy="22" r="2"></circle>`,
  1
), pd = /* @__PURE__ */ Cn('<svg class="Icon svelte-1iy4pem" width="24" height="24" viewBox="0 0 24 24" fill="black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><!></svg>');
function hd(t, e) {
  const r = g(e, "isEmpty", 3, !0);
  var a = pd(), i = S(a);
  {
    var s = (l) => {
      var u = fd();
      w(l, u);
    }, o = (l) => {
      var u = gd();
      wn(2), w(l, u);
    };
    F(i, (l) => {
      r() ? l(s) : l(o, !1);
    });
  }
  _(a), w(t, a);
}
const Qa = {
  MAIN_NAVIGATION: "Main Navigation",
  SUBNAVIGATION: "Subnavigation"
}, Rn = 50, Pn = 150, Ws = 250, md = 250, yd = 350, _d = 1024, Sd = 1280, Ei = "cta-subnav-mobile-dropdown-menu", js = "global-nav-desktop-cart-content", Gs = "global-nav-mobile-cart-content", bd = 100, Id = 50, wd = ".__menu_toggle_focus";
var Cd = /* @__PURE__ */ x('<span class="Count svelte-yobq5x" aria-hidden="true"> </span>');
function Nd(t, e) {
  const r = g(e, "count", 3, 0), a = {
    duration: md,
    easing: Ts
  };
  var i = Cd(), s = S(i, !0);
  _(i), L(() => fe(s, r())), Br(1, i, () => Ns, () => a), w(t, i);
}
function Nt(t) {
  const e = (r) => {
    r.detail !== 0 && t.blur();
  };
  return t.addEventListener("click", e), {
    destroy() {
      t.removeEventListener("click", e);
    }
  };
}
function He(t, e) {
  let r = !1;
  function a() {
    r = !0;
  }
  function i() {
    r = !1;
  }
  function s(o) {
    r && (o.preventDefault(), e());
  }
  return t.addEventListener("click", e), t.addEventListener("touchstart", a, { passive: !0 }), t.addEventListener("touchmove", i, { passive: !0 }), t.addEventListener("touchcancel", i, { passive: !0 }), t.addEventListener("touchend", s), {
    destroy() {
      t.removeEventListener("click", e), t.removeEventListener("touchstart", a), t.removeEventListener("touchmove", i), t.removeEventListener("touchcancel", i), t.removeEventListener("touchend", s);
    }
  };
}
function Td(t, e) {
  e() && t.detail !== 0 && (window.location.href = e());
}
var Ed = /* @__PURE__ */ x('<button class="Toggle svelte-4y1zh8" aria-haspopup="true"><!> <!> <span class="title svelte-4y1zh8"> </span></button>');
function xd(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(o, "$countStore", r), s = Vn(), o = Fn(), l = g(e, "isOpen", 3, !1), u = g(e, "title", 3, "Your cart"), d = g(e, "url", 3, "");
  function f() {
    s("toggle");
  }
  var c = Ed();
  c.__click = [Td, d];
  var v = S(c);
  const p = /* @__PURE__ */ Z(() => i() === 0);
  hd(v, {
    get isEmpty() {
      return n(p);
    }
  });
  var h = H(v, 2);
  {
    var m = (C) => {
      Nd(C, {
        get count() {
          return i();
        }
      });
    };
    F(h, (C) => {
      i() > 0 && C(m);
    });
  }
  var y = H(h, 2), I = S(y, !0);
  _(y), _(c), ne(c, (C, T) => He == null ? void 0 : He(C, T), () => f), ne(c, (C) => Nt == null ? void 0 : Nt(C)), L(() => {
    D(c, "aria-expanded", l()), D(c, "aria-controls", `nav-flyout-${js}`), fe(I, u());
  }), w(t, c), le(), a();
}
Wa(["click"]);
function kd() {
  const { subscribe: t, update: e } = We({
    id: null,
    subcategoryId: null,
    contentHeight: 0,
    showSlideInAnimation: !0
  });
  function r(l) {
    e((u) => ({
      ...u,
      id: l,
      subcategoryId: null,
      // only show slide in animation if the dropdown was closed,
      // show fade in/out animation when hover between categories
      showSlideInAnimation: u.id === null
    }));
  }
  function a(l) {
    e((u) => ({
      ...u,
      subcategoryId: l,
      showSlideInAnimation: !1
    }));
  }
  function i() {
    e((l) => ({ ...l, id: null, subcategoryId: null, showSlideInAnimation: !0 })), o(0);
  }
  function s() {
    e((l) => ({ ...l, subcategoryId: null }));
  }
  function o(l) {
    e((u) => ({ ...u, contentHeight: l }));
  }
  return {
    subscribe: t,
    open: r,
    openSubcategory: a,
    close: i,
    closeSubcategory: s,
    updateContentHeight: o
  };
}
const xt = kd();
function Od() {
  const { subscribe: t, set: e, update: r } = We(null);
  function a(s) {
    e(s);
  }
  function i(s) {
    r((o) => (o == null ? void 0 : o.id) === s ? null : o);
  }
  return {
    subscribe: t,
    update: r,
    open: a,
    close: i
  };
}
const kr = Od();
function rt(t, e) {
  if (!e)
    return {
      destroy() {
      }
    };
  const [r, a, i, s] = e;
  let o, l;
  const u = () => {
    clearTimeout(l), o = setTimeout(r, i);
  }, d = () => {
    clearTimeout(o), l = setTimeout(a, s);
  };
  return t.addEventListener("mouseenter", u), t.addEventListener("mouseleave", d), {
    destroy() {
      clearTimeout(o), clearTimeout(l), t.removeEventListener("mouseenter", u), t.removeEventListener("mouseleave", d);
    }
  };
}
function Sa(t, e) {
  const r = (a) => {
    const i = a.target;
    t.contains(i) || e();
  };
  return window.addEventListener("click", r), {
    destroy() {
      window.removeEventListener("click", r);
    }
  };
}
function Ld() {
  const t = (e) => {
    typeof window < "u" && window.Sq && window.Sq.Tracking && window.Sq.Tracking.config && window.Sq.Tracking.cdp ? e() : setTimeout(() => t(e), 100);
  };
  return new Promise(t);
}
function Md() {
  const t = (e) => {
    typeof window > "u" ? setTimeout(() => t(e), 100) : e();
  };
  return new Promise(t);
}
const Ad = (t) => {
  const e = {};
  for (const [r, a] of Object.entries(t))
    a !== void 0 && (e[r] = a);
  return e;
}, Dd = (t) => t === null || !Array.isArray(t) || t.length === 0 ? !1 : t[0] === "*" ? !0 : t.includes(window.location.pathname);
function Rd(t) {
  return async ({ eventName: e, properties: r = {} }) => {
    await Md();
    const a = t.get("xms2-enable-pwt"), i = t.get("xmsfe-enable-pwt"), s = t.get("xmsfe-pwt-page-allow-list"), o = !!a || !!i && Dd(s), l = Ad(r);
    o ? window.Sq.Tracking.track(
      {
        action: e,
        properties: l
      },
      { destinations: ["cdp"] }
    ) : (await Ld(), window.Sq.Tracking.cdp.track(e, l));
  };
}
const Ys = Symbol("trackingContextKey");
function Pd(t) {
  Mt(Ys, Rd(t));
}
function qt() {
  return Lt(Ys);
}
function Aa(t) {
  return oa(t, "data-category");
}
function Ud(t) {
  return oa(t, "data-subcategory");
}
function Ot(t) {
  return oa(t, "data-component-type");
}
function dt(t) {
  return oa(t, "data-nav-device-type");
}
function Bd(t) {
  return !!(t != null && t.closest(".isSticky"));
}
function oa(t, e) {
  var r;
  if (t)
    return ((r = t.closest(`[${e}]`)) == null ? void 0 : r.getAttribute(e)) || void 0;
}
var Vd = /* @__PURE__ */ x('<button class="toggle-button svelte-168qyia" aria-haspopup="true"> <!></button>'), Fd = /* @__PURE__ */ x("<div><!> <!></div>");
function $a(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(kr, "$activeFlyoutStore", r), s = g(e, "id", 3, ""), o = g(e, "title", 3, ""), l = g(e, "alignment", 3, "left"), u = g(e, "enableScrim", 3, !1), d = g(e, "enableChevron", 3, !1), f = g(e, "renderCartButton", 3, !1);
  let c = /* @__PURE__ */ Ue(void 0);
  const v = qt(), p = /* @__PURE__ */ Z(() => {
    var A;
    return ((A = i()) == null ? void 0 : A.id) === s();
  });
  function h() {
    n(p) || (kr.open({ id: s(), enableScrim: u() }), xt.close(), v({
      eventName: f() ? "Open Cart" : "Open Menu",
      properties: {
        currentPage: vt(),
        menuId: s(),
        menuText: o(),
        menuCategory: o(),
        menuLocation: Ot(n(c)),
        navDeviceType: dt(n(c))
      }
    }));
  }
  function m() {
    n(p) && (kr.close(s()), v({
      eventName: f() ? "Close Cart" : "Close Menu",
      properties: {
        currentPage: vt(),
        menuId: s(),
        menuText: o(),
        menuCategory: o(),
        menuLocation: Ot(n(c)),
        navDeviceType: dt(n(c))
      }
    }));
  }
  function y() {
    n(p) ? m() : h();
  }
  var I = Fd();
  let C;
  var T = S(I);
  {
    var N = (A) => {
      xd(A, {
        get isOpen() {
          return n(p);
        },
        get title() {
          return o();
        },
        $$events: { toggle: y }
      });
    }, b = (A) => {
      var P = Vd(), M = S(P), z = H(M);
      {
        var B = (G) => {
          qs(G, {
            get isOpen() {
              return n(p);
            }
          });
        };
        F(z, (G) => {
          d() && G(B);
        });
      }
      _(P), ne(P, (G, R) => He == null ? void 0 : He(G, R), () => y), ne(P, (G) => Nt == null ? void 0 : Nt(G)), L(() => {
        D(P, "aria-expanded", n(p)), D(P, "aria-controls", `nav-flyout-${s()}`), fe(M, `${o() ?? ""} `);
      }), w(A, P);
    };
    F(T, (A) => {
      f() ? A(N) : A(b, !1);
    });
  }
  var E = H(T, 2);
  const k = /* @__PURE__ */ Z(() => f() ? js : s());
  dd(E, {
    get id() {
      return n(k);
    },
    get isOpen() {
      return n(p);
    },
    get alignment() {
      return l();
    },
    children: (A, P) => {
      var M = Ze(), z = ye(M);
      gs(z, () => e.children ?? pt), w(A, M);
    },
    $$slots: { default: !0 }
  }), _(I), nt(I, (A) => O(c, A), () => n(c)), ne(I, (A, P) => rt == null ? void 0 : rt(A, P), () => [
    h,
    m,
    Rn,
    Pn
  ]), ne(I, (A, P) => Sa == null ? void 0 : Sa(A, P), () => m), L(
    (A) => {
      D(I, "data-entry-id", s()), C = j(I, 1, "FlyoutToggle svelte-168qyia", null, C, A);
    },
    [() => ({ isOpen: n(p) })]
  ), w(t, I), le(), a();
}
function Gt(t, e = {}) {
  const r = () => {
    var i;
    if (!e.trackFn)
      return;
    const a = {
      currentPage: vt(),
      isNavSticky: Bd(t),
      linkId: e.id,
      linkText: e.title,
      linkUrl: (i = e.url) != null && i.includes("http") ? e.url : `${window.location.origin}${e.url}`,
      linkCategory: Aa(t),
      linkSubcategory: Ud(t),
      linkLocation: Ot(t),
      navDeviceType: dt(t)
    };
    e.trackFn({
      eventName: "Click Top Navigation Link",
      properties: a
    });
  };
  return t.addEventListener("click", r), {
    update(a) {
      e = a;
    },
    destroy() {
      t.removeEventListener("click", r);
    }
  };
}
var Hd = /* @__PURE__ */ x('<span class="icon svelte-12c1mn1"><!></span>'), zd = /* @__PURE__ */ x('<a><!> <span class="title svelte-12c1mn1"> </span></a>');
function qd(t, e) {
  const r = g(e, "linkCustomCssClass", 3, void 0), a = g(e, "id", 3, ""), i = g(e, "title", 3, ""), s = g(e, "url", 3, "#"), o = g(e, "svgIcon", 3, void 0), l = g(e, "enableHoverOpacity", 3, !1), u = g(e, "openInNewTab", 3, !1), d = g(e, "hoverWithDelayConfig", 3, void 0);
  var f = zd();
  let c;
  var v = S(f);
  {
    var p = (y) => {
      var I = Hd(), C = S(I);
      Ga(C, o), _(I), w(y, I);
    };
    F(v, (y) => {
      o() && y(p);
    });
  }
  var h = H(v, 2), m = S(h, !0);
  _(h), _(f), ne(f, (y) => Nt == null ? void 0 : Nt(y)), ne(f, (y, I) => rt == null ? void 0 : rt(y, I), d), L(
    (y) => {
      D(f, "data-entry-id", a()), c = j(f, 1, `Link--text ${(r() || "") ?? ""}`, "svelte-12c1mn1", c, y), D(f, "href", s()), D(f, "target", u() ? "_blank" : void 0), fe(m, i());
    },
    [
      () => ({ "hover-opacity": l() })
    ]
  ), w(t, f);
}
var Wd = /* @__PURE__ */ x('<span class="icon svelte-1x11yo"><!></span>'), jd = /* @__PURE__ */ x('<a><!> <span class="title svelte-1x11yo"> </span></a>');
function Gd(t, e) {
  const r = g(e, "id", 3, ""), a = g(e, "title", 3, ""), i = g(e, "url", 3, "#"), s = g(e, "linkStyle", 3, "primary"), o = g(e, "linkCustomCssClass", 3, void 0), l = g(e, "svgIcon", 3, void 0), u = g(e, "openInNewTab", 3, !1);
  var d = jd(), f = S(d);
  {
    var c = (h) => {
      var m = Wd(), y = S(m);
      Ga(y, l), _(m), w(h, m);
    };
    F(f, (h) => {
      l() && h(c);
    });
  }
  var v = H(f, 2), p = S(v, !0);
  _(v), _(d), ne(d, (h) => Nt == null ? void 0 : Nt(h)), L(() => {
    D(d, "href", i()), j(d, 1, `Link--button ${s() ?? ""} ${(o() || "") ?? ""}`, "svelte-1x11yo"), D(d, "data-entry-id", r()), D(d, "target", u() ? "_blank" : void 0), fe(p, a());
  }), w(t, d);
}
var Yd = /* @__PURE__ */ x('<div class="Link svelte-d35mct"><!></div>');
function mt(t, e) {
  oe(e, !0);
  const r = g(e, "id", 3, ""), a = g(e, "title", 3, ""), i = g(e, "url", 3, "#"), s = g(e, "icon", 3, void 0), o = g(e, "linkStyle", 3, "text"), l = g(e, "linkCustomCssClass", 3, void 0), u = g(e, "enableHoverOpacity", 3, !1), d = g(e, "openInNewTab", 3, !1), f = g(e, "hoverWithDelayConfig", 3, void 0), c = qt();
  var v = Yd(), p = S(v);
  {
    var h = (y) => {
      const I = /* @__PURE__ */ Z(() => {
        var C;
        return (C = s()) == null ? void 0 : C.svgString;
      });
      Gd(y, {
        get linkCustomCssClass() {
          return l();
        },
        get id() {
          return r();
        },
        get title() {
          return a();
        },
        get url() {
          return i();
        },
        get linkStyle() {
          return o();
        },
        get svgIcon() {
          return n(I);
        },
        get openInNewTab() {
          return d();
        }
      });
    }, m = (y) => {
      const I = /* @__PURE__ */ Z(() => {
        var C;
        return (C = s()) == null ? void 0 : C.svgString;
      });
      qd(y, {
        get linkCustomCssClass() {
          return l();
        },
        get id() {
          return r();
        },
        get title() {
          return a();
        },
        get url() {
          return i();
        },
        get svgIcon() {
          return n(I);
        },
        get enableHoverOpacity() {
          return u();
        },
        get openInNewTab() {
          return d();
        },
        get hoverWithDelayConfig() {
          return f();
        }
      });
    };
    F(p, (y) => {
      o() === "primary" || o() === "secondary" ? y(h) : y(m, !1);
    });
  }
  _(v), ne(v, (y, I) => Gt == null ? void 0 : Gt(y, I), () => ({
    id: r(),
    title: a(),
    url: i(),
    trackFn: c
  })), w(t, v), le();
}
var Zd = /* @__PURE__ */ x("<span> </span>"), Jd = /* @__PURE__ */ x("<li><!></li>"), Kd = /* @__PURE__ */ x('<div class="LinkList svelte-1g2wc2y"><!> <ul class="link-list svelte-1g2wc2y"></ul></div>');
function Bn(t, e) {
  const r = g(e, "id", 3, ""), a = g(e, "title", 3, ""), i = g(e, "excludeTitleOnDesktop", 3, !1), s = g(e, "navItems", 19, () => []), o = g(e, "linkStartingIndex", 3, 0), l = g(e, "slideInFrom", 3, "top");
  var u = Kd(), d = S(u);
  {
    var f = (v) => {
      var p = Zd();
      let h;
      var m = S(p, !0);
      _(p), L(() => {
        j(p, 1, `title slide-in-from-${l() ?? ""}`, "svelte-1g2wc2y"), h = Te(p, "", h, {
          "--link-list-item-number": o() + 1
        }), fe(m, a());
      }), w(v, p);
    };
    F(d, (v) => {
      i() || v(f);
    });
  }
  var c = H(d, 2);
  qe(c, 21, s, Je, (v, p, h) => {
    var m = Jd();
    let y;
    var I = S(m);
    mt(I, {
      linkCustomCssClass: "link-list-link",
      get id() {
        return n(p).contentfulEntryId;
      },
      get title() {
        return n(p).props.title;
      },
      get url() {
        return n(p).props.url;
      },
      get icon() {
        return n(p).props.icon;
      },
      get linkStyle() {
        return n(p).props.linkStyle;
      },
      enableHoverOpacity: !0,
      get openInNewTab() {
        return n(p).props.openInNewTab;
      }
    }), _(m), L(() => {
      j(m, 1, `slide-in-from-${l() ?? ""}`, "svelte-1g2wc2y"), y = Te(m, "", y, {
        "--link-list-item-number": o() + h + (i() ? 1 : 2)
      });
    }), w(v, m);
  }), _(c), _(u), L(() => D(u, "data-entry-id", r())), w(t, u);
}
function ft(t) {
  switch (t) {
    case "PublicWebNavigationCategoryV2":
      return "category";
    case "PublicWebNavigationImageListCategoryV2":
      return "imageListCategory";
    case "PublicWebNavigationLinkV2":
    case "PublicWebNavigationLink":
      return "link";
    default:
      return "link";
  }
}
function ei({ item: t, loggedIn: e = !1, cartCount: r = 0 }) {
  var a, i, s, o;
  return !(!t || (a = t == null ? void 0 : t.props) != null && a.hideWhenLoggedIn && e || (i = t == null ? void 0 : t.props) != null && i.hideWhenLoggedOut && !e || (s = t == null ? void 0 : t.props) != null && s.hideWhenCartEmpty && r === 0 || (o = t == null ? void 0 : t.props) != null && o.hideWhenCartNotEmpty && r !== 0);
}
function Zs({
  primaryCtaButton: t,
  showCtaOnCtaPage: e,
  currentUrl: r = sa(),
  loggedIn: a = !1,
  cartCount: i = 0
}) {
  return !!t && // CTA is not filtered out by logged in or cart state
  ei({
    item: t,
    loggedIn: a,
    cartCount: i
  }) && // CTA should not be hidden due to current URL
  (e || !rd(t.props.url, r));
}
function Js({ secondaryCtaButton: t, loggedIn: e = !1, cartCount: r = 0 }) {
  return !!t && // CTA is not filtered out by logged in or cart state
  ei({
    item: t,
    loggedIn: e,
    cartCount: r
  });
}
function Xn({ items: t = [], loggedIn: e = !1, cartCount: r = 0 }) {
  return t ? t.filter(
    (a) => ei({
      item: a,
      loggedIn: e,
      cartCount: r
    })
  ) : [];
}
var Xd = /* @__PURE__ */ x('<div class="shim svelte-fpav0j" aria-hidden="true"></div>'), Qd = /* @__PURE__ */ x('<span class="title svelte-fpav0j"> </span>'), $d = /* @__PURE__ */ x("<li><!></li>"), ef = /* @__PURE__ */ x("<li><!></li>"), tf = /* @__PURE__ */ x("<li><!></li>"), nf = /* @__PURE__ */ x('<li class="cta-button isVisible svelte-fpav0j"><!></li>'), rf = /* @__PURE__ */ x('<div class="right-slot-content svelte-fpav0j"><ul></ul> <ul class="cta-button-container svelte-fpav0j"><!> <!></ul></div>'), af = /* @__PURE__ */ x('<!> <nav class="DesktopNav svelte-fpav0j" data-cta-subnav-desktop-v2=""><div><div class="left-slot svelte-fpav0j"><!></div> <div class="right-slot svelte-fpav0j"><!></div></div></nav>', 1);
function sf(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(C, "$currentUrlStore", r), s = () => re(T, "$loggedInStore", r), o = () => re(I, "$cartCountStore", r), l = g(e, "id", 3, ""), u = g(e, "title", 3, ""), d = g(e, "navItems", 19, () => []), f = g(e, "primaryCtaButton", 3, void 0), c = g(e, "secondaryCtaButton", 3, void 0), v = g(e, "onlyShowCtaWhenSticky", 3, !1), p = g(e, "showCtaOnCtaPage", 3, !1), h = g(e, "hiddenUntilScrolled", 3, !1), m = g(e, "reverseDesktopCtaButtons", 3, !1), y = g(e, "isSticky", 3, !1), I = Fn(), C = zs(), T = Nr();
  let N = /* @__PURE__ */ Ue(void 0), b = /* @__PURE__ */ Ue(void 0), E = /* @__PURE__ */ Ue(void 0), k = /* @__PURE__ */ Ue(!1);
  const A = /* @__PURE__ */ Z(() => y() || !v()), P = /* @__PURE__ */ Z(() => Zs({
    primaryCtaButton: f(),
    showCtaOnCtaPage: p(),
    currentUrl: i(),
    loggedIn: s(),
    cartCount: o()
  })), M = /* @__PURE__ */ Z(() => n(P) ? f() : void 0), z = /* @__PURE__ */ Z(() => Js({
    secondaryCtaButton: c(),
    loggedIn: s(),
    cartCount: o()
  })), B = /* @__PURE__ */ Z(() => n(z) ? c() : void 0), G = /* @__PURE__ */ Z(() => Xn({
    items: d(),
    loggedIn: s(),
    cartCount: o()
  })), R = /* @__PURE__ */ Z(() => {
    var _e;
    return (_e = n(G).find((De) => {
      var Re;
      return Kn((Re = De.props) == null ? void 0 : Re.url, i());
    })) == null ? void 0 : _e.contentfulEntryId;
  }), W = /* @__PURE__ */ Z(() => n(M) && n(B) && m());
  ut(() => {
    Vs({
      renderCta: n(P),
      renderSecondaryCta: n(z),
      ctaIsVisible: n(A),
      isSticky: y(),
      hiddenUntilScrolled: h()
    });
  }), _t(() => {
    n(E) && (n(E).style.position = ""), setTimeout(
      () => {
        O(k, !0);
      },
      100
    );
  });
  var K = af(), Q = ye(K);
  {
    var V = (_e) => {
      var De = Xd();
      let Re;
      L(() => Re = Te(De, "", Re, { height: `${n(N)}px` })), w(_e, De);
    };
    F(Q, (_e) => {
      y() && _e(V);
    });
  }
  var U = H(Q, 2), J = S(U);
  let X, ee;
  var Ee = S(J), Ie = S(Ee);
  {
    var Ae = (_e) => {
      var De = Qd(), Re = S(De, !0);
      _(De), L(() => fe(Re, u())), w(_e, De);
    };
    F(Ie, (_e) => {
      u() && _e(Ae);
    });
  }
  _(Ee);
  var je = H(Ee, 2), pe = S(je);
  {
    var ze = (_e) => {
      var De = rf(), Re = S(De);
      let ge;
      qe(Re, 21, () => n(G), Je, (we, ie) => {
        var $ = Ze(), te = ye($);
        {
          var ue = (Se) => {
            var he = $d();
            let ve;
            var se = S(he);
            $a(se, {
              get id() {
                return n(ie).contentfulEntryId;
              },
              get title() {
                return n(ie).props.title;
              },
              enableChevron: !0,
              alignment: "right",
              children: (Oe, Ye) => {
                Bn(Oe, {
                  get id() {
                    return n(ie).contentfulEntryId;
                  },
                  get title() {
                    return n(ie).props.title;
                  },
                  excludeTitleOnDesktop: !0,
                  get navItems() {
                    return n(ie).props.primaryNavItems;
                  }
                });
              },
              $$slots: { default: !0 }
            }), _(he), L(
              (Oe) => {
                ve = j(he, 1, "flyout-toggle-item svelte-fpav0j", null, ve, Oe), D(he, "data-category", n(ie).props.title);
              },
              [
                () => ({
                  inactive: n(R) && n(R) !== n(ie).contentfulEntryId
                })
              ]
            ), w(Se, he);
          }, ce = (Se, he) => {
            {
              var ve = (se) => {
                var Oe = ef();
                let Ye;
                var Qe = S(Oe);
                mt(Qe, {
                  linkCustomCssClass: "nav-list-link",
                  get id() {
                    return n(ie).contentfulEntryId;
                  },
                  get title() {
                    return n(ie).props.title;
                  },
                  get url() {
                    return n(ie).props.url;
                  },
                  get linkStyle() {
                    return n(ie).props.linkStyle;
                  },
                  enableHoverOpacity: !0,
                  get openInNewTab() {
                    return n(ie).props.openInNewTab;
                  }
                }), _(Oe), L((Ve) => Ye = j(Oe, 1, "svelte-fpav0j", null, Ye, Ve), [
                  () => ({
                    inactive: n(R) && n(R) !== n(ie).contentfulEntryId
                  })
                ]), w(se, Oe);
              };
              F(
                Se,
                (se) => {
                  ft(n(ie).componentName) === "link" && se(ve);
                },
                he
              );
            }
          };
          F(te, (Se) => {
            ft(n(ie).componentName) === "category" ? Se(ue) : Se(ce, !1);
          });
        }
        w(we, $);
      }), _(Re);
      var q = H(Re, 2), me = S(q);
      {
        var Ne = (we) => {
          var ie = tf();
          let $;
          var te = S(ie);
          const ue = /* @__PURE__ */ Z(() => {
            var se;
            return (se = n(M)) == null ? void 0 : se.contentfulEntryId;
          }), ce = /* @__PURE__ */ Z(() => {
            var se, Oe;
            return (Oe = (se = n(M)) == null ? void 0 : se.props) == null ? void 0 : Oe.title;
          }), Se = /* @__PURE__ */ Z(() => {
            var se, Oe;
            return (Oe = (se = n(M)) == null ? void 0 : se.props) == null ? void 0 : Oe.url;
          }), he = /* @__PURE__ */ Z(() => {
            var se, Oe;
            return (Oe = (se = n(M)) == null ? void 0 : se.props) == null ? void 0 : Oe.linkStyle;
          }), ve = /* @__PURE__ */ Z(() => {
            var se, Oe;
            return (Oe = (se = n(M)) == null ? void 0 : se.props) == null ? void 0 : Oe.openInNewTab;
          });
          mt(te, {
            get id() {
              return n(ue);
            },
            get title() {
              return n(ce);
            },
            get url() {
              return n(Se);
            },
            get linkStyle() {
              return n(he);
            },
            get openInNewTab() {
              return n(ve);
            }
          }), _(ie), L((se) => $ = j(ie, 1, "cta-button svelte-fpav0j", null, $, se), [() => ({ isVisible: n(A) })]), w(we, ie);
        };
        F(me, (we) => {
          n(M) && n(A) && we(Ne);
        });
      }
      var Ce = H(me, 2);
      {
        var Pe = (we) => {
          var ie = nf(), $ = S(ie);
          const te = /* @__PURE__ */ Z(() => {
            var ve;
            return (ve = n(B)) == null ? void 0 : ve.contentfulEntryId;
          }), ue = /* @__PURE__ */ Z(() => {
            var ve, se;
            return (se = (ve = n(B)) == null ? void 0 : ve.props) == null ? void 0 : se.title;
          }), ce = /* @__PURE__ */ Z(() => {
            var ve, se;
            return (se = (ve = n(B)) == null ? void 0 : ve.props) == null ? void 0 : se.url;
          }), Se = /* @__PURE__ */ Z(() => {
            var ve, se;
            return (se = (ve = n(B)) == null ? void 0 : ve.props) == null ? void 0 : se.linkStyle;
          }), he = /* @__PURE__ */ Z(() => {
            var ve, se;
            return (se = (ve = n(B)) == null ? void 0 : ve.props) == null ? void 0 : se.openInNewTab;
          });
          mt($, {
            get id() {
              return n(te);
            },
            get title() {
              return n(ue);
            },
            get url() {
              return n(ce);
            },
            get linkStyle() {
              return n(Se);
            },
            get openInNewTab() {
              return n(he);
            }
          }), _(ie), w(we, ie);
        };
        F(Ce, (we) => {
          n(B) && we(Pe);
        });
      }
      _(q), _(De), L((we) => ge = j(Re, 1, "cta-subnav-list svelte-fpav0j", null, ge, we), [
        () => ({
          ctaIsVisible: n(A),
          primaryCtaFirst: n(W)
        })
      ]), w(_e, De);
    };
    F(pe, (_e) => {
      (n(M) || n(B) || n(G).length > 0) && _e(ze);
    });
  }
  _(je), _(J), nt(J, (_e) => O(E, _e), () => n(E)), _(U), L(
    (_e) => {
      X = j(J, 1, "cta-subnav-container svelte-fpav0j", null, X, _e), D(J, "data-entry-id", l()), ee = Te(J, "", ee, { width: `${n(b)}px` });
    },
    [
      () => ({
        isSticky: y(),
        useTransitions: n(k),
        hiddenUntilScrolled: h()
      })
    ]
  ), it(J, "offsetHeight", (_e) => O(N, _e)), it(U, "offsetWidth", (_e) => O(b, _e)), w(t, K), le(), a();
}
function of() {
  const { subscribe: t, update: e } = We({
    direction: null,
    isPastWaypoint: !1,
    offsetY: 0
  });
  let r = 0, a = null, i = null, s = !1;
  function o() {
    s = !0;
  }
  function l() {
    if (!a) {
      if (s) {
        s = !1;
        return;
      }
      a = window.setTimeout(() => {
        const c = window.scrollY, v = c > r ? "down" : "up";
        u(c), d(v), a = null;
      }, bd);
    }
  }
  function u(c) {
    c !== r && (e((v) => (v.offsetY = c, v)), r = c);
  }
  function d(c) {
    c !== i && (e((v) => (v.direction = c, v)), i = c);
  }
  function f(c) {
    e((v) => (v.isPastWaypoint = c, v));
  }
  return typeof window < "u" && window.addEventListener("scroll", l, { passive: !0 }), {
    subscribe: t,
    setWaypointPassed: f,
    setIgnoreNextScroll: o
  };
}
const ti = of();
function Ks(t, e) {
  oe(e, !0);
  const r = g(e, "shouldLock", 3, !1), a = g(e, "delayLockAfter", 3, 0);
  let i = null, s = !1, o, l, u, d, f;
  function c() {
    typeof window > "u" || !o || s || (s = !0, l = o.style.overflowY, u = o.style.position, f = o.style.width, d = window.scrollY, d && ti.setIgnoreNextScroll(), i && (clearTimeout(i), i = null), i = setTimeout(
      () => {
        o && (o.style.overflowY = "scroll", o.style.position = "fixed", o.style.width = "100%");
      },
      a()
    ));
  }
  function v() {
    typeof window > "u" || !o || !s || (i && (clearTimeout(i), i = null), o.style.overflowY = l, o.style.position = u, o.style.width = f, d && window.scrollTo(0, d), s = !1);
  }
  ut(() => {
    r() ? c() : v();
  }), _t(() => (o = document.body, l = o.style.overflowY, u = o.style.position, f = o.style.width, r() ? c() : v(), () => {
    v();
  })), le();
}
var lf = /* @__PURE__ */ x('<button type="button" class="CloseButton svelte-7crrdp"><span class="text svelte-7crrdp"><!></span> <span class="icon svelte-7crrdp" aria-hidden="true"><span class="iconBarClockwise svelte-7crrdp"></span> <span class="iconBarCounterwise svelte-7crrdp"></span></span></button>');
function uf(t, e) {
  const r = g(e, "openText", 3, "Open menu"), a = g(e, "closeText", 3, "Close menu"), i = g(e, "isActive", 3, !1), s = g(e, "clickTouchFn", 3, () => {
  });
  var o = lf(), l = S(o), u = S(l);
  {
    var d = (c) => {
      var v = Zn();
      L(() => fe(v, a())), w(c, v);
    }, f = (c) => {
      var v = Zn();
      L(() => fe(v, r())), w(c, v);
    };
    F(u, (c) => {
      i() ? c(d) : c(f, !1);
    });
  }
  _(l), wn(2), _(o), ne(o, (c, v) => He == null ? void 0 : He(c, v), s), w(t, o);
}
var cf = /* @__PURE__ */ x('<button><span class="text svelte-1cgv5h3"> </span> <svg width="18" height="20" viewBox="0 0 15 17" fill="none" class="svelte-1cgv5h3"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 7.79297C-0.0976311 8.18349 -0.0976311 8.81666 0.292893 9.20718L7.29289 16.2072L8.70711 14.793L3.41421 9.50008L15 9.50008L15 7.50008L3.41421 7.50008L8.70711 2.20718L7.29289 0.792969L0.292893 7.79297Z" fill="black" class="svelte-1cgv5h3"></path></svg></button>');
function Xs(t, e) {
  const r = g(e, "isActive", 3, !1), a = g(e, "clickTouchFn", 3, () => {
  });
  var i = cf();
  let s;
  var o = S(i), l = S(o, !0);
  _(o), wn(2), _(i), ne(i, (u, d) => He == null ? void 0 : He(u, d), a), L(
    (u) => {
      s = j(i, 1, "BackButton svelte-1cgv5h3", null, s, u), fe(l, e.text || "Go back to previous menu screen");
    },
    [() => ({ active: r() })]
  ), w(t, i);
}
function vf() {
  const { subscribe: t, update: e } = We({
    isOpen: !1,
    hasNavLinks: null,
    activeContentStack: []
  });
  function r(o) {
    e((l) => (l.activeContentStack.push(o), l));
  }
  function a() {
    e((o) => (o.activeContentStack.pop(), o));
  }
  function i() {
    e((o) => (o.isOpen = !o.isOpen, o.activeContentStack = [], o));
  }
  function s(o) {
    e((l) => (l.hasNavLinks = o, l));
  }
  return {
    push: r,
    pop: a,
    subscribe: t,
    toggle: i,
    setHasNavLinks: s
  };
}
const yn = vf();
function df() {
  const { subscribe: t, update: e } = We({
    isOpen: !1,
    activeContentStack: [],
    showHeightTransition: !0
  });
  function r(s) {
    e((o) => (o.activeContentStack.push(s), o));
  }
  function a() {
    e((s) => (s.activeContentStack.pop(), s));
  }
  function i(s) {
    const o = (s == null ? void 0 : s.openFromSubnav) ?? !1;
    e((l) => (l.showHeightTransition = !o, l.activeContentStack = [], l.isOpen = !l.isOpen, l));
  }
  return {
    push: r,
    pop: a,
    subscribe: t,
    toggle: i
  };
}
const kt = df();
var ff = /* @__PURE__ */ x('<div class="transition-shim svelte-svij48" aria-hidden="true"></div>'), gf = /* @__PURE__ */ x('<li class="svelte-svij48"><!></li>'), pf = /* @__PURE__ */ x('<div class="category-item-list svelte-svij48"><!></div>'), hf = /* @__PURE__ */ x('<!> <div class="Dropdown svelte-svij48"><div><div><div class="left-slot svelte-svij48"><!></div> <div class="right-slot svelte-svij48"><!></div></div> <div><ul class="svelte-svij48"><!> <!></ul></div></div></div>', 1);
function mf(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(yn, "$mobileCtaSubnavMenuStateStore", r), s = () => re(kt, "$mobileNavStateStore", r), o = g(e, "navItems", 19, () => []), l = g(e, "mobileNavWidth", 3, 0), u = qt();
  let d = /* @__PURE__ */ Ue(0), f = /* @__PURE__ */ Ue(void 0);
  const c = /* @__PURE__ */ Z(() => o().filter((U) => ft(U.componentName) === "link")), v = /* @__PURE__ */ Z(() => o().filter((U) => ft(U.componentName) === "category" && y(U)));
  function p() {
    yn.toggle(), u({
      eventName: "Close Menu",
      properties: {
        currentPage: vt(),
        isCloseButton: !0,
        menuLocation: Ot(n(f)),
        navDeviceType: dt(n(f))
      }
    });
  }
  function h() {
    kt.toggle({ openFromSubnav: !0 }), u({
      eventName: "Open Drawer",
      properties: {
        currentPage: vt(),
        menuLocation: Qa.MAIN_NAVIGATION,
        navDeviceType: dt(n(f))
      }
    });
  }
  function m() {
    var U;
    p(), h(), (U = document.querySelector(wd)) == null || U.focus();
  }
  function y(U) {
    return "primaryNavItems" in U.props ? U.props : null;
  }
  var I = hf(), C = ye(I);
  {
    var T = (U) => {
      var J = ff();
      w(U, J);
    };
    F(C, (U) => {
      (i().isOpen || s().isOpen) && U(T);
    });
  }
  var N = H(C, 2);
  let b;
  var E = S(N), k = S(E);
  let A, P;
  var M = S(k), z = S(M);
  Xs(z, {
    get isActive() {
      return i().isOpen;
    },
    clickTouchFn: m,
    text: "Go to main menu"
  }), _(M);
  var B = H(M, 2), G = S(B);
  uf(G, {
    get isActive() {
      return i().isOpen;
    },
    clickTouchFn: p
  }), _(B), _(k);
  var R = H(k, 2);
  let W;
  var K = S(R), Q = S(K);
  qe(Q, 17, () => n(c), Je, (U, J, X) => {
    var ee = gf();
    Te(ee, "", {}, { "--dropdown-item-number": X + 1 });
    var Ee = S(ee);
    mt(Ee, {
      linkCustomCssClass: "subcategory-large-link",
      get id() {
        return n(J).contentfulEntryId;
      },
      get title() {
        return n(J).props.title;
      },
      get url() {
        return n(J).props.url;
      },
      get linkStyle() {
        return n(J).props.linkStyle;
      },
      get openInNewTab() {
        return n(J).props.openInNewTab;
      }
    }), _(ee), w(U, ee);
  });
  var V = H(Q, 2);
  qe(V, 17, () => n(v), Je, (U, J) => {
    var X = pf(), ee = S(X);
    const Ee = /* @__PURE__ */ Z(() => {
      var Ie;
      return (Ie = y(n(J))) == null ? void 0 : Ie.primaryNavItems;
    });
    Bn(ee, {
      get id() {
        return n(J).contentfulEntryId;
      },
      get title() {
        return n(J).props.title;
      },
      get navItems() {
        return n(Ee);
      },
      get linkStartingIndex() {
        return n(c).length;
      }
    }), _(X), w(U, X);
  }), _(K), _(R), _(E), _(N), nt(N, (U) => O(f, U), () => n(f)), L(
    (U, J) => {
      b = Te(N, "", b, { height: `${n(d)}px` }), A = j(k, 1, "header svelte-svij48", null, A, U), P = Te(k, "", P, { width: `${l()}px` }), W = j(R, 1, "dropdown-nav-item-container slide-in-from-top svelte-svij48", null, W, J);
    },
    [
      () => ({
        active: i().isOpen
      }),
      () => ({
        active: i().isOpen
      })
    ]
  ), it(E, "clientHeight", (U) => O(d, U)), w(t, I), le(), a();
}
const Qs = xl(
  [ti, yn],
  ([t, e]) => t.direction === "up" && t.offsetY > Id && e.hasNavLinks === !1
);
var yf = /* @__PURE__ */ x('<button class="dropdown-toggle svelte-1p3tb31" aria-haspopup="true"><span class="title svelte-1p3tb31"> </span> <!></button>'), _f = /* @__PURE__ */ x('<span class="title svelte-1p3tb31"> </span>'), Sf = /* @__PURE__ */ x("<div><!></div>"), bf = /* @__PURE__ */ x('<div class="shim svelte-1p3tb31" aria-hidden="true"></div> <div aria-hidden="true"></div> <div><!></div> <!>', 1), If = /* @__PURE__ */ x("<div><!> <!></div>"), wf = /* @__PURE__ */ x('<nav class="MobileNav svelte-1p3tb31" data-cta-subnav-mobile-v2=""><!> <!></nav> <!>', 1);
function Cf(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(b, "$currentUrlStore", r), s = () => re(N, "$loggedInStore", r), o = () => re(T, "$cartCountStore", r), l = () => re(yn, "$mobileCtaSubnavMenuStateStore", r), u = () => re(Qs, "$mobileNavIsSticky", r), d = () => re(kt, "$mobileNavStateStore", r), f = g(e, "id", 3, ""), c = g(e, "title", 3, ""), v = g(e, "navItems", 19, () => []), p = g(e, "primaryCtaButton", 3, void 0), h = g(e, "secondaryCtaButton", 3, void 0), m = g(e, "showCtaOnCtaPage", 3, !1), y = g(e, "hiddenUntilScrolled", 3, !1), I = g(e, "disableIconCtaOnMobile", 3, !1), C = g(e, "isSticky", 3, !1), T = Fn(), N = Nr(), b = zs(), E = qt();
  let k = /* @__PURE__ */ Ue(void 0), A = /* @__PURE__ */ Ue(void 0), P = /* @__PURE__ */ Ue(void 0);
  const M = /* @__PURE__ */ Z(() => Zs({
    primaryCtaButton: p(),
    showCtaOnCtaPage: m(),
    currentUrl: i(),
    loggedIn: s(),
    cartCount: o()
  })), z = /* @__PURE__ */ Z(() => n(M) ? p() : void 0), B = /* @__PURE__ */ Z(() => Js({
    secondaryCtaButton: h(),
    loggedIn: s(),
    cartCount: o()
  })), G = /* @__PURE__ */ Z(() => {
    var Ae, je;
    return I() || !((je = (Ae = n(z)) == null ? void 0 : Ae.props) != null && je.icon);
  }), R = /* @__PURE__ */ Z(() => n(B) ? h() : void 0), W = /* @__PURE__ */ Z(() => Xn({
    items: v(),
    loggedIn: s(),
    cartCount: o()
  }));
  ut(() => {
    yn.setHasNavLinks(n(W).length > 0);
  });
  function K() {
    l().isOpen ? E({
      eventName: "Close Menu",
      properties: {
        currentPage: vt(),
        menuId: f(),
        menuText: c(),
        menuLocation: Ot(n(P)),
        navDeviceType: dt(n(P))
      }
    }) : E({
      eventName: "Open Drawer",
      properties: {
        currentPage: vt(),
        menuId: f(),
        menuText: c(),
        menuLocation: Ot(n(P)),
        navDeviceType: dt(n(P))
      }
    }), yn.toggle();
  }
  _t(() => {
    n(P) && (n(P).style.position = "");
  });
  var Q = wf(), V = ye(Q), U = S(V);
  {
    var J = (Ae) => {
      var je = bf(), pe = ye(je);
      let ze;
      var _e = H(pe, 2);
      let De;
      var Re = H(_e, 2);
      let ge, q;
      var me = S(Re);
      {
        var Ne = (ie) => {
          var $ = yf(), te = S($), ue = S(te, !0);
          _(te);
          var ce = H(te, 2);
          qs(ce, {
            get isOpen() {
              return l().isOpen;
            }
          }), _($), ne($, (Se, he) => He == null ? void 0 : He(Se, he), () => K), L(() => {
            D($, "aria-expanded", l().isOpen), D($, "aria-controls", Ei), fe(ue, c());
          }), w(ie, $);
        }, Ce = (ie) => {
          var $ = _f(), te = S($, !0);
          _($), L(() => fe(te, c())), w(ie, $);
        };
        F(me, (ie) => {
          var $;
          (($ = n(W)) == null ? void 0 : $.length) > 0 ? ie(Ne) : ie(Ce, !1);
        });
      }
      _(Re), nt(Re, (ie) => O(P, ie), () => n(P));
      var Pe = H(Re, 2);
      {
        var we = (ie) => {
          var $ = Sf(), te = S($);
          mf(te, {
            get navItems() {
              return n(W);
            },
            get mobileNavWidth() {
              return n(A);
            }
          }), _($), L(() => D($, "id", Ei)), w(ie, $);
        };
        F(Pe, (ie) => {
          n(W) && ie(we);
        });
      }
      L(
        (ie, $) => {
          ze = Te(pe, "", ze, {
            height: C() && !y() ? `${n(k)}px` : "0px"
          }), De = j(_e, 1, "transition-shim svelte-1p3tb31", null, De, ie), ge = j(Re, 1, "cta-subnav-menu-container svelte-1p3tb31", null, ge, $), D(Re, "data-entry-id", f()), q = Te(Re, "", q, { width: `${n(A)}px` });
        },
        [
          () => ({ globalNavIsSticky: u() }),
          () => ({
            isSticky: C(),
            globalNavIsSticky: u(),
            hiddenUntilScrolled: y()
          })
        ]
      ), it(Re, "offsetHeight", (ie) => O(k, ie)), w(Ae, je);
    };
    F(U, (Ae) => {
      c() && Ae(J);
    });
  }
  var X = H(U, 2);
  {
    var ee = (Ae) => {
      var je = If();
      let pe, ze;
      var _e = S(je);
      {
        var De = (q) => {
          const me = /* @__PURE__ */ Z(() => {
            var $;
            return ($ = n(R)) == null ? void 0 : $.contentfulEntryId;
          }), Ne = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(R)) == null ? void 0 : $.props) == null ? void 0 : te.title;
          }), Ce = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(R)) == null ? void 0 : $.props) == null ? void 0 : te.url;
          }), Pe = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(R)) == null ? void 0 : $.props) == null ? void 0 : te.linkStyle;
          }), we = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(R)) == null ? void 0 : $.props) == null ? void 0 : te.icon;
          }), ie = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(R)) == null ? void 0 : $.props) == null ? void 0 : te.openInNewTab;
          });
          mt(q, {
            get id() {
              return n(me);
            },
            get title() {
              return n(Ne);
            },
            get url() {
              return n(Ce);
            },
            get linkStyle() {
              return n(Pe);
            },
            get icon() {
              return n(we);
            },
            get openInNewTab() {
              return n(ie);
            }
          });
        };
        F(_e, (q) => {
          n(R) && q(De);
        });
      }
      var Re = H(_e, 2);
      {
        var ge = (q) => {
          const me = /* @__PURE__ */ Z(() => {
            var $;
            return ($ = n(z)) == null ? void 0 : $.contentfulEntryId;
          }), Ne = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(z)) == null ? void 0 : $.props) == null ? void 0 : te.title;
          }), Ce = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(z)) == null ? void 0 : $.props) == null ? void 0 : te.url;
          }), Pe = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(z)) == null ? void 0 : $.props) == null ? void 0 : te.linkStyle;
          }), we = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(z)) == null ? void 0 : $.props) == null ? void 0 : te.icon;
          }), ie = /* @__PURE__ */ Z(() => {
            var $, te;
            return (te = ($ = n(z)) == null ? void 0 : $.props) == null ? void 0 : te.openInNewTab;
          });
          mt(q, {
            get id() {
              return n(me);
            },
            get title() {
              return n(Ne);
            },
            get url() {
              return n(Ce);
            },
            get linkStyle() {
              return n(Pe);
            },
            get icon() {
              return n(we);
            },
            get openInNewTab() {
              return n(ie);
            }
          });
        };
        F(Re, (q) => {
          n(z) && q(ge);
        });
      }
      _(je), L(
        (q) => {
          pe = j(je, 1, "cta-button-container svelte-1p3tb31", null, pe, q), ze = Te(je, "", ze, { width: `${n(A)}px` });
        },
        [
          () => ({
            isSticky: C(),
            isVisible: C() || l().isOpen,
            disableLeftCtaIcon: n(G)
          })
        ]
      ), w(Ae, je);
    };
    F(X, (Ae) => {
      (n(z) || n(R)) && Ae(ee);
    });
  }
  _(V);
  var Ee = H(V, 2);
  const Ie = /* @__PURE__ */ Z(() => l().isOpen || d().isOpen);
  Ks(Ee, {
    get shouldLock() {
      return n(Ie);
    },
    get delayLockAfter() {
      return Ws;
    }
  }), it(V, "offsetWidth", (Ae) => O(A, Ae)), w(t, Q), le(), a();
}
var Nf = /* @__PURE__ */ x("<div></div>");
function Tf(t, e) {
  oe(e, !0);
  let r = g(e, "isPast", 15), a = g(e, "hiddenUntilScrolled", 3, !1), i = /* @__PURE__ */ Ue(void 0), s;
  _t(() => {
    s = new IntersectionObserver(o), s.observe(n(i));
  }), wr(() => {
    s && s.unobserve(n(i));
  });
  function o(d) {
    r(d[0].boundingClientRect.top < 0), ti.setWaypointPassed(r());
  }
  var l = Nf();
  let u;
  nt(l, (d) => O(i, d), () => n(i)), L((d) => u = j(l, 1, "Waypoint svelte-si089p", null, u, d), [
    () => ({ hiddenUntilScrolled: a() })
  ]), w(t, l), le();
}
var Ef = /* @__PURE__ */ x('<div class="CtaSubnav" data-cta-subnav-v2=""><!> <!> <!></div>');
function xf(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(yn, "$mobileCtaSubnavMenuStateStore", r), s = "pwn-has-sticky-cta-subnav", o = g(e, "id", 3, ""), l = g(e, "title", 3, ""), u = g(e, "navItems", 19, () => []), d = g(e, "primaryCtaButton", 3, void 0), f = g(e, "secondaryCtaButton", 3, void 0), c = g(e, "onlyShowCtaWhenSticky", 3, !1), v = g(e, "showCtaOnCtaPage", 3, !1), p = g(e, "disableStickyBehavior", 3, !1), h = g(e, "hiddenUntilScrolled", 3, !1), m = g(e, "reverseDesktopCtaButtons", 3, !1), y = g(e, "disableIconCtaOnMobile", 3, !1);
  let I = /* @__PURE__ */ Ue(void 0), C = /* @__PURE__ */ Ue(!1), T = /* @__PURE__ */ Ue(void 0);
  const N = /* @__PURE__ */ Z(() => n(T) === void 0 ? null : n(T) >= Sd), b = /* @__PURE__ */ Z(() => n(C) && !p());
  ut(() => {
    var M;
    (M = n(I)) == null || M.classList.toggle(s, !p());
  }), ut(() => {
    n(N) && i().isOpen && yn.toggle();
  }), _t(() => {
    O(I, document.documentElement, !0);
  });
  var E = Ef(), k = S(E);
  Tf(k, {
    get hiddenUntilScrolled() {
      return h();
    },
    get isPast() {
      return n(C);
    },
    set isPast(M) {
      O(C, M, !0);
    }
  });
  var A = H(k, 2);
  sf(A, {
    get id() {
      return o();
    },
    get title() {
      return l();
    },
    get navItems() {
      return u();
    },
    get primaryCtaButton() {
      return d();
    },
    get secondaryCtaButton() {
      return f();
    },
    get onlyShowCtaWhenSticky() {
      return c();
    },
    get showCtaOnCtaPage() {
      return v();
    },
    get hiddenUntilScrolled() {
      return h();
    },
    get reverseDesktopCtaButtons() {
      return m();
    },
    get isSticky() {
      return n(b);
    }
  });
  var P = H(A, 2);
  Cf(P, {
    get id() {
      return o();
    },
    get title() {
      return l();
    },
    get navItems() {
      return u();
    },
    get primaryCtaButton() {
      return d();
    },
    get secondaryCtaButton() {
      return f();
    },
    get showCtaOnCtaPage() {
      return v();
    },
    get hiddenUntilScrolled() {
      return h();
    },
    get disableIconCtaOnMobile() {
      return y();
    },
    get isSticky() {
      return n(b);
    }
  }), _(E), L(() => {
    D(E, "data-component-type", Qa.SUBNAVIGATION), D(E, "data-nav-device-type", n(N) ? "Desktop" : "Mobile");
  }), Ya("innerWidth", (M) => O(T, M, !0)), w(t, E), le(), a();
}
function kf(t = "LogoJewel") {
  const e = We(t);
  return Mt("LOGO", e), e;
}
function Of() {
  return Lt("LOGO") || We("LogoJewel");
}
var Lf = /* @__PURE__ */ x(
  `<svg class="LogoJewel svelte-1d2tadf" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 994.6 995.7" width="22" height="22"><path fill="black" d="M828.4,0H166.2C74.4,0,0,74.4,0,166.2v662.2c0,91.8,74.4,166.2,166.2,166.2h662.2
    c91.8,0,166.2-74.4,166.2-166.2V166.2C994.6,74.4,920.2,0,828.4,0z M813.8,761.3c0,29-23.5,52.5-52.5,52.5h-528
    c-29,0-52.5-23.5-52.5-52.5v-528c0-29,23.5-52.5,52.5-52.5h528c29,0,52.5,23.5,52.5,52.5V761.3z M391.8,632.3
    c-16.7,0-30.1-13.5-30.1-30.2V391.3c0-16.7,13.4-30.3,30.1-30.3h211.1c16.6,0,30.1,13.5,30.1,30.3V602c0,16.7-13.5,30.2-30.1,30.2
    H391.8z" class="svelte-1d2tadf"></path></svg> <span class="text svelte-1d2tadf"> </span>`,
  1
);
function xi(t, e) {
  const r = g(e, "title", 3, "Square");
  var a = Lf(), i = H(ye(a), 2), s = S(i, !0);
  _(i), L(() => fe(s, r())), w(t, a);
}
var Mf = /* @__PURE__ */ x(
  `<svg class="LogoLockup svelte-1qhoav6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3967.7 995.7" width="88" height="22"><path d="M828.4,0H166.2C74.4,0,0,74.4,0,166.2v662.2c0,91.8,74.4,166.2,166.2,166.2h662.2
    c91.8,0,166.2-74.4,166.2-166.2V166.2C994.6,74.4,920.2,0,828.4,0z M813.8,761.3c0,29-23.5,52.5-52.5,52.5h-528
    c-29,0-52.5-23.5-52.5-52.5v-528c0-29,23.5-52.5,52.5-52.5h528c29,0,52.5,23.5,52.5,52.5V761.3z M391.8,632.3
    c-16.7,0-30.1-13.5-30.1-30.2V391.3c0-16.7,13.4-30.3,30.1-30.3h211.1c16.6,0,30.1,13.5,30.1,30.3V602c0,16.7-13.5,30.2-30.1,30.2
    H391.8z M1258.3,617.9h108.6c5.4,61.5,47.1,109.5,131.2,109.5c75.1,0,121.3-37.1,121.3-93.2c0-52.5-36.2-76-101.4-91.4l-84.2-18.1
    c-91.4-19.9-160.2-78.7-160.2-174.7c0-105.9,94.1-178.3,216.3-178.3c129.4,0,212.7,67.9,219.9,168.3h-105
    C1592.3,293,1553.3,265,1490,265c-67,0-113.1,36.2-113.1,82.4s39.8,74.2,108.6,89.6l83.3,18.1c91.4,19.9,153.8,75.1,153.8,171.9
    c0,123.1-92.3,196.4-224.4,196.4C1349.7,823.3,1267.4,742.8,1258.3,617.9z M2111.1,994.6V814.5l7.1-79h-7.1
    c-24.9,56.8-77.2,87.9-148.2,87.9c-114.5,0-199.7-93.2-199.7-236.1c0-142.9,85.2-236.1,199.7-236.1c70.1,0,119.8,32.8,148.2,84.3
    h7.1V360h94.1v634.6H2111.1z M2114.6,587.2c0-91.4-55.9-144.7-124.3-144.7s-124.3,53.3-124.3,144.7c0,91.4,55.9,144.7,124.3,144.7
    S2114.6,678.7,2114.6,587.2z M2287.4,634.3V360h101.2v265.4c0,71.9,34.6,106.5,92.3,106.5c71,0,117.2-50.6,117.2-129.6V360h101.2
    v454.4h-94.1v-94.1h-7.1c-22.2,60.4-71,103-146.4,103C2343.3,823.3,2287.4,754.1,2287.4,634.3z M2760.9,687.5
    c0-85.2,59.5-134.9,165.1-141.1l125.1-8v-35.5c0-42.6-31.1-68.3-86.1-68.3c-50.6,0-80.8,25.7-88.8,62.1h-101.2
    c10.7-92.3,87-145.6,189.9-145.6c116.3,0,187.3,49.7,187.3,145.6v317.7h-94.1v-84.3h-7.1c-21.3,55.9-65.7,93.2-150.9,93.2
    C2818.6,823.3,2760.9,768.3,2760.9,687.5z M3051.2,631.6v-24l-102.1,7.1c-55,3.5-79.9,24-79.9,64.8c0,34.6,28.4,59.5,68.3,59.5
    C3009.5,739,3051.2,692.9,3051.2,631.6z M3227.7,814.5V360h94.1v87h7.1c13.3-59.5,58.6-87,126-87h46.2v91.4h-57.7
    c-65.7,0-114.5,42.6-114.5,123.4v239.6H3227.7z M3964.1,605.9h-345.3c5.3,83.4,63.9,130.5,128.7,130.5c55,0,89.6-22.2,109.2-59.5
    H3957c-27.5,92.3-108.3,146.4-210.4,146.4c-134,0-228.1-100.3-228.1-236.1c0-135.8,96.7-236.1,229-236.1
    c133.1,0,220.1,91.4,220.1,205C3967.7,578.4,3965.9,589.9,3964.1,605.9z M3867.4,535.8c-3.5-63-55.9-105.6-119.8-105.6
    c-60.4,0-110.9,38.2-123.4,105.6H3867.4z" fill="black" class="svelte-1qhoav6"></path></svg> <span class="text svelte-1qhoav6"> </span>`,
  1
);
function Af(t, e) {
  const r = g(e, "title", 3, "Square");
  var a = Mf(), i = H(ye(a), 2), s = S(i, !0);
  _(i), L(() => fe(s, r())), w(t, a);
}
var Df = /* @__PURE__ */ x('<a class="HomeLink svelte-13dv3ye"><!></a>');
function $s(t, e) {
  oe(e, !0);
  const r = g(e, "id", 3, ""), a = g(e, "title", 3, "Square"), i = g(e, "logo", 3, "LogoJewel"), s = g(e, "url", 3, "/");
  let o = /* @__PURE__ */ Ue(void 0);
  const l = qt(), d = {
    LogoJewel: xi,
    LogoLockup: Af
    // Easy to add new logo in the future:
  }[i()] || xi;
  function f() {
    let p;
    switch (window.Sq && window.Sq.Environment ? p = window.Sq.Environment.env : p = ad(window.location.hostname), p) {
      case "development":
      case "test":
        return "/";
      case "staging":
        return "https://squareupstaging.com";
      default:
        return "https://squareup.com";
    }
  }
  _t(() => {
    O(o, f(), !0);
  });
  var c = Df(), v = S(c);
  d(v, {
    get title() {
      return a();
    }
  }), _(c), ne(c, (p, h) => Gt == null ? void 0 : Gt(p, h), () => ({
    id: r(),
    title: a(),
    url: s(),
    trackFn: l
  })), L(() => {
    D(c, "data-entry-id", r()), D(c, "href", n(o));
  }), w(t, c), le();
}
var Rf = /* @__PURE__ */ x('<li class="button-item svelte-2kkkgi"><!></li>'), Pf = /* @__PURE__ */ x("<li><!></li>"), Uf = /* @__PURE__ */ x("<ul></ul>");
function qr(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(c, "$loggedInStore", r), s = () => re(f, "$cartCountStore", r), o = g(e, "navItems", 19, () => []), l = g(e, "cartPrimary", 3, !1), u = g(e, "listStartingIndex", 3, 0), d = g(e, "slideInFrom", 3, "top"), f = Fn(), c = Nr(), v = /* @__PURE__ */ Z(() => !l()), p = /* @__PURE__ */ Z(() => Xn({
    items: o(),
    loggedIn: i(),
    cartCount: s()
  }));
  var h = Uf();
  let m;
  qe(h, 21, () => n(p), Je, (y, I, C) => {
    var T = Ze(), N = ye(T);
    {
      var b = (E) => {
        var k = Ze(), A = ye(k);
        {
          var P = (z) => {
            var B = Rf();
            let G;
            var R = S(B);
            const W = /* @__PURE__ */ Z(() => {
              var J;
              return (J = n(I)) == null ? void 0 : J.contentfulEntryId;
            }), K = /* @__PURE__ */ Z(() => {
              var J, X;
              return (X = (J = n(I)) == null ? void 0 : J.props) == null ? void 0 : X.title;
            }), Q = /* @__PURE__ */ Z(() => {
              var J, X;
              return (X = (J = n(I)) == null ? void 0 : J.props) == null ? void 0 : X.url;
            }), V = /* @__PURE__ */ Z(() => {
              var J, X;
              return (X = (J = n(I)) == null ? void 0 : J.props) == null ? void 0 : X.linkStyle;
            }), U = /* @__PURE__ */ Z(() => {
              var J, X;
              return (X = (J = n(I)) == null ? void 0 : J.props) == null ? void 0 : X.openInNewTab;
            });
            mt(R, {
              get id() {
                return n(W);
              },
              get title() {
                return n(K);
              },
              get url() {
                return n(Q);
              },
              get linkStyle() {
                return n(V);
              },
              get openInNewTab() {
                return n(U);
              }
            }), _(B), L(() => G = Te(B, "", G, {
              "--item-list-item-number": u() + C + 1
            })), w(z, B);
          }, M = (z) => {
            var B = Pf();
            let G, R;
            var W = S(B);
            const K = /* @__PURE__ */ Z(() => {
              var X;
              return (X = n(I)) == null ? void 0 : X.contentfulEntryId;
            }), Q = /* @__PURE__ */ Z(() => {
              var X, ee;
              return (ee = (X = n(I)) == null ? void 0 : X.props) == null ? void 0 : ee.title;
            }), V = /* @__PURE__ */ Z(() => {
              var X, ee;
              return (ee = (X = n(I)) == null ? void 0 : X.props) == null ? void 0 : ee.url;
            }), U = /* @__PURE__ */ Z(() => {
              var X, ee;
              return (ee = (X = n(I)) == null ? void 0 : X.props) == null ? void 0 : ee.linkStyle;
            }), J = /* @__PURE__ */ Z(() => {
              var X, ee;
              return (ee = (X = n(I)) == null ? void 0 : X.props) == null ? void 0 : ee.openInNewTab;
            });
            mt(W, {
              linkCustomCssClass: "item-list-link",
              get id() {
                return n(K);
              },
              get title() {
                return n(Q);
              },
              get url() {
                return n(V);
              },
              get linkStyle() {
                return n(U);
              },
              enableHoverOpacity: !0,
              get openInNewTab() {
                return n(J);
              }
            }), _(B), L(
              (X) => {
                G = j(B, 1, "link-item svelte-2kkkgi", null, G, X), R = Te(B, "", R, {
                  "--item-list-item-number": u() + C + 1
                });
              },
              [() => ({ hidden: n(I).hidden })]
            ), w(z, B);
          };
          F(A, (z) => {
            var B, G, R, W;
            ((G = (B = n(I)) == null ? void 0 : B.props) == null ? void 0 : G.linkStyle) === "primary" || ((W = (R = n(I)) == null ? void 0 : R.props) == null ? void 0 : W.linkStyle) === "secondary" ? z(P) : z(M, !1);
          });
        }
        w(E, k);
      };
      F(N, (E) => {
        ft(n(I).componentName) === "link" && E(b);
      });
    }
    w(y, T);
  }), _(h), L((y) => m = j(h, 1, `ItemList slide-in-from-${d() ?? ""}`, "svelte-2kkkgi", m, y), [() => ({ marginTop: n(v) })]), w(t, h), le(), a();
}
var Bf = /* @__PURE__ */ x('<li class="link-list-container svelte-yp34p1"><!></li>'), Vf = /* @__PURE__ */ x('<ul class="SubcategoryLinkList slide-in-from-top svelte-yp34p1"><li class="link-list-container first-column svelte-yp34p1"></li> <!></ul>');
function Ff(t, e) {
  oe(e, !0);
  const r = e.subcategory.props.primaryNavItems.length - 1 || 1, a = e.subcategory.props.primaryNavItems.slice(0, 2), i = e.subcategory.props.primaryNavItems.slice(2), s = a.map((f) => f.props.primaryNavItems.length).reduce((f, c) => f + c, 0) + 1;
  var o = Vf();
  let l;
  var u = S(o);
  Te(u, "", {}, { "--link-list-number": 1 }), qe(u, 21, () => a, Je, (f, c, v) => {
    const p = /* @__PURE__ */ Z(() => {
      var h, m, y;
      return ((y = (m = (h = a[v - 1]) == null ? void 0 : h.props) == null ? void 0 : m.primaryNavItems) == null ? void 0 : y.length) + 1 || 0;
    });
    Bn(f, {
      get id() {
        return n(c).contentfulEntryId;
      },
      get title() {
        return n(c).props.title;
      },
      get excludeTitleOnDesktop() {
        return n(c).props.excludeTitleOnDesktop;
      },
      get navItems() {
        return n(c).props.primaryNavItems;
      },
      get linkStartingIndex() {
        return n(p);
      },
      slideInFrom: "top"
    });
  }), _(u);
  var d = H(u, 2);
  qe(d, 17, () => i, Je, (f, c, v) => {
    var p = Bf();
    Te(p, "", {}, { "--link-list-number": v + 2 });
    var h = S(p);
    Bn(h, {
      get id() {
        return n(c).contentfulEntryId;
      },
      get title() {
        return n(c).props.title;
      },
      get excludeTitleOnDesktop() {
        return n(c).props.excludeTitleOnDesktop;
      },
      get navItems() {
        return n(c).props.primaryNavItems;
      },
      get linkStartingIndex() {
        return s;
      },
      slideInFrom: "top"
    }), _(p), w(f, p);
  }), _(o), L(() => {
    D(o, "data-entry-id", e.subcategory.contentfulEntryId), l = Te(o, "", l, {
      "--subcategory-columns-count": r
    });
  }), w(t, o), le();
}
var Hf = /* @__PURE__ */ x("<span> </span>"), zf = /* @__PURE__ */ x("<source/>"), qf = /* @__PURE__ */ x('<picture class="svelte-1scc9wl"><!> <img class="image svelte-1scc9wl" fetchpriority="high" loading="lazy"/></picture>'), Wf = /* @__PURE__ */ x('<span class="image-title svelte-1scc9wl"> </span>'), jf = /* @__PURE__ */ x('<span class="image-subtitle svelte-1scc9wl"> </span>'), Gf = /* @__PURE__ */ x('<li class="svelte-1scc9wl"><a class="image-tile svelte-1scc9wl"><!> <div class="image-tile-text-container svelte-1scc9wl"><!> <!></div></a></li>'), Yf = /* @__PURE__ */ x('<div class="ImageListCategory svelte-1scc9wl"><!> <ul><ul></ul></ul></div>');
function Wr(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(h, "$darkModeStore", r), s = g(e, "id", 3, ""), o = g(e, "title", 3, ""), l = g(e, "navItems", 19, () => []), u = g(e, "alignment", 3, "left"), d = g(e, "containerSize", 3, "small"), f = g(e, "slideInFrom", 3, "top"), c = g(e, "showTitle", 3, !1), v = ["avif", "webp"], p = qt(), h = td();
  function m(b) {
    var E, k;
    return i() && ((E = b.props) != null && E.darkModeImage) ? b.props.darkModeImage : (k = b.props) == null ? void 0 : k.image;
  }
  var y = Yf(), I = S(y);
  {
    var C = (b) => {
      var E = Hf();
      Te(E, "", {}, { "--image-list-item-number": 1 });
      var k = S(E, !0);
      _(E), L(() => {
        j(E, 1, `title slide-in-from-${f() ?? ""}`, "svelte-1scc9wl"), fe(k, o());
      }), w(b, E);
    };
    F(I, (b) => {
      c() && b(C);
    });
  }
  var T = H(I, 2), N = S(T);
  qe(N, 21, l, Je, (b, E, k) => {
    var A = Gf();
    let P;
    var M = S(A), z = S(M);
    {
      var B = (V) => {
        var U = qf(), J = S(U);
        qe(J, 17, () => v, Je, (ee, Ee) => {
          var Ie = zf();
          L(
            (Ae) => {
              D(Ie, "srcset", Ae), D(Ie, "type", `image/${n(Ee) ?? ""}`);
            },
            [
              () => {
                var Ae, je;
                return `${(je = (Ae = m(n(E)).props) == null ? void 0 : Ae.file) == null ? void 0 : je.url}?fm=${n(Ee)}`;
              }
            ]
          ), w(ee, Ie);
        });
        var X = H(J, 2);
        _(U), L(
          (ee, Ee, Ie) => {
            D(X, "data-entry-id", ee), D(X, "alt", Ee), D(X, "src", Ie);
          },
          [
            () => m(n(E)).contentfulEntryId,
            () => {
              var ee;
              return (ee = m(n(E)).props) == null ? void 0 : ee.description;
            },
            () => {
              var ee, Ee;
              return (Ee = (ee = m(n(E)).props) == null ? void 0 : ee.file) == null ? void 0 : Ee.url;
            }
          ]
        ), w(V, U);
      };
      F(z, (V) => {
        m(n(E)) && V(B);
      });
    }
    var G = H(z, 2), R = S(G);
    {
      var W = (V) => {
        var U = Wf(), J = S(U, !0);
        _(U), L(() => {
          var X;
          return fe(J, (X = n(E).props) == null ? void 0 : X.title);
        }), w(V, U);
      };
      F(R, (V) => {
        var U;
        (U = n(E).props) != null && U.title && V(W);
      });
    }
    var K = H(R, 2);
    {
      var Q = (V) => {
        var U = jf(), J = S(U, !0);
        _(U), L(() => {
          var X;
          return fe(J, (X = n(E).props) == null ? void 0 : X.subtitle);
        }), w(V, U);
      };
      F(K, (V) => {
        var U;
        (U = n(E).props) != null && U.subtitle && V(Q);
      });
    }
    _(G), _(M), ne(M, (V) => Nt == null ? void 0 : Nt(V)), ne(M, (V, U) => Gt == null ? void 0 : Gt(V, U), () => {
      var V, U, J;
      return {
        id: n(E).contentfulEntryId,
        title: `${(V = n(E).props) == null ? void 0 : V.title} ${((U = n(E).props) == null ? void 0 : U.subtitle) || ""}`.trim(),
        url: (J = n(E).props) == null ? void 0 : J.url,
        trackFn: p
      };
    }), _(A), L(() => {
      var V;
      P = Te(A, "", P, {
        "--image-list-item-number": k + (c() ? 2 : 1)
      }), D(M, "data-entry-id", n(E).contentfulEntryId), D(M, "href", (V = n(E).props) == null ? void 0 : V.url);
    }), w(b, A);
  }), _(N), _(T), _(y), L(() => {
    D(y, "data-entry-id", s()), j(T, 1, `list-container alignment-${u() ?? ""} ${d() ?? ""}-list-container`, "svelte-1scc9wl"), j(N, 1, `image-tile-list slide-in-from-${f() ?? ""}`, "svelte-1scc9wl");
  }), w(t, y), le(), a();
}
var Zf = (t, e, r) => e(t, n(r)), Jf = /* @__PURE__ */ x('<div class="trigger-col svelte-cm2ops"><div><button aria-haspopup="true"><span> </span></button></div></div> <div><!></div>', 1), Kf = /* @__PURE__ */ x("<li><!></li>"), Xf = /* @__PURE__ */ x('<!> <div><ul class="secondary-dropdown-nav-item-list svelte-cm2ops"><!></ul></div>', 1), Qf = /* @__PURE__ */ x("<div><!></div>");
function $f(t, e) {
  var y;
  oe(e, !0);
  const [r, a] = ke(), i = () => re(xt, "$activeDropdownStore", r);
  let s = /* @__PURE__ */ Ue(void 0), o = /* @__PURE__ */ Ue(0), l = /* @__PURE__ */ Ue(null);
  const u = (((y = e.navItem.props.primaryNavItems) == null ? void 0 : y.length) || 0) + (e.navItem.props.secondaryNavItems ? 1 : 0), d = qt();
  function f(I) {
    i().subcategoryId !== I.contentfulEntryId && d({
      eventName: "Open Menu",
      properties: {
        currentPage: vt(),
        menuId: I.contentfulEntryId,
        menuText: I.props.title,
        menuCategory: Aa(n(s)),
        menuSubcategory: I.props.title,
        menuLocation: Ot(n(s)),
        navDeviceType: dt(n(s))
      }
    }), i().subcategoryId !== I.contentfulEntryId && xt.openSubcategory(I.contentfulEntryId);
  }
  ut(() => {
    i().id && i().id !== e.navItem.contentfulEntryId && O(l, null), i().contentHeight || O(l, null);
  });
  function c(I, C) {
    I.key === "Enter" && (i().subcategoryId !== C.contentfulEntryId && d({
      eventName: "Open Menu",
      properties: {
        currentPage: vt(),
        menuId: C.contentfulEntryId,
        menuText: C.props.title,
        menuCategory: Aa(n(s)),
        menuSubcategory: C.props.title,
        menuLocation: Ot(n(s)),
        navDeviceType: dt(n(s))
      }
    }), i().subcategoryId === C.contentfulEntryId ? xt.closeSubcategory() : xt.openSubcategory(C.contentfulEntryId));
  }
  var v = Qf();
  let p, h;
  var m = S(v);
  ul(m, () => n(o), (I) => {
    var C = Xf(), T = ye(C);
    {
      var N = (M) => {
        var z = Ze(), B = ye(z);
        qe(B, 17, () => e.navItem.props.primaryNavItems, Je, (G, R, W) => {
          var K = Jf(), Q = ye(K), V = S(Q);
          let U;
          Te(V, "", {}, { "--slide-in-item-index": W + 1 });
          var J = S(V);
          let X;
          J.__keydown = [Zf, c, R];
          var ee = S(J), Ee = S(ee, !0);
          _(ee), _(J), ne(J, (_e, De) => rt == null ? void 0 : rt(_e, De), () => [
            () => {
              f(n(R)), O(l, n(R).contentfulEntryId, !0);
            },
            () => {
            },
            Rn,
            Pn
          ]), _(V), _(Q);
          var Ie = H(Q, 2);
          let Ae;
          var je = S(Ie);
          {
            var pe = (_e) => {
              Wr(_e, {
                get id() {
                  return n(R).contentfulEntryId;
                },
                get title() {
                  return n(R).props.title;
                },
                get navItems() {
                  return n(R).props.navItems;
                }
              });
            }, ze = (_e, De) => {
              {
                var Re = (ge) => {
                  Ff(ge, {
                    get subcategory() {
                      return n(R);
                    }
                  });
                };
                F(
                  _e,
                  (ge) => {
                    var q;
                    ft((q = n(R)) == null ? void 0 : q.componentName) === "category" && ge(Re);
                  },
                  De
                );
              }
            };
            F(je, (_e) => {
              var De;
              ft((De = n(R)) == null ? void 0 : De.componentName) === "imageListCategory" ? _e(pe) : _e(ze, !1);
            });
          }
          _(Ie), L(
            (_e, De, Re) => {
              U = j(V, 1, "svelte-cm2ops", null, U, _e), X = j(J, 1, "toggle svelte-cm2ops", null, X, De), D(J, "aria-expanded", i().subcategoryId === n(R).contentfulEntryId), D(J, "aria-controls", `global-nav-desktop-subcategory-col-${n(R).contentfulEntryId}`), D(J, "data-entry-id", n(R).contentfulEntryId), fe(Ee, n(R).props.title), D(Ie, "id", `global-nav-desktop-subcategory-col-${n(R).contentfulEntryId ?? ""}`), Ae = j(Ie, 1, "subcategory-col svelte-cm2ops", null, Ae, Re), D(Ie, "data-subcategory", n(R).props.title);
            },
            [
              () => ({
                "slide-in-target": i().showSlideInAnimation
              }),
              () => ({
                inactive: n(l) && n(l) !== n(R).contentfulEntryId
              }),
              () => ({
                active: i().subcategoryId === n(R).contentfulEntryId
              })
            ]
          ), w(G, K);
        }), w(M, z);
      };
      F(T, (M) => {
        var z;
        (z = e.navItem.props.primaryNavItems) != null && z.length && M(N);
      });
    }
    var b = H(T, 2);
    let E;
    var k = S(b), A = S(k);
    {
      var P = (M) => {
        var z = Ze(), B = ye(z);
        qe(B, 17, () => e.navItem.props.secondaryNavItems, Je, (G, R, W) => {
          var K = Kf();
          let Q, V;
          var U = S(K);
          const J = /* @__PURE__ */ Z(() => [
            () => {
              xt.closeSubcategory(), O(l, n(R).contentfulEntryId, !0);
            },
            () => {
            },
            Rn,
            Pn
          ]);
          mt(U, {
            linkCustomCssClass: "subcategory-small-link",
            get id() {
              return n(R).contentfulEntryId;
            },
            get title() {
              return n(R).props.title;
            },
            get url() {
              return n(R).props.url;
            },
            get linkStyle() {
              return n(R).props.linkStyle;
            },
            get openInNewTab() {
              return n(R).props.openInNewTab;
            },
            get hoverWithDelayConfig() {
              return n(J);
            }
          }), _(K), L(
            (X) => {
              var ee;
              Q = j(K, 1, "svelte-cm2ops", null, Q, X), V = Te(K, "", V, {
                "--slide-in-item-index": (((ee = e.navItem.props.primaryNavItems) == null ? void 0 : ee.length) || 0) + W + 1
              });
            },
            [
              () => ({
                "slide-in-target": i().showSlideInAnimation,
                inactive: n(l) && n(l) !== n(R).contentfulEntryId
              })
            ]
          ), w(G, K);
        }), w(M, z);
      };
      F(A, (M) => {
        var z, B;
        (B = (z = e.navItem.props) == null ? void 0 : z.secondaryNavItems) != null && B.length && M(P);
      });
    }
    _(k), _(b), L((M) => E = j(b, 1, "secondary-links-list svelte-cm2ops", null, E, M), [
      () => {
        var M;
        return {
          "has-primary-nav-items": !!((M = e.navItem.props.primaryNavItems) != null && M.length)
        };
      }
    ]), w(I, C);
  }), _(v), nt(v, (I) => O(s, I), () => n(s)), L(
    (I) => {
      p = j(v, 1, "NavigationCategoryGrid svelte-cm2ops", null, p, I), h = Te(v, "", h, {
        "--subcategory-row-end": `${u + 1}`,
        "--grid-rows-count": u - 1
      });
    },
    [
      () => ({
        "max-column-width": n(o) * 0.33 > yd
      })
    ]
  ), it(v, "offsetWidth", (I) => O(o, I)), w(t, v), le(), a();
}
Wa(["keydown"]);
var e1 = /* @__PURE__ */ x('<div class="image-list-container svelte-wwwhvf"><!></div>'), t1 = /* @__PURE__ */ x('<div class="Dropdown"><button class="DropdownToggle svelte-wwwhvf" aria-haspopup="true"><span> </span></button> <div><!></div></div>');
function n1(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(xt, "$activeDropdownStore", r), s = () => re(d, "$logoStore", r);
  let o = /* @__PURE__ */ Ue(void 0), l = /* @__PURE__ */ Ue(void 0);
  const u = qt(), d = Of();
  function f() {
    xt.open(e.item.contentfulEntryId), u({
      eventName: "Open Menu",
      properties: {
        currentPage: vt(),
        menuId: e.item.contentfulEntryId,
        menuText: e.item.props.title,
        menuCategory: e.item.props.title,
        menuLocation: Ot(n(l)),
        navDeviceType: dt(n(l))
      }
    });
  }
  function c() {
    i().id === e.item.contentfulEntryId && (u({
      eventName: "Close Menu",
      properties: {
        currentPage: vt(),
        menuId: e.item.contentfulEntryId,
        menuText: e.item.props.title,
        menuCategory: e.item.props.title,
        menuLocation: Ot(n(l)),
        navDeviceType: dt(n(l))
      }
    }), xt.close());
  }
  function v() {
    i().id === e.item.contentfulEntryId ? c() : f();
  }
  const p = /* @__PURE__ */ Z(() => i().id === e.item.contentfulEntryId);
  ut(() => {
    n(p) && n(o) !== i().contentHeight && xt.updateContentHeight(n(o));
  });
  var h = t1(), m = S(h), y = S(m), I = S(y, !0);
  _(y), _(m), ne(m, (k, A) => He == null ? void 0 : He(k, A), () => v);
  var C = H(m, 2);
  let T;
  var N = S(C);
  {
    var b = (k) => {
      var A = e1(), P = S(A);
      const M = /* @__PURE__ */ Z(() => {
        var B;
        return (B = e.item.props) == null ? void 0 : B.title;
      }), z = /* @__PURE__ */ Z(() => {
        var B;
        return (B = e.item.props) == null ? void 0 : B.navItems;
      });
      Wr(P, {
        get id() {
          return e.item.contentfulEntryId;
        },
        get title() {
          return n(M);
        },
        get navItems() {
          return n(z);
        },
        alignment: "center",
        containerSize: "large"
      }), _(A), w(k, A);
    }, E = (k) => {
      $f(k, {
        get navItem() {
          return e.item;
        }
      });
    };
    F(N, (k) => {
      e.item.componentName === "PublicWebNavigationImageListCategoryV2" ? k(b) : k(E, !1);
    });
  }
  _(C), _(h), nt(h, (k) => O(l, k), () => n(l)), ne(h, (k, A) => rt == null ? void 0 : rt(k, A), () => [
    f,
    c,
    Rn,
    Pn
  ]), L(
    (k) => {
      D(h, "data-category", e.item.props.title), D(m, "data-entry-id", e.item.contentfulEntryId), D(m, "aria-expanded", n(p)), D(m, "aria-controls", `global-nav-desktop-dropdown-content-${e.item.contentfulEntryId}`), fe(I, e.item.props.title), D(C, "id", `global-nav-desktop-dropdown-content-${e.item.contentfulEntryId ?? ""}`), T = j(C, 1, "DropdownContent svelte-wwwhvf", null, T, k);
    },
    [
      () => ({
        active: n(p),
        "logo-lockup-padding-left": s() === "LogoLockup"
      })
    ]
  ), it(C, "clientHeight", (k) => O(o, k)), w(t, h), le(), a();
}
var r1 = /* @__PURE__ */ x("<li><!></li>"), a1 = /* @__PURE__ */ x("<li><!></li>"), i1 = /* @__PURE__ */ x("<li><!></li>"), s1 = /* @__PURE__ */ x('<ul class="NavList svelte-1mu45jj"></ul>');
function ki(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(c, "$loggedInStore", r), s = () => re(f, "$cartCountStore", r), o = g(e, "navItems", 19, () => []), l = g(e, "enableLinkHoverOpacity", 3, !1), u = g(e, "enableInactiveState", 3, !1), d = g(e, "shouldRenderFlyout", 3, !1), f = Fn(), c = Nr();
  let v = /* @__PURE__ */ Ue(""), p = /* @__PURE__ */ Ue("");
  const h = xt.subscribe((T) => {
    T != null && T.id ? (O(v, T.id, !0), O(p, "dropdown")) : n(p) !== "link" && (O(v, ""), O(p, ""));
  }), m = /* @__PURE__ */ Z(() => Xn({
    items: o(),
    loggedIn: i(),
    cartCount: s()
  }));
  function y(T, N) {
    O(v, T, !0), O(p, N, !0);
  }
  function I(T) {
    n(v) === T && (O(v, ""), O(p, ""));
  }
  wr(h);
  var C = s1();
  qe(C, 21, () => n(m), Je, (T, N) => {
    var b = Ze(), E = ye(b);
    {
      var k = (P) => {
        var M = Ze(), z = ye(M);
        {
          var B = (R) => {
            var W = r1();
            let K;
            var Q = S(W);
            $a(Q, {
              get id() {
                return n(N).contentfulEntryId;
              },
              get title() {
                return n(N).props.title;
              },
              alignment: "right",
              children: (V, U) => {
                Bn(V, {
                  get id() {
                    return n(N).contentfulEntryId;
                  },
                  get title() {
                    return n(N).props.title;
                  },
                  excludeTitleOnDesktop: !0,
                  get navItems() {
                    return n(N).props.primaryNavItems;
                  }
                });
              },
              $$slots: { default: !0 }
            }), _(W), ne(W, (V, U) => rt == null ? void 0 : rt(V, U), () => [
              () => y(n(N).contentfulEntryId, "flyout"),
              () => I(n(N).contentfulEntryId),
              Rn,
              Pn
            ]), L((V) => K = j(W, 1, "svelte-1mu45jj", null, K, V), [
              () => ({
                inactive: u() && n(v) !== "" && n(v) !== n(N).contentfulEntryId
              })
            ]), w(R, W);
          }, G = (R) => {
            var W = a1();
            let K;
            var Q = S(W);
            n1(Q, {
              get item() {
                return n(N);
              }
            }), _(W), ne(W, (V, U) => rt == null ? void 0 : rt(V, U), () => [
              () => y(n(N).contentfulEntryId, "dropdown"),
              () => I(n(N).contentfulEntryId),
              Rn,
              Pn
            ]), L((V) => K = j(W, 1, "svelte-1mu45jj", null, K, V), [
              () => ({
                inactive: u() && n(v) !== "" && n(v) !== n(N).contentfulEntryId
              })
            ]), w(R, W);
          };
          F(z, (R) => {
            d() ? R(B) : R(G, !1);
          });
        }
        w(P, M);
      }, A = (P, M) => {
        {
          var z = (B) => {
            var G = i1();
            let R;
            var W = S(G);
            mt(W, {
              linkCustomCssClass: "nav-list-link",
              get id() {
                return n(N).contentfulEntryId;
              },
              get title() {
                return n(N).props.title;
              },
              get url() {
                return n(N).props.url;
              },
              get linkStyle() {
                return n(N).props.linkStyle;
              },
              get enableHoverOpacity() {
                return l();
              },
              get openInNewTab() {
                return n(N).props.openInNewTab;
              }
            }), _(G), ne(G, (K, Q) => rt == null ? void 0 : rt(K, Q), () => [
              () => y(n(N).contentfulEntryId, "link"),
              () => I(n(N).contentfulEntryId),
              Rn,
              Pn
            ]), L((K) => R = j(G, 1, "svelte-1mu45jj", null, R, K), [
              () => ({
                inactive: u() && n(v) !== "" && n(v) !== n(N).contentfulEntryId
              })
            ]), w(B, G);
          };
          F(
            P,
            (B) => {
              ft(n(N).componentName) === "link" && B(z);
            },
            M
          );
        }
      };
      F(E, (P) => {
        ["category", "imageListCategory"].includes(ft(n(N).componentName)) ? P(k) : P(A, !1);
      });
    }
    w(T, b);
  }), _(C), w(t, C), le(), a();
}
var o1 = /* @__PURE__ */ Cn('<svg class="Icon" width="24" height="24" viewBox="0 0 24 25" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M10.5002 17.9998C12.0702 17.9998 13.5202 17.4698 14.6802 16.5998L18.7902 20.7098L20.2002 19.2998L16.0902 15.1898C16.9702 14.0198 17.4902 12.5798 17.4902 11.0098C17.4902 7.14977 14.3502 4.00977 10.4902 4.00977C6.63023 4.00977 3.49023 7.14977 3.49023 11.0098C3.49023 14.8698 6.64023 17.9998 10.5002 17.9998ZM10.5002 5.99977C13.2602 5.99977 15.5002 8.23977 15.5002 10.9998C15.5002 13.7598 13.2602 15.9998 10.5002 15.9998C7.74023 15.9998 5.50023 13.7598 5.50023 10.9998C5.50023 8.23977 7.74023 5.99977 10.5002 5.99977Z" fill="currentColor"></path></svg>');
function ni(t) {
  var e = o1();
  w(t, e);
}
var l1 = /* @__PURE__ */ Cn('<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 12.5C3 7.53 7.03 3.5 12 3.5C16.97 3.5 21 7.53 21 12.5C21 17.47 16.97 21.5 12 21.5C7.03 21.5 3 17.47 3 12.5ZM5 12.5C5 16.36 8.14 19.5 12 19.5C15.86 19.5 19 16.36 19 12.5C19 8.64 15.86 5.5 12 5.5C8.14 5.5 5 8.64 5 12.5ZM12 11.09L14.29 8.79004L15.71 10.21L13.41 12.5L15.71 14.79L14.29 16.21L12 13.92L9.71004 16.21L8.29004 14.79L10.59 12.5L8.29004 10.21L9.71004 8.79004L12 11.09Z" fill="#767676"></path></svg>');
function u1(t) {
  var e = l1();
  w(t, e);
}
const eo = Symbol("searchOptions");
function c1(t) {
  const e = We(t);
  return Mt(eo, e), e;
}
function la() {
  return Lt(eo);
}
function v1(t, e) {
  oe(e, !1);
  let r = g(e, "options", 8);
  const a = c1(r());
  ae(() => Le(r()), () => {
    a.set(r());
  }), et(), Me();
  var i = Ze(), s = ye(i);
  ra(s, e, "default", {}), w(t, i), le();
}
var d1 = /* @__PURE__ */ x('<form method="get"><!> <input name="query" placeholder="Search squareup.com" class="svelte-15lt8lo"/> <button type="button" aria-label="clear search input" class="svelte-15lt8lo"><!></button></form>');
function to(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(u, "$searchOptions", r);
  let s = g(e, "inputEl", 12), o = /* @__PURE__ */ Y(), l = /* @__PURE__ */ Y("");
  const u = la(), d = qt(), f = Vn();
  let c;
  function v() {
    d({
      eventName: "Click Search Bar",
      properties: {
        currentPage: vt(),
        navDeviceType: dt(s())
      }
    });
  }
  function p() {
    window.clearTimeout(c), c = window.setTimeout(
      () => {
        n(l).length > 0 && d({
          eventName: "Type In Search Bar",
          properties: {
            searchQuery: n(l),
            currentPage: vt(),
            navDeviceType: dt(s())
          }
        });
      },
      400
    );
  }
  function h() {
    O(l, ""), s().focus();
  }
  function m(A) {
    n(l) || A.preventDefault();
  }
  function y(A) {
    A.relatedTarget !== n(o) && f("blur");
  }
  function I(A) {
    A.relatedTarget !== s() && f("blur");
  }
  wr(() => {
    typeof window < "u" && window.clearTimeout(c);
  }), Me();
  var C = d1();
  let T;
  var N = S(C);
  ni(N);
  var b = H(N, 2);
  yl(b), nt(b, (A) => s(A), () => s());
  var E = H(b, 2), k = S(E);
  u1(k), _(E), nt(E, (A) => O(o, A), () => n(o)), _(C), L(
    (A) => {
      D(C, "action", i().searchPageUrl), T = j(C, 1, "svelte-15lt8lo", null, T, A);
    },
    [
      () => ({ empty: n(l).length === 0 })
    ],
    de
  ), Nl(b, () => n(l), (A) => O(l, A)), at("focus", b, v), at("blur", b, y), at("input", b, p), at("click", E, h), at("blur", E, I), at("submit", C, m), w(t, C), le(), a();
}
const Or = We(!1);
var f1 = /* @__PURE__ */ x('<div class="Dropdown"><button class="svelte-1ro1r17"><!></button> <div><div><!></div></div></div>');
function g1(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(Or, "$isSearchDropdownOpen", r);
  let s = /* @__PURE__ */ Ue(void 0), o = /* @__PURE__ */ Ue(void 0), l = /* @__PURE__ */ Ue(void 0), u = /* @__PURE__ */ Ue(!0);
  const d = 200;
  function f() {
    window.clearTimeout(n(l)), O(u, !1), tt(Or, !0), window.setTimeout(() => n(o).focus(), d);
  }
  function c() {
    tt(Or, !1), window.clearTimeout(n(l)), O(l, window.setTimeout(() => O(u, !0), d), !0);
  }
  function v() {
    i() ? c() : f();
  }
  var p = f1(), h = S(p), m = S(h);
  ni(m), _(h), ne(h, (E, k) => He == null ? void 0 : He(E, k), () => v);
  var y = H(h, 2);
  let I, C;
  var T = S(y);
  let N;
  var b = S(T);
  to(b, {
    get inputEl() {
      return n(o);
    },
    set inputEl(E) {
      O(o, E, !0);
    },
    $$events: { blur: () => c() }
  }), _(T), _(y), _(p), ne(p, (E, k) => rt == null ? void 0 : rt(E, k), () => [f, c, 100, 300]), L(
    (E, k) => {
      I = j(y, 1, "DropdownContent svelte-1ro1r17", null, I, E), C = Te(y, "", C, {
        "--animation-duration": `${d}ms`,
        "--dropdown-height": `${n(s)}px`
      }), N = j(T, 1, "DropdownContentInner", null, N, k);
    },
    [
      () => ({ isOpen: i() }),
      () => ({ hidden: n(u) })
    ]
  ), it(T, "clientHeight", (E) => O(s, E)), w(t, p), le(), a();
}
var p1 = /* @__PURE__ */ x('<div aria-hidden="true"></div>');
function h1(t, e) {
  oe(e, !1);
  const [r, a] = ke(), i = () => re(kr, "$activeFlyoutStore", r), s = () => re(xt, "$activeDropdownStore", r), o = () => re(Or, "$isSearchDropdownOpen", r);
  Me();
  var l = p1();
  let u;
  Te(l, "", {}, { visibility: "var(--scrim-visibility, hidden)" }), ne(l, (d, f) => He == null ? void 0 : He(d, f), () => xt.close), L(
    (d) => u = j(l, 1, "Scrim svelte-1iw6kpl", null, u, d),
    [
      () => {
        var d;
        return {
          isVisible: ((d = i()) == null ? void 0 : d.enableScrim) || s().id !== null || o()
        };
      }
    ],
    de
  ), w(t, l), le(), a();
}
var m1 = /* @__PURE__ */ x('<div><div class="title svelte-12bzn7f"> </div></div>');
function no(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(d, "$countStore", r), s = g(e, "statusZero", 3, "{count} items"), o = g(e, "statusOne", 3, "{count} item"), l = g(e, "statusMany", 3, "{count} items"), u = g(e, "slideInFrom", 3, "top"), d = Fn();
  function f(m) {
    switch (m) {
      case 0:
        return s().replace(/{count}/, m == null ? void 0 : m.toString());
      case 1:
        return o().replace(/{count}/, m == null ? void 0 : m.toString());
      default:
        return l().replace(/{count}/, m == null ? void 0 : m.toString());
    }
  }
  const c = /* @__PURE__ */ Z(() => f(i()));
  var v = m1(), p = S(v);
  Te(p, "", {}, { "--item-number": 1 });
  var h = S(p, !0);
  _(p), _(v), L(() => {
    j(v, 1, `Status slide-in-from-${u() ?? ""}`, "svelte-12bzn7f"), fe(h, n(c));
  }), w(t, v), le(), a();
}
var y1 = /* @__PURE__ */ x(
  `<div></div> <style lang="scss">@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.global-nav-ctas {
  margin-left: 12px;
  display: none;
  gap: 12px;
  margin-right: 6px;
}
.global-nav-ctas.isVisible {
  display: flex;
}
@media (max-width: 79.9375rem) {
  .global-nav-ctas.isVisible {
    display: none;
  }
}
.global-nav-ctas .Link--button {
  white-space: nowrap;
}</style>`,
  1
);
function _1(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(Bs, "$ctaSubnavButtonsAreVisibleStore", r), s = g(e, "primaryCtaButton", 3, void 0), o = g(e, "secondaryCtaButton", 3, void 0), l = g(e, "ctaButtonStyleV1", 3, !1), u = [
    o(),
    s()
  ].filter((v) => v !== void 0);
  var d = Ze(), f = ye(d);
  {
    var c = (v) => {
      var p = y1(), h = ye(p);
      let m;
      qe(h, 21, () => u, Je, (y, I) => {
        var C = Ze(), T = ye(C);
        {
          var N = (b) => {
            var E = Ze(), k = ye(E);
            {
              var A = (M) => {
                const z = /* @__PURE__ */ Z(() => {
                  var K;
                  return (K = n(I)) == null ? void 0 : K.contentfulEntryId;
                }), B = /* @__PURE__ */ Z(() => {
                  var K, Q;
                  return (Q = (K = n(I)) == null ? void 0 : K.props) == null ? void 0 : Q.title;
                }), G = /* @__PURE__ */ Z(() => {
                  var K, Q;
                  return (Q = (K = n(I)) == null ? void 0 : K.props) == null ? void 0 : Q.url;
                }), R = /* @__PURE__ */ Z(() => {
                  var K, Q;
                  return (Q = (K = n(I)) == null ? void 0 : K.props) == null ? void 0 : Q.linkStyle;
                }), W = /* @__PURE__ */ Z(() => {
                  var K, Q;
                  return (Q = (K = n(I)) == null ? void 0 : K.props) == null ? void 0 : Q.icon;
                });
                an(M, {
                  get id() {
                    return n(z);
                  },
                  get title() {
                    return n(B);
                  },
                  get url() {
                    return n(G);
                  },
                  get linkStyle() {
                    return n(R);
                  },
                  get icon() {
                    return n(W);
                  }
                });
              }, P = (M) => {
                const z = /* @__PURE__ */ Z(() => {
                  var Q;
                  return (Q = n(I)) == null ? void 0 : Q.contentfulEntryId;
                }), B = /* @__PURE__ */ Z(() => {
                  var Q, V;
                  return (V = (Q = n(I)) == null ? void 0 : Q.props) == null ? void 0 : V.title;
                }), G = /* @__PURE__ */ Z(() => {
                  var Q, V;
                  return (V = (Q = n(I)) == null ? void 0 : Q.props) == null ? void 0 : V.url;
                }), R = /* @__PURE__ */ Z(() => {
                  var Q, V;
                  return (V = (Q = n(I)) == null ? void 0 : Q.props) == null ? void 0 : V.linkStyle;
                }), W = /* @__PURE__ */ Z(() => {
                  var Q, V;
                  return (V = (Q = n(I)) == null ? void 0 : Q.props) == null ? void 0 : V.icon;
                }), K = /* @__PURE__ */ Z(() => {
                  var Q, V;
                  return (V = (Q = n(I)) == null ? void 0 : Q.props) == null ? void 0 : V.openInNewTab;
                });
                mt(M, {
                  get id() {
                    return n(z);
                  },
                  get title() {
                    return n(B);
                  },
                  get url() {
                    return n(G);
                  },
                  get linkStyle() {
                    return n(R);
                  },
                  get icon() {
                    return n(W);
                  },
                  get openInNewTab() {
                    return n(K);
                  }
                });
              };
              F(k, (M) => {
                l() ? M(A) : M(P, !1);
              });
            }
            w(b, E);
          };
          F(T, (b) => {
            n(I) && b(N);
          });
        }
        w(y, C);
      }), _(h), wn(2), L((y) => m = j(h, 1, "global-nav-ctas", null, m, y), [
        () => ({
          isVisible: !i()
        })
      ]), w(v, p);
    };
    F(f, (v) => {
      u.length > 0 && v(c);
    });
  }
  w(t, d), le(), a();
}
var S1 = /* @__PURE__ */ x("<!> <!> <!>", 1), b1 = /* @__PURE__ */ x('<div class="DesktopNav svelte-k3n56n" data-global-nav-desktop-v2=""><div class="left-slot svelte-k3n56n"><!></div> <div class="middle-slot svelte-k3n56n"><!></div> <div class="right-slot svelte-k3n56n"><!> <!> <!> <!></div> <div></div></div> <!>', 1);
function I1(t, e) {
  var ee, Ee;
  oe(e, !0);
  const [r, a] = ke(), i = () => re(m, "$searchOptions", r), s = () => re(xt, "$activeDropdownStore", r), o = g(e, "id", 3, ""), l = g(e, "homeLink", 3, void 0), u = g(e, "primaryNavItems", 19, () => []), d = g(e, "secondaryNavItems", 19, () => []), f = g(e, "cart", 3, void 0), c = g(e, "primaryCtaButton", 3, void 0), v = g(e, "secondaryCtaButton", 3, void 0), p = g(e, "ctaButtonStyleV1", 3, !1);
  let h = /* @__PURE__ */ Ue(0);
  const m = la();
  kf(((Ee = (ee = l()) == null ? void 0 : ee.props) == null ? void 0 : Ee.logo) || "LogoJewel");
  var y = b1(), I = ye(y);
  let C;
  var T = S(I), N = S(T);
  const b = /* @__PURE__ */ Z(() => {
    var Ie;
    return (Ie = l()) == null ? void 0 : Ie.contentfulEntryId;
  }), E = /* @__PURE__ */ Z(() => {
    var Ie, Ae;
    return (Ae = (Ie = l()) == null ? void 0 : Ie.props) == null ? void 0 : Ae.title;
  }), k = /* @__PURE__ */ Z(() => {
    var Ie, Ae;
    return (Ae = (Ie = l()) == null ? void 0 : Ie.props) == null ? void 0 : Ae.logo;
  }), A = /* @__PURE__ */ Z(() => {
    var Ie, Ae;
    return (Ae = (Ie = l()) == null ? void 0 : Ie.props) == null ? void 0 : Ae.url;
  });
  $s(N, {
    get id() {
      return n(b);
    },
    get title() {
      return n(E);
    },
    get logo() {
      return n(k);
    },
    get url() {
      return n(A);
    }
  }), _(T);
  var P = H(T, 2), M = S(P);
  ki(M, {
    get navItems() {
      return u();
    },
    enableInactiveState: !0
  }), _(P);
  var z = H(P, 2), B = S(z);
  ki(B, {
    get navItems() {
      return d();
    },
    shouldRenderFlyout: !0,
    enableLinkHoverOpacity: !0
  });
  var G = H(B, 2);
  {
    var R = (Ie) => {
      g1(Ie, {});
    };
    F(G, (Ie) => {
      i().isEnabled && Ie(R);
    });
  }
  var W = H(G, 2);
  {
    var K = (Ie) => {
      $a(Ie, {
        get id() {
          return f().contentfulEntryId;
        },
        get title() {
          return f().props.title;
        },
        alignment: "right",
        renderCartButton: !0,
        children: (Ae, je) => {
          var pe = S1(), ze = ye(pe);
          no(ze, {
            get statusZero() {
              return f().props.statusZeroItems;
            },
            get statusOne() {
              return f().props.statusOneItem;
            },
            get statusMany() {
              return f().props.statusManyItems;
            },
            slideInFrom: "top"
          });
          var _e = H(ze, 2);
          {
            var De = (q) => {
              qr(q, {
                get navItems() {
                  return f().props.primaryNavItems;
                },
                cartPrimary: !0,
                listStartingIndex: 1,
                slideInFrom: "top"
              });
            };
            F(_e, (q) => {
              u() && q(De);
            });
          }
          var Re = H(_e, 2);
          {
            var ge = (q) => {
              const me = /* @__PURE__ */ Z(() => {
                var Ne;
                return 1 + ((Ne = u()) == null ? void 0 : Ne.length) || 0;
              });
              qr(q, {
                get navItems() {
                  return f().props.secondaryNavItems;
                },
                get listStartingIndex() {
                  return n(me);
                },
                slideInFrom: "top"
              });
            };
            F(Re, (q) => {
              d() && q(ge);
            });
          }
          w(Ae, pe);
        },
        $$slots: { default: !0 }
      });
    };
    F(W, (Ie) => {
      f() && Ie(K);
    });
  }
  var Q = H(W, 2);
  _1(Q, {
    get primaryCtaButton() {
      return c();
    },
    get secondaryCtaButton() {
      return v();
    },
    get ctaButtonStyleV1() {
      return p();
    }
  }), _(z);
  var V = H(z, 2);
  let U, J;
  _(I);
  var X = H(I, 2);
  h1(X, {}), L(
    (Ie) => {
      D(I, "data-entry-id", o()), C = Te(I, "", C, {
        "--desktop-nav-height": `${n(h)}px`
      }), U = j(V, 1, "dropdown-background svelte-k3n56n", null, U, Ie), J = Te(V, "", J, {
        "--dropdown-background-height": `${s().contentHeight}px`
      });
    },
    [
      () => ({
        "has-slide-in": s().showSlideInAnimation
      })
    ]
  ), it(I, "clientHeight", (Ie) => O(h, Ie)), w(t, y), le(), a();
}
var w1 = /* @__PURE__ */ x('<div class="Cart svelte-dtm09k"><!> <!> <!></div>');
function C1(t, e) {
  oe(e, !0);
  const r = g(e, "id", 3, ""), a = g(e, "statusZero", 3, ""), i = g(e, "statusOne", 3, ""), s = g(e, "statusMany", 3, ""), o = g(e, "primaryNavItems", 19, () => []), l = g(e, "secondaryNavItems", 19, () => []), u = g(e, "slideInFrom", 3, "top");
  var d = w1(), f = S(d);
  no(f, {
    get statusZero() {
      return a();
    },
    get statusOne() {
      return i();
    },
    get statusMany() {
      return s();
    },
    get slideInFrom() {
      return u();
    }
  });
  var c = H(f, 2);
  {
    var v = (m) => {
      qr(m, {
        get navItems() {
          return o();
        },
        cartPrimary: !0,
        listStartingIndex: 1,
        get slideInFrom() {
          return u();
        }
      });
    };
    F(c, (m) => {
      o() && m(v);
    });
  }
  var p = H(c, 2);
  {
    var h = (m) => {
      const y = /* @__PURE__ */ Z(() => {
        var I;
        return 1 + ((I = o()) == null ? void 0 : I.length) || 0;
      });
      qr(m, {
        get navItems() {
          return l();
        },
        get listStartingIndex() {
          return n(y);
        },
        get slideInFrom() {
          return u();
        }
      });
    };
    F(p, (m) => {
      l() && m(h);
    });
  }
  _(d), L(() => {
    D(d, "id", Gs), D(d, "data-entry-id", r());
  }), w(t, d), le();
}
var N1 = /* @__PURE__ */ x('<button class="Button svelte-1ua0hxd"><span class="icon svelte-1ua0hxd"><svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.125 10.75C4.64375 10.75 4.25 11.1438 4.25 11.625C4.25 12.1062 4.64375 12.5 5.125 12.5H16.5V14.25H5.125C3.68125 14.25 2.5 13.0687 2.5 11.625C2.5 10.6012 3.095 9.7175 3.96125 9.28875L2.5 2H0.75V0.25H6V2H16.5L14.75 10.75H5.125ZM13.315 9L14.365 3.75H4.635L5.685 9H13.315ZM5.5625 17.75C6.28737 17.75 6.875 17.1624 6.875 16.4375C6.875 15.7126 6.28737 15.125 5.5625 15.125C4.83763 15.125 4.25 15.7126 4.25 16.4375C4.25 17.1624 4.83763 17.75 5.5625 17.75ZM13.4375 17.75C14.1624 17.75 14.75 17.1624 14.75 16.4375C14.75 15.7126 14.1624 15.125 13.4375 15.125C12.7126 15.125 12.125 15.7126 12.125 16.4375C12.125 17.1624 12.7126 17.75 13.4375 17.75Z" fill="#232425"></path></svg></span> <span class="title svelte-1ua0hxd"> </span></button>');
function T1(t, e) {
  oe(e, !0);
  const r = g(e, "id", 3, ""), a = g(e, "title", 3, "Checkout"), i = qt();
  let s = /* @__PURE__ */ Ue(void 0);
  function o() {
    i({
      eventName: "Open Cart",
      properties: {
        currentPage: vt(),
        navDeviceType: dt(n(s))
      }
    }), kt.push({ type: "cart" });
  }
  var l = N1(), u = H(S(l), 2), d = S(u, !0);
  _(u), _(l), nt(l, (f) => O(s, f), () => n(s)), ne(l, (f, c) => He == null ? void 0 : He(f, c), () => o), L(() => {
    D(l, "data-entry-id", r()), D(l, "aria-controls", Gs), fe(d, a());
  }), w(t, l), le();
}
var E1 = /* @__PURE__ */ x('<button class="svelte-1i97ge2"><span class="icon svelte-1i97ge2"><!></span> <span class="title svelte-1i97ge2">Search</span></button>');
function x1(t, e) {
  oe(e, !1), Me();
  var r = E1(), a = S(r), i = S(a);
  ni(i), _(a), wn(2), _(r), at("click", r, () => kt.push({ type: "search" })), w(t, r), le();
}
var k1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><button class="toggle-large svelte-1rg4zfp" aria-haspopup="true"><span> </span></button></li>'), O1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><!></li>'), L1 = /* @__PURE__ */ x('<ul class="svelte-1rg4zfp"></ul>'), M1 = /* @__PURE__ */ x('<span class="icon svelte-1rg4zfp"><!></span>'), A1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><button class="toggle-small svelte-1rg4zfp" aria-haspopup="true"><!> <span> </span></button></li>'), D1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><!></li>'), R1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><!></li>'), P1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><!></li>'), U1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><button class="toggle-large svelte-1rg4zfp" aria-haspopup="true"><span> </span></button></li>'), B1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><!></li>'), V1 = /* @__PURE__ */ x('<li class="svelte-1rg4zfp"><!></li>'), F1 = /* @__PURE__ */ x('<ul class="primary-dropdown-nav-item-list svelte-1rg4zfp"><li class="svelte-1rg4zfp"><span class="title svelte-1rg4zfp"> </span></li> <!></ul> <ul class="secondary-dropdown-nav-item-list svelte-1rg4zfp"></ul>', 1), H1 = /* @__PURE__ */ x("<div><!></div>"), z1 = /* @__PURE__ */ x("<div><!></div>"), q1 = /* @__PURE__ */ x("<div><!></div>"), W1 = /* @__PURE__ */ x("<div><!></div>"), j1 = /* @__PURE__ */ x('<div class="search-bar-container svelte-1rg4zfp"><!></div>'), G1 = /* @__PURE__ */ x('<div><div><div><!> <ul class="svelte-1rg4zfp"><!> <!> <!></ul></div> <!> <!> <!> <!> <!></div></div>');
function Y1(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(h, "$loggedInStore", r), s = () => re(p, "$cartCountStore", r), o = () => re(kt, "$mobileNavStateStore", r), l = () => re(v, "$searchOptions", r), u = g(e, "primaryNavItems", 19, () => []), d = g(e, "secondaryNavItems", 19, () => []), f = g(e, "mobileNavHeight", 3, 0), c = g(e, "cart", 3, void 0), v = la(), p = Fn(), h = Nr(), m = qt(), y = /* @__PURE__ */ Z(() => Xn({
    items: u(),
    loggedIn: i(),
    cartCount: s()
  })), I = /* @__PURE__ */ Z(() => Xn({
    items: d(),
    loggedIn: i(),
    cartCount: s()
  }));
  let C = /* @__PURE__ */ Ue(0), T = /* @__PURE__ */ Ue(void 0), N = /* @__PURE__ */ Ue(void 0);
  function b(ge) {
    var q, me;
    m({
      eventName: "Open Menu",
      properties: {
        currentPage: vt(),
        menuId: ge.contentfulEntryId,
        menuText: (q = ge.props) == null ? void 0 : q.title,
        menuCategory: (me = ge.props) == null ? void 0 : me.title,
        menuLocation: Ot(n(T)),
        navDeviceType: dt(n(T))
      }
    }), kt.push({
      type: "category",
      categoryId: ge.contentfulEntryId
    });
  }
  function E(ge, q) {
    var me, Ne;
    m({
      eventName: "Open Menu",
      properties: {
        currentPage: vt(),
        menuId: ge.contentfulEntryId,
        menuText: (me = ge.props) == null ? void 0 : me.title,
        menuCategory: q,
        menuSubcategory: (Ne = ge.props) == null ? void 0 : Ne.title,
        menuLocation: Ot(n(T)),
        navDeviceType: dt(n(T))
      }
    }), kt.push({
      type: "subcategory",
      subcategoryId: ge.contentfulEntryId
    });
  }
  function k(ge) {
    if (!ge)
      return null;
    const q = ge.activeContentStack;
    return !q || q.length === 0 ? null : q.at(-1);
  }
  function A({ isOpen: ge, activeContentStack: q }, me) {
    var Ce;
    ge && ((Ce = q.at(-1)) == null ? void 0 : Ce.type) === "search" && me && me.focus();
  }
  ut(() => {
    A(o(), n(N));
  });
  const P = /* @__PURE__ */ Z(() => k(o()));
  var M = G1();
  let z, B;
  var G = S(M), R = S(G);
  let W;
  var K = S(R);
  {
    var Q = (ge) => {
      var q = L1();
      qe(q, 21, () => n(y), Je, (me, Ne, Ce) => {
        var Pe = Ze(), we = ye(Pe);
        {
          var ie = (te) => {
            var ue = k1();
            Te(ue, "", {}, { "--dropdown-item-number": Ce + 1 });
            var ce = S(ue), Se = S(ce), he = S(Se, !0);
            _(Se), _(ce), ne(ce, (ve, se) => He == null ? void 0 : He(ve, se), () => () => b(n(Ne))), _(ue), L(
              (ve) => {
                D(ce, "aria-expanded", ve), D(ce, "aria-controls", `global-nav-mobile-dropdown-content-${n(Ne).contentfulEntryId}`), D(ce, "data-entry-id", n(Ne).contentfulEntryId), fe(he, n(Ne).props.title);
              },
              [
                () => {
                  var ve;
                  return n(Ne).contentfulEntryId === ((ve = k(o())) == null ? void 0 : ve.categoryId);
                }
              ]
            ), w(te, ue);
          }, $ = (te, ue) => {
            {
              var ce = (Se) => {
                var he = O1();
                Te(he, "", {}, { "--dropdown-item-number": Ce + 1 });
                var ve = S(he);
                mt(ve, {
                  linkCustomCssClass: "subcategory-large-link",
                  get id() {
                    return n(Ne).contentfulEntryId;
                  },
                  get title() {
                    return n(Ne).props.title;
                  },
                  get url() {
                    return n(Ne).props.url;
                  },
                  get linkStyle() {
                    return n(Ne).props.linkStyle;
                  },
                  get openInNewTab() {
                    return n(Ne).props.openInNewTab;
                  }
                }), _(he), w(Se, he);
              };
              F(
                te,
                (Se) => {
                  ft(n(Ne).componentName) === "link" && Se(ce);
                },
                ue
              );
            }
          };
          F(we, (te) => {
            ["category", "imageListCategory"].includes(ft(n(Ne).componentName)) ? te(ie) : te($, !1);
          });
        }
        w(me, Pe);
      }), _(q), w(ge, q);
    };
    F(K, (ge) => {
      n(y).length > 0 && ge(Q);
    });
  }
  var V = H(K, 2), U = S(V);
  {
    var J = (ge) => {
      var q = Ze(), me = ye(q);
      qe(me, 17, () => n(I), Je, (Ne, Ce, Pe) => {
        var we = Ze(), ie = ye(we);
        {
          var $ = (ue) => {
            var ce = A1();
            let Se;
            var he = S(ce), ve = S(he);
            {
              var se = (Qe) => {
                var Ve = M1(), Fe = S(Ve);
                Ga(Fe, () => {
                  var Tt;
                  return (Tt = n(Ce).props.icon) == null ? void 0 : Tt.svgString;
                }), _(Ve), w(Qe, Ve);
              };
              F(ve, (Qe) => {
                var Ve;
                (Ve = n(Ce).props.icon) != null && Ve.svgString && Qe(se);
              });
            }
            var Oe = H(ve, 2), Ye = S(Oe, !0);
            _(Oe), _(he), ne(he, (Qe, Ve) => He == null ? void 0 : He(Qe, Ve), () => () => b(n(Ce))), _(ce), L(
              (Qe) => {
                var Ve;
                Se = Te(ce, "", Se, {
                  "--dropdown-item-number": Pe + (((Ve = n(y)) == null ? void 0 : Ve.length) || 0) + 1
                }), D(he, "aria-expanded", Qe), D(he, "aria-controls", `global-nav-mobile-dropdown-content-${n(Ce).contentfulEntryId}`), D(he, "data-entry-id", n(Ce).contentfulEntryId), fe(Ye, n(Ce).props.title);
              },
              [
                () => {
                  var Qe;
                  return n(Ce).contentfulEntryId === ((Qe = k(o())) == null ? void 0 : Qe.categoryId);
                }
              ]
            ), w(ue, ce);
          }, te = (ue, ce) => {
            {
              var Se = (he) => {
                var ve = D1();
                let se;
                var Oe = S(ve);
                mt(Oe, {
                  linkCustomCssClass: "link-list-link",
                  get id() {
                    return n(Ce).contentfulEntryId;
                  },
                  get title() {
                    return n(Ce).props.title;
                  },
                  get url() {
                    return n(Ce).props.url;
                  },
                  get icon() {
                    return n(Ce).props.icon;
                  },
                  get linkStyle() {
                    return n(Ce).props.linkStyle;
                  },
                  get openInNewTab() {
                    return n(Ce).props.openInNewTab;
                  }
                }), _(ve), L(() => {
                  var Ye;
                  return se = Te(ve, "", se, {
                    "--dropdown-item-number": Pe + (((Ye = n(y)) == null ? void 0 : Ye.length) || 0) + 1
                  });
                }), w(he, ve);
              };
              F(
                ue,
                (he) => {
                  ft(n(Ce).componentName) === "link" && he(Se);
                },
                ce
              );
            }
          };
          F(ie, (ue) => {
            ft(n(Ce).componentName) === "category" ? ue($) : ue(te, !1);
          });
        }
        w(Ne, we);
      }), w(ge, q);
    };
    F(U, (ge) => {
      n(I).length > 0 && ge(J);
    });
  }
  var X = H(U, 2);
  {
    var ee = (ge) => {
      var q = R1();
      let me;
      var Ne = S(q);
      x1(Ne, {}), _(q), L(() => {
        var Ce, Pe;
        return me = Te(q, "", me, {
          "--dropdown-item-number": (((Ce = n(I)) == null ? void 0 : Ce.length) || 0) + (((Pe = n(y)) == null ? void 0 : Pe.length) || 0) + 2
        });
      }), w(ge, q);
    };
    F(X, (ge) => {
      l().isEnabled && ge(ee);
    });
  }
  var Ee = H(X, 2);
  {
    var Ie = (ge) => {
      var q = P1();
      let me;
      var Ne = S(q);
      const Ce = /* @__PURE__ */ Z(() => {
        var Pe, we;
        return (we = (Pe = c()) == null ? void 0 : Pe.props) == null ? void 0 : we.mobileTitle;
      });
      T1(Ne, {
        get id() {
          return c().contentfulEntryId;
        },
        get title() {
          return n(Ce);
        }
      }), _(q), L(() => {
        var Pe, we;
        return me = Te(q, "", me, {
          "--dropdown-item-number": (((Pe = n(I)) == null ? void 0 : Pe.length) || 0) + (((we = n(y)) == null ? void 0 : we.length) || 0) + 1
        });
      }), w(ge, q);
    };
    F(Ee, (ge) => {
      c() && ge(Ie);
    });
  }
  _(V), _(R);
  var Ae = H(R, 2);
  qe(Ae, 17, () => n(y), Je, (ge, q) => {
    var me = Ze(), Ne = ye(me);
    {
      var Ce = (Pe) => {
        var we = H1();
        let ie;
        var $ = S(we);
        {
          var te = (ce) => {
            const Se = /* @__PURE__ */ Z(() => {
              var se;
              return (se = n(q)) == null ? void 0 : se.contentfulEntryId;
            }), he = /* @__PURE__ */ Z(() => {
              var se, Oe;
              return (Oe = (se = n(q)) == null ? void 0 : se.props) == null ? void 0 : Oe.title;
            }), ve = /* @__PURE__ */ Z(() => {
              var se, Oe;
              return (Oe = (se = n(q)) == null ? void 0 : se.props) == null ? void 0 : Oe.navItems;
            });
            Wr(ce, {
              get id() {
                return n(Se);
              },
              get title() {
                return n(he);
              },
              get navItems() {
                return n(ve);
              },
              alignment: "center",
              containerSize: "large",
              slideInFrom: "left"
            });
          }, ue = (ce) => {
            var Se = F1(), he = ye(Se), ve = S(he);
            Te(ve, "", {}, { "--dropdown-item-number": 1 });
            var se = S(ve), Oe = S(se, !0);
            _(se), _(ve);
            var Ye = H(ve, 2);
            qe(Ye, 17, () => n(q).props.primaryNavItems, Je, (Ve, Fe, Tt) => {
              var gt = Ze(), At = ye(gt);
              {
                var or = (Dt) => {
                  var Qt = U1();
                  Te(Qt, "", {}, { "--dropdown-item-number": Tt + 2 });
                  var nn = S(Qt), cn = S(nn), vn = S(cn, !0);
                  _(cn), _(nn), ne(nn, (Et, Mn) => He == null ? void 0 : He(Et, Mn), () => () => {
                    var Et, Mn;
                    return E(n(Fe), (Mn = (Et = n(q)) == null ? void 0 : Et.props) == null ? void 0 : Mn.title);
                  }), _(Qt), L(
                    (Et) => {
                      D(nn, "aria-expanded", Et), D(nn, "aria-controls", `global-nav-mobile-dropdown-content-${n(Fe).contentfulEntryId}`), D(nn, "data-entry-id", n(Fe).contentfulEntryId), fe(vn, n(Fe).props.title);
                    },
                    [
                      () => {
                        var Et;
                        return n(Fe).contentfulEntryId === ((Et = k(o())) == null ? void 0 : Et.subcategoryId);
                      }
                    ]
                  ), w(Dt, Qt);
                }, Hn = (Dt, Qt) => {
                  {
                    var nn = (cn) => {
                      var vn = B1();
                      Te(vn, "", {}, { "--dropdown-item-number": Tt + 2 });
                      var Et = S(vn);
                      mt(Et, {
                        linkCustomCssClass: "subcategory-small-link",
                        get id() {
                          return n(Fe).contentfulEntryId;
                        },
                        get title() {
                          return n(Fe).props.title;
                        },
                        get url() {
                          return n(Fe).props.url;
                        },
                        get linkStyle() {
                          return n(Fe).props.linkStyle;
                        },
                        get openInNewTab() {
                          return n(Fe).props.openInNewTab;
                        }
                      }), _(vn), w(cn, vn);
                    };
                    F(
                      Dt,
                      (cn) => {
                        ft(n(Fe).componentName) === "link" && cn(nn);
                      },
                      Qt
                    );
                  }
                };
                F(At, (Dt) => {
                  ["category", "imageListCategory"].includes(ft(n(Fe).componentName)) ? Dt(or) : Dt(Hn, !1);
                });
              }
              w(Ve, gt);
            }), _(he);
            var Qe = H(he, 2);
            qe(Qe, 21, () => n(q).props.secondaryNavItems, Je, (Ve, Fe, Tt) => {
              var gt = V1();
              let At;
              var or = S(gt);
              mt(or, {
                linkCustomCssClass: "subcategory-small-link",
                get id() {
                  return n(Fe).contentfulEntryId;
                },
                get title() {
                  return n(Fe).props.title;
                },
                get url() {
                  return n(Fe).props.url;
                },
                get linkStyle() {
                  return n(Fe).props.linkStyle;
                },
                get openInNewTab() {
                  return n(Fe).props.openInNewTab;
                }
              }), _(gt), L(() => {
                var Hn, Dt, Qt;
                return At = Te(gt, "", At, {
                  "--dropdown-item-number": Tt + (((Qt = (Dt = (Hn = n(q)) == null ? void 0 : Hn.props) == null ? void 0 : Dt.primaryNavItems) == null ? void 0 : Qt.length) || 0) + 1
                });
              }), w(Ve, gt);
            }), _(Qe), L(() => {
              var Ve, Fe;
              return fe(Oe, (Fe = (Ve = n(q)) == null ? void 0 : Ve.props) == null ? void 0 : Fe.title);
            }), w(ce, Se);
          };
          F($, (ce) => {
            n(q).componentName === "PublicWebNavigationImageListCategoryV2" ? ce(te) : ce(ue, !1);
          });
        }
        _(we), L(
          (ce) => {
            var Se, he;
            D(we, "id", `global-nav-mobile-dropdown-content-${n(q).contentfulEntryId}`), ie = j(we, 1, "dropdown-nav-item-container dropdown-subcategory-nav-item-container slide-in-from-left svelte-1rg4zfp", null, ie, ce), D(we, "data-category", (he = (Se = n(q)) == null ? void 0 : Se.props) == null ? void 0 : he.title), D(we, "data-entry-id", n(q).contentfulEntryId);
          },
          [
            () => {
              var ce;
              return {
                active: n(q).contentfulEntryId === ((ce = k(o())) == null ? void 0 : ce.categoryId)
              };
            }
          ]
        ), w(Pe, we);
      };
      F(Ne, (Pe) => {
        var we, ie, $, te, ue, ce, Se, he, ve;
        ((($ = (ie = (we = n(q)) == null ? void 0 : we.props) == null ? void 0 : ie.primaryNavItems) == null ? void 0 : $.length) > 0 || ((ce = (ue = (te = n(q)) == null ? void 0 : te.props) == null ? void 0 : ue.secondaryNavItems) == null ? void 0 : ce.length) > 0 || ((ve = (he = (Se = n(q)) == null ? void 0 : Se.props) == null ? void 0 : he.navItems) == null ? void 0 : ve.length) > 0) && Pe(Ce);
      });
    }
    w(ge, me);
  });
  var je = H(Ae, 2);
  qe(je, 17, () => n(y), Je, (ge, q) => {
    var me = Ze(), Ne = ye(me);
    {
      var Ce = (Pe) => {
        var we = Ze(), ie = ye(we);
        qe(ie, 17, () => n(q).props.primaryNavItems, Je, ($, te) => {
          var ue = Ze(), ce = ye(ue);
          {
            var Se = (he) => {
              var ve = z1();
              let se;
              var Oe = S(ve);
              {
                var Ye = (Ve) => {
                  Wr(Ve, {
                    get id() {
                      return n(te).contentfulEntryId;
                    },
                    get title() {
                      return n(te).props.title;
                    },
                    get navItems() {
                      return n(te).props.navItems;
                    },
                    alignment: "center",
                    containerSize: "large",
                    slideInFrom: "left",
                    showTitle: !0
                  });
                }, Qe = (Ve, Fe) => {
                  {
                    var Tt = (gt) => {
                      var At = Ze(), or = ye(At);
                      qe(or, 17, () => n(te).props.primaryNavItems, Je, (Hn, Dt, Qt) => {
                        const nn = /* @__PURE__ */ Z(() => {
                          var cn, vn, Et, Mn, ri;
                          return ((ri = (Mn = (Et = (vn = (cn = n(te)) == null ? void 0 : cn.props) == null ? void 0 : vn.primaryNavItems[Qt - 1]) == null ? void 0 : Et.props) == null ? void 0 : Mn.primaryNavItems) == null ? void 0 : ri.length) || 0;
                        });
                        Bn(Hn, {
                          get id() {
                            return n(Dt).contentfulEntryId;
                          },
                          get navItems() {
                            return n(Dt).props.primaryNavItems;
                          },
                          get title() {
                            return n(Dt).props.title;
                          },
                          get linkStartingIndex() {
                            return n(nn);
                          },
                          slideInFrom: "left"
                        });
                      }), w(gt, At);
                    };
                    F(
                      Ve,
                      (gt) => {
                        var At;
                        ft((At = n(te)) == null ? void 0 : At.componentName) === "category" && gt(Tt);
                      },
                      Fe
                    );
                  }
                };
                F(Oe, (Ve) => {
                  var Fe;
                  ft((Fe = n(te)) == null ? void 0 : Fe.componentName) === "imageListCategory" ? Ve(Ye) : Ve(Qe, !1);
                });
              }
              _(ve), L(
                (Ve) => {
                  var Fe, Tt, gt, At;
                  D(ve, "id", `global-nav-mobile-dropdown-content-${n(te).contentfulEntryId}`), se = j(ve, 1, "dropdown-nav-item-container slide-in-from-left svelte-1rg4zfp", null, se, Ve), D(ve, "data-category", (Tt = (Fe = n(q)) == null ? void 0 : Fe.props) == null ? void 0 : Tt.title), D(ve, "data-subcategory", (At = (gt = n(te)) == null ? void 0 : gt.props) == null ? void 0 : At.title), D(ve, "data-entry-id", n(te).contentfulEntryId);
                },
                [
                  () => {
                    var Ve;
                    return {
                      active: n(te).contentfulEntryId === ((Ve = k(o())) == null ? void 0 : Ve.subcategoryId)
                    };
                  }
                ]
              ), w(he, ve);
            };
            F(ce, (he) => {
              var ve, se, Oe, Ye;
              ((se = (ve = n(te)) == null ? void 0 : ve.props) != null && se.primaryNavItems || (Ye = (Oe = n(te)) == null ? void 0 : Oe.props) != null && Ye.navItems) && he(Se);
            });
          }
          w($, ue);
        }), w(Pe, we);
      };
      F(Ne, (Pe) => {
        var we, ie;
        (ie = (we = n(q)) == null ? void 0 : we.props) != null && ie.primaryNavItems && Pe(Ce);
      });
    }
    w(ge, me);
  });
  var pe = H(je, 2);
  qe(pe, 17, () => n(I), Je, (ge, q, me) => {
    var Ne = Ze(), Ce = ye(Ne);
    {
      var Pe = (we) => {
        var ie = q1();
        let $;
        var te = S(ie);
        {
          var ue = (ce) => {
            const Se = /* @__PURE__ */ Z(() => {
              var he, ve, se;
              return ((se = (ve = (he = n(I)[me - 1]) == null ? void 0 : he.props) == null ? void 0 : ve.primaryNavItems) == null ? void 0 : se.length) || 0;
            });
            Bn(ce, {
              get id() {
                return n(q).contentfulEntryId;
              },
              get navItems() {
                return n(q).props.primaryNavItems;
              },
              get title() {
                return n(q).props.title;
              },
              get linkStartingIndex() {
                return n(Se);
              },
              slideInFrom: "left"
            });
          };
          F(te, (ce) => {
            n(q).componentName === "PublicWebNavigationCategoryV2" && ce(ue);
          });
        }
        _(ie), L(
          (ce) => {
            D(ie, "id", `global-nav-mobile-dropdown-content-${n(q).contentfulEntryId}`), $ = j(ie, 1, "dropdown-nav-item-container slide-in-from-left svelte-1rg4zfp", null, $, ce);
          },
          [
            () => {
              var ce;
              return {
                active: n(q).contentfulEntryId === ((ce = k(o())) == null ? void 0 : ce.categoryId)
              };
            }
          ]
        ), w(we, ie);
      };
      F(Ce, (we) => {
        var ie, $, te;
        ((te = ($ = (ie = n(q)) == null ? void 0 : ie.props) == null ? void 0 : $.primaryNavItems) == null ? void 0 : te.length) > 0 && we(Pe);
      });
    }
    w(ge, Ne);
  });
  var ze = H(pe, 2);
  {
    var _e = (ge) => {
      var q = W1();
      let me;
      var Ne = S(q);
      C1(Ne, {
        get id() {
          return c().contentfulEntryId;
        },
        get statusZero() {
          return c().props.statusZeroItems;
        },
        get statusOne() {
          return c().props.statusOneItem;
        },
        get statusMany() {
          return c().props.statusManyItems;
        },
        get primaryNavItems() {
          return c().props.primaryNavItems;
        },
        get secondaryNavItems() {
          return c().props.secondaryNavItems;
        },
        slideInFrom: "left"
      }), _(q), L((Ce) => me = j(q, 1, "dropdown-nav-item-container svelte-1rg4zfp", null, me, Ce), [
        () => {
          var Ce;
          return {
            active: ((Ce = k(o())) == null ? void 0 : Ce.type) === "cart"
          };
        }
      ]), w(ge, q);
    };
    F(ze, (ge) => {
      c() && ge(_e);
    });
  }
  var De = H(ze, 2);
  {
    var Re = (ge) => {
      var q = j1();
      Te(q, "", {}, { "--search-item-number": 1 });
      var me = S(q);
      to(me, {
        get inputEl() {
          return n(N);
        },
        set inputEl(Ne) {
          O(N, Ne, !0);
        }
      }), _(q), w(ge, q);
    };
    F(De, (ge) => {
      var q;
      ((q = n(P)) == null ? void 0 : q.type) === "search" && ge(Re);
    });
  }
  _(G), _(M), nt(M, (ge) => O(T, ge), () => n(T)), L(
    (ge, q) => {
      z = j(M, 1, "Dropdown svelte-1rg4zfp", null, z, ge), B = Te(M, "", B, {
        height: `${n(C)}px`,
        "--dropdown-top-offset": `${f()}px`
      }), W = j(R, 1, "dropdown-nav-item-container slide-in-from-top svelte-1rg4zfp", null, W, q);
    },
    [
      () => ({
        "no-height-transition": !o().showHeightTransition
      }),
      () => ({
        active: o().isOpen && o().activeContentStack.length === 0
      })
    ]
  ), it(G, "clientHeight", (ge) => O(C, ge)), w(t, M), le(), a();
}
var Z1 = /* @__PURE__ */ x('<button type="button" aria-haspopup="true"><span class="text svelte-evish4"><!></span> <span class="icon svelte-evish4" aria-hidden="true"><span class="iconBarTop svelte-evish4"></span> <span class="iconBarBottom svelte-evish4"></span> <span class="iconBarClockwise svelte-evish4"></span> <span class="iconBarCounterwise svelte-evish4"></span></span></button>');
function J1(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(kt, "$mobileNavStateStore", r), s = g(e, "openText", 3, "Open menu"), o = g(e, "closeText", 3, "Close menu"), l = qt();
  let u = /* @__PURE__ */ Ue(void 0);
  function d() {
    i().isOpen ? l({
      eventName: "Close Menu",
      properties: {
        currentPage: vt(),
        isCloseButton: !0,
        menuLocation: Ot(n(u)),
        navDeviceType: dt(n(u))
      }
    }) : l({
      eventName: "Open Drawer",
      properties: {
        currentPage: vt(),
        menuLocation: Ot(n(u)),
        navDeviceType: dt(n(u))
      }
    }), kt.toggle();
  }
  var f = Z1();
  let c;
  var v = S(f), p = S(v);
  {
    var h = (y) => {
      var I = Zn();
      L(() => fe(I, o())), w(y, I);
    }, m = (y) => {
      var I = Zn();
      L(() => fe(I, s())), w(y, I);
    };
    F(p, (y) => {
      i().isOpen ? y(h) : y(m, !1);
    });
  }
  _(v), wn(2), _(f), nt(f, (y) => O(u, y), () => n(u)), ne(f, (y, I) => He == null ? void 0 : He(y, I), () => d), L(
    (y) => {
      c = j(f, 1, "MenuToggle svelte-evish4", null, c, y), D(f, "aria-expanded", i().isOpen);
    },
    [
      () => ({ isOpen: i().isOpen })
    ]
  ), w(t, f), le(), a();
}
var K1 = /* @__PURE__ */ x('<div class="__menu_toggle_focus" aria-hidden="true" tabindex="-1"></div> <!>', 1), X1 = /* @__PURE__ */ x('<div class="shim svelte-h9sfi2" aria-hidden="true"></div> <div data-global-nav-mobile-v2=""><div class="left-slot svelte-h9sfi2"><div><!></div> <!></div> <div class="right-slot svelte-h9sfi2"><!></div> <!></div> <!>', 1);
function Q1(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(p, "$searchOptions", r), s = () => re(Qs, "$mobileNavIsSticky", r), o = () => re(kt, "$mobileNavStateStore", r), l = () => re(yn, "$mobileCtaSubnavMenuStateStore", r), u = g(e, "id", 3, ""), d = g(e, "homeLink", 3, void 0), f = g(e, "primaryNavItems", 19, () => []), c = g(e, "secondaryNavItems", 19, () => []), v = g(e, "cart", 3, void 0), p = la(), h = /* @__PURE__ */ Z(() => f().length > 0 || c().length > 0 || v() || i().isEnabled);
  let m = /* @__PURE__ */ Ue(void 0);
  var y = X1(), I = ye(y);
  let C;
  var T = H(I, 2);
  let N;
  var b = S(T), E = S(b);
  let k;
  var A = S(E);
  const P = /* @__PURE__ */ Z(() => {
    var ee;
    return (ee = d()) == null ? void 0 : ee.contentfulEntryId;
  }), M = /* @__PURE__ */ Z(() => {
    var ee, Ee;
    return (Ee = (ee = d()) == null ? void 0 : ee.props) == null ? void 0 : Ee.title;
  }), z = /* @__PURE__ */ Z(() => {
    var ee, Ee;
    return (Ee = (ee = d()) == null ? void 0 : ee.props) == null ? void 0 : Ee.logo;
  }), B = /* @__PURE__ */ Z(() => {
    var ee, Ee;
    return (Ee = (ee = d()) == null ? void 0 : ee.props) == null ? void 0 : Ee.url;
  });
  $s(A, {
    get id() {
      return n(P);
    },
    get title() {
      return n(M);
    },
    get logo() {
      return n(z);
    },
    get url() {
      return n(B);
    }
  }), _(E);
  var G = H(E, 2);
  const R = /* @__PURE__ */ Z(() => o().activeContentStack.length > 0);
  Xs(G, {
    get isActive() {
      return n(R);
    },
    get clickTouchFn() {
      return kt.pop;
    }
  }), _(b);
  var W = H(b, 2), K = S(W);
  {
    var Q = (ee) => {
      var Ee = K1(), Ie = H(ye(Ee), 2);
      J1(Ie, {}), w(ee, Ee);
    };
    F(K, (ee) => {
      n(h) && ee(Q);
    });
  }
  _(W);
  var V = H(W, 2);
  {
    var U = (ee) => {
      Y1(ee, {
        get primaryNavItems() {
          return f();
        },
        get secondaryNavItems() {
          return c();
        },
        get mobileNavHeight() {
          return n(m);
        },
        get cart() {
          return v();
        }
      });
    };
    F(V, (ee) => {
      n(h) && ee(U);
    });
  }
  _(T);
  var J = H(T, 2);
  const X = /* @__PURE__ */ Z(() => l().isOpen || o().isOpen);
  Ks(J, {
    get shouldLock() {
      return n(X);
    },
    get delayLockAfter() {
      return Ws;
    }
  }), L(
    (ee, Ee) => {
      C = Te(I, "", C, {
        height: s() ? `${n(m)}px` : "0px"
      }), N = j(T, 1, "MobileNav svelte-h9sfi2", null, N, ee), D(T, "data-entry-id", u()), k = j(E, 1, "home-link-wrapper svelte-h9sfi2", null, k, Ee);
    },
    [
      () => ({ globalNavIsSticky: s() }),
      () => ({ active: !o().isOpen })
    ]
  ), it(T, "offsetHeight", (ee) => O(m, ee)), w(t, y), le(), a();
}
var $1 = /* @__PURE__ */ x('<div class="GlobalNav" data-global-nav-v2=""><!> <!></div>');
function eg(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(kt, "$mobileNavStateStore", r), s = g(e, "id", 3, ""), o = g(e, "homeLink", 3, void 0), l = g(e, "primaryNavItems", 19, () => []), u = g(e, "secondaryNavItems", 19, () => []), d = g(e, "cart", 3, void 0), f = g(e, "primaryCtaButton", 3, void 0), c = g(e, "secondaryCtaButton", 3, void 0), v = g(e, "ctaButtonStyleV1", 3, !1);
  let p = /* @__PURE__ */ Ue(void 0);
  const h = /* @__PURE__ */ Z(() => n(p) === void 0 ? null : n(p) >= _d);
  ut(() => {
    n(h) && i().isOpen && kt.toggle();
  });
  var m = $1(), y = S(m);
  I1(y, {
    get id() {
      return s();
    },
    get homeLink() {
      return o();
    },
    get primaryNavItems() {
      return l();
    },
    get secondaryNavItems() {
      return u();
    },
    get cart() {
      return d();
    },
    get primaryCtaButton() {
      return f();
    },
    get secondaryCtaButton() {
      return c();
    },
    get ctaButtonStyleV1() {
      return v();
    }
  });
  var I = H(y, 2);
  Q1(I, {
    get id() {
      return s();
    },
    get homeLink() {
      return o();
    },
    get primaryNavItems() {
      return l();
    },
    get secondaryNavItems() {
      return u();
    },
    get cart() {
      return d();
    }
  }), _(m), L(() => {
    D(m, "data-component-type", Qa.MAIN_NAVIGATION), D(m, "data-nav-device-type", n(h) ? "Desktop" : "Mobile");
  }), Ya("innerWidth", (C) => O(p, C, !0)), w(t, m), le(), a();
}
var tg = /* @__PURE__ */ x('<div id="public-web-nav-v2-pwds-tokens" class="svelte-1s7hkwz"></div>');
function ng(t) {
  var e = tg();
  w(t, e);
}
function rg() {
  window.location.href = "#main-content";
}
var ag = /* @__PURE__ */ x('<a id="main-content-jump-link" class="MainContentJumpLink svelte-17bfpsx" href="#main-content">Skip to Content</a>');
function ig(t, e) {
  oe(e, !1);
  const r = qt();
  Me();
  var a = ag();
  a.__click = [rg], ne(a, (i, s) => Gt == null ? void 0 : Gt(i, s), () => ({
    id: "main-content-jump-link",
    title: "Skip to Content",
    url: "#main-content",
    trackFn: r
  })), w(t, a), le();
}
Wa(["click"]);
var sg = /* @__PURE__ */ x("<!> <!> <!>", 1), og = /* @__PURE__ */ x('<div data-nav-v2="" data-nav-svelte-5=""><!> <!></div> <!> <!>', 1);
function fg(t, e) {
  oe(e, !0);
  const [r, a] = ke(), i = () => re(Hs, "$flagsStore", r);
  let s = g(e, "dataJSON", 3, void 0), o = g(e, "imageSubnavJSON", 3, void 0), l = g(e, "ctaSubnavJSON", 15, void 0), u = g(e, "flagsJSON", 3, void 0), d = g(e, "darkMode", 3, !1), f = g(e, "themeColor", 3, "#006aff"), c = g(e, "themeFocusColor", 3, "#0055cc"), v = g(e, "zIndex", 3, 1e3), p = g(e, "cartCount", 15, 0), h = g(e, "currentUrl", 31, () => Tn(sa())), m = g(e, "loggedIn", 15, void 0);
  const y = od(p()), I = id(h()), C = ed(d()), T = sd(m()), N = Vn();
  nd(u()), Pd(i());
  const b = (pe) => p(pe), E = (pe) => h(pe), k = (pe) => l(pe);
  function A() {
    var pe, ze, _e, De;
    return fetch((De = (_e = (ze = (pe = n(M)) == null ? void 0 : pe.props) == null ? void 0 : ze.cart) == null ? void 0 : _e.props) == null ? void 0 : De.dataUrl).then((Re) => Re.json()).then((Re) => {
      p(Re.item_count);
    }).catch((Re) => {
      console.error("PublicWebNav: Unable to fetch cart data", Re);
    });
  }
  function P() {
    return fetch("/mp/status").then((pe) => (pe.status === 200 && m(!0), pe.json())).catch((pe) => {
      console.error("PublicWebNav: Unable to fetch logged in state", pe);
    });
  }
  const M = /* @__PURE__ */ Z(() => s() ? JSON.parse(s()) : {}), z = /* @__PURE__ */ Z(() => l() ? JSON.parse(l()) : void 0), B = /* @__PURE__ */ Z(() => o() ? JSON.parse(o()) : void 0), G = /* @__PURE__ */ Z(() => i().get("xms2-search-page-url")), R = /* @__PURE__ */ Z(() => {
    var pe;
    return n(z) && ((pe = n(z).componentName) == null ? void 0 : pe.endsWith("V2"));
  });
  ut(() => {
    tt(T, m());
  }), ut(() => {
    tt(y, p());
  }), ut(() => {
    tt(I, h());
  }), ut(() => {
    tt(C, d());
  }), ut(() => {
    var pe, ze, _e, De;
    (De = (_e = (ze = (pe = n(M)) == null ? void 0 : pe.props) == null ? void 0 : ze.cart) == null ? void 0 : _e.props) != null && De.dataUrl && typeof window < "u" && A();
  }), ut(() => {
    m() === void 0 && typeof window < "u" && P();
  });
  let W = /* @__PURE__ */ Ue(!1), K = /* @__PURE__ */ Ue(!1);
  _t(() => {
    N("mount", { meta: n(M) && n(M).meta }), O(K, !0);
    const pe = getComputedStyle(document.body).getPropertyValue("max-width"), ze = document.querySelector('[class^="shop-layout"]');
    O(W, pe && pe !== "none" || !!ze, !0);
  });
  var Q = og(), V = ye(Q);
  let U, J;
  var X = S(V);
  ig(X, {});
  var ee = H(X, 2);
  const Ee = /* @__PURE__ */ Z(() => {
    var pe;
    return {
      searchPageUrl: n(G),
      isEnabled: (pe = n(M).props) == null ? void 0 : pe.enableSearch
    };
  });
  v1(ee, {
    get options() {
      return n(Ee);
    },
    children: (pe, ze) => {
      var _e = sg(), De = ye(_e);
      const Re = /* @__PURE__ */ Z(() => {
        var ue;
        return (ue = n(M).props) == null ? void 0 : ue.homeLink;
      }), ge = /* @__PURE__ */ Z(() => {
        var ue;
        return (ue = n(M).props) == null ? void 0 : ue.primaryNavItems;
      }), q = /* @__PURE__ */ Z(() => {
        var ue;
        return (ue = n(M).props) == null ? void 0 : ue.secondaryNavItems;
      }), me = /* @__PURE__ */ Z(() => {
        var ue;
        return (ue = n(M).props) == null ? void 0 : ue.cart;
      }), Ne = /* @__PURE__ */ Z(() => {
        var ue;
        return (ue = n(M).props) == null ? void 0 : ue.cta;
      }), Ce = /* @__PURE__ */ Z(() => {
        var ue;
        return (ue = n(M).props) == null ? void 0 : ue.secondaryCta;
      }), Pe = /* @__PURE__ */ Z(() => n(z) && !n(R));
      eg(De, {
        get id() {
          return n(M).contentfulEntryId;
        },
        get homeLink() {
          return n(Re);
        },
        get primaryNavItems() {
          return n(ge);
        },
        get secondaryNavItems() {
          return n(q);
        },
        get cart() {
          return n(me);
        },
        get primaryCtaButton() {
          return n(Ne);
        },
        get secondaryCtaButton() {
          return n(Ce);
        },
        get ctaButtonStyleV1() {
          return n(Pe);
        }
      });
      var we = H(De, 2);
      {
        var ie = (ue) => {
          Us(ue, {
            get navItems() {
              return n(B).navItems;
            }
          });
        };
        F(we, (ue) => {
          n(B) && ue(ie);
        });
      }
      var $ = H(we, 2);
      {
        var te = (ue) => {
          var ce = Ze(), Se = ye(ce);
          {
            var he = (se) => {
              xf(se, {
                get id() {
                  return n(z).contentfulEntryId;
                },
                get title() {
                  return n(z).props.title;
                },
                get navItems() {
                  return n(z).props.navItems;
                },
                get primaryCtaButton() {
                  return n(z).props.cta;
                },
                get secondaryCtaButton() {
                  return n(z).props.secondaryCta;
                },
                get onlyShowCtaWhenSticky() {
                  return n(z).props.onlyShowCtaWhenSticky;
                },
                get showCtaOnCtaPage() {
                  return n(z).props.showCtaOnCtaPage;
                },
                get disableStickyBehavior() {
                  return n(z).props.disableStickyBehavior;
                },
                get hiddenUntilScrolled() {
                  return n(z).props.hiddenUntilScrolled;
                },
                get reverseDesktopCtaButtons() {
                  return n(z).props.reverseDesktopCtaButtons;
                },
                get disableIconCtaOnMobile() {
                  return n(z).props.disableIconCtaOnMobile;
                }
              });
            }, ve = (se) => {
              Fs(se, {
                get data() {
                  return n(z);
                }
              });
            };
            F(Se, (se) => {
              n(R) ? se(he) : se(ve, !1);
            });
          }
          w(ue, ce);
        };
        F($, (ue) => {
          n(z) && ue(te);
        });
      }
      w(pe, _e);
    },
    $$slots: { default: !0 }
  }), _(V);
  var Ie = H(V, 2);
  ud(Ie);
  var Ae = H(Ie, 2);
  ng(Ae), L(
    (pe) => {
      U = j(V, 1, "PublicWebNavV2 svelte-29sz9r", null, U, pe), D(V, "data-mounted", n(K)), J = Te(V, "", J, {
        "--color-theme": f(),
        "--color-theme-focus": c(),
        "z-index": v(),
        "--dynamic-gutter": n(W) ? "0px" : "calc((100vw - var(--body-width-max) - var(--space-30)) / 2)"
      });
    },
    [() => ({ darkMode: d() })]
  ), w(t, Q);
  var je = le({
    setCartCount: b,
    setCurrentUrl: E,
    setCtaSubnavJSON: k,
    fetchCartData: A,
    fetchLoggedInState: P
  });
  return a(), je;
}
var lg = /* @__PURE__ */ Cn('<svg class="Icon svelte-ecgruy" width="24" height="24" viewBox="0 0 24 24" fill="black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 17.4998C12.07 17.4998 13.52 16.9698 14.68 16.0998L18.79 20.2098L20.2 18.7998L16.09 14.6898C16.97 13.5198 17.49 12.0798 17.49 10.5098C17.49 6.64983 14.35 3.50983 10.49 3.50983C6.62999 3.50983 3.48999 6.64983 3.48999 10.5098C3.48999 14.3698 6.63999 17.4998 10.5 17.4998ZM10.5 5.49983C13.26 5.49983 15.5 7.73983 15.5 10.4998C15.5 13.2598 13.26 15.4998 10.5 15.4998C7.73999 15.4998 5.49999 13.2598 5.49999 10.4998C5.49999 7.73983 7.73999 5.49983 10.5 5.49983Z" fill="black"></path></svg>');
function gg(t) {
  var e = lg();
  w(t, e);
}
export {
  dg as PublicWebNav,
  fg as PublicWebNavV2,
  to as PublicWebSearchBar,
  gg as PublicWebSearchIcon,
  cg as hydrate,
  sl as mount,
  vg as unmount
};
